// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

.build-with-bootstrap *,
.build-with-bootstrap *::before,
.build-with-bootstrap *::after {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: no-preference) {
  .build-with-bootstrap :root {
    scroll-behavior: smooth;
  }
}
.build-with-bootstrap body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.build-with-bootstrap hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}
.build-with-bootstrap h6, .build-with-bootstrap .h6, .build-with-bootstrap h5, .build-with-bootstrap .h5, .build-with-bootstrap h4, .build-with-bootstrap .h4, .build-with-bootstrap h3, .build-with-bootstrap .h3, .build-with-bootstrap h2, .build-with-bootstrap .h2, .build-with-bootstrap h1, .build-with-bootstrap .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}
.build-with-bootstrap h1, .build-with-bootstrap .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap h1, .build-with-bootstrap .h1 {
    font-size: 2.5rem;
  }
}
.build-with-bootstrap h2, .build-with-bootstrap .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap h2, .build-with-bootstrap .h2 {
    font-size: 2rem;
  }
}
.build-with-bootstrap h3, .build-with-bootstrap .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap h3, .build-with-bootstrap .h3 {
    font-size: 1.75rem;
  }
}
.build-with-bootstrap h4, .build-with-bootstrap .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap h4, .build-with-bootstrap .h4 {
    font-size: 1.5rem;
  }
}
.build-with-bootstrap h5, .build-with-bootstrap .h5 {
  font-size: 1.25rem;
}
.build-with-bootstrap h6, .build-with-bootstrap .h6 {
  font-size: 1rem;
}
.build-with-bootstrap p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.build-with-bootstrap abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}
.build-with-bootstrap address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
.build-with-bootstrap ol,
.build-with-bootstrap ul {
  padding-left: 2rem;
}
.build-with-bootstrap ol,
.build-with-bootstrap ul,
.build-with-bootstrap dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
.build-with-bootstrap ol ol,
.build-with-bootstrap ul ul,
.build-with-bootstrap ol ul,
.build-with-bootstrap ul ol {
  margin-bottom: 0;
}
.build-with-bootstrap dt {
  font-weight: 700;
}
.build-with-bootstrap dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.build-with-bootstrap blockquote {
  margin: 0 0 1rem;
}
.build-with-bootstrap b,
.build-with-bootstrap strong {
  font-weight: bolder;
}
.build-with-bootstrap small, .build-with-bootstrap .small {
  font-size: 0.875em;
}
.build-with-bootstrap mark, .build-with-bootstrap .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}
.build-with-bootstrap sub,
.build-with-bootstrap sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
.build-with-bootstrap sub {
  bottom: -0.25em;
}
.build-with-bootstrap sup {
  top: -0.5em;
}
.build-with-bootstrap a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
.build-with-bootstrap a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}
.build-with-bootstrap a:not([href]):not([class]), .build-with-bootstrap a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
.build-with-bootstrap pre,
.build-with-bootstrap code,
.build-with-bootstrap kbd,
.build-with-bootstrap samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}
.build-with-bootstrap pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
.build-with-bootstrap pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
.build-with-bootstrap code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > .build-with-bootstrap code {
  color: inherit;
}
.build-with-bootstrap kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
.build-with-bootstrap kbd kbd {
  padding: 0;
  font-size: 1em;
}
.build-with-bootstrap figure {
  margin: 0 0 1rem;
}
.build-with-bootstrap img,
.build-with-bootstrap svg {
  vertical-align: middle;
}
.build-with-bootstrap table {
  caption-side: bottom;
  border-collapse: collapse;
}
.build-with-bootstrap caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}
.build-with-bootstrap th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
.build-with-bootstrap thead,
.build-with-bootstrap tbody,
.build-with-bootstrap tfoot,
.build-with-bootstrap tr,
.build-with-bootstrap td,
.build-with-bootstrap th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
.build-with-bootstrap label {
  display: inline-block;
}
.build-with-bootstrap button {
  border-radius: 0;
}
.build-with-bootstrap button:focus:not(:focus-visible) {
  outline: 0;
}
.build-with-bootstrap input,
.build-with-bootstrap button,
.build-with-bootstrap select,
.build-with-bootstrap optgroup,
.build-with-bootstrap textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.build-with-bootstrap button,
.build-with-bootstrap select {
  text-transform: none;
}
.build-with-bootstrap [role=button] {
  cursor: pointer;
}
.build-with-bootstrap select {
  word-wrap: normal;
}
.build-with-bootstrap select:disabled {
  opacity: 1;
}
.build-with-bootstrap [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
.build-with-bootstrap button,
.build-with-bootstrap [type=button],
.build-with-bootstrap [type=reset],
.build-with-bootstrap [type=submit] {
  -webkit-appearance: button;
}
.build-with-bootstrap button:not(:disabled),
.build-with-bootstrap [type=button]:not(:disabled),
.build-with-bootstrap [type=reset]:not(:disabled),
.build-with-bootstrap [type=submit]:not(:disabled) {
  cursor: pointer;
}
.build-with-bootstrap ::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
.build-with-bootstrap textarea {
  resize: vertical;
}
.build-with-bootstrap fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.build-with-bootstrap legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap legend {
    font-size: 1.5rem;
  }
}
.build-with-bootstrap legend + * {
  clear: left;
}
.build-with-bootstrap ::-webkit-datetime-edit-fields-wrapper,
.build-with-bootstrap ::-webkit-datetime-edit-text,
.build-with-bootstrap ::-webkit-datetime-edit-minute,
.build-with-bootstrap ::-webkit-datetime-edit-hour-field,
.build-with-bootstrap ::-webkit-datetime-edit-day-field,
.build-with-bootstrap ::-webkit-datetime-edit-month-field,
.build-with-bootstrap ::-webkit-datetime-edit-year-field {
  padding: 0;
}
.build-with-bootstrap ::-webkit-inner-spin-button {
  height: auto;
}
.build-with-bootstrap [type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
.build-with-bootstrap [type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}
.build-with-bootstrap {
  /* rtl:raw:
  [type="tel"],
  [type="url"],
  [type="email"],
  [type="number"] {
    direction: ltr;
  }
  */
}
.build-with-bootstrap ::-webkit-search-decoration {
  -webkit-appearance: none;
}
.build-with-bootstrap ::-webkit-color-swatch-wrapper {
  padding: 0;
}
.build-with-bootstrap ::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
.build-with-bootstrap output {
  display: inline-block;
}
.build-with-bootstrap iframe {
  border: 0;
}
.build-with-bootstrap summary {
  display: list-item;
  cursor: pointer;
}
.build-with-bootstrap progress {
  vertical-align: baseline;
}
.build-with-bootstrap [hidden] {
  display: none !important;
}
.build-with-bootstrap .lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.build-with-bootstrap .display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-1 {
    font-size: 5rem;
  }
}
.build-with-bootstrap .display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-2 {
    font-size: 4.5rem;
  }
}
.build-with-bootstrap .display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-3 {
    font-size: 4rem;
  }
}
.build-with-bootstrap .display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-4 {
    font-size: 3.5rem;
  }
}
.build-with-bootstrap .display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-5 {
    font-size: 3rem;
  }
}
.build-with-bootstrap .display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .build-with-bootstrap .display-6 {
    font-size: 2.5rem;
  }
}
.build-with-bootstrap .list-unstyled {
  padding-left: 0;
  list-style: none;
}
.build-with-bootstrap .list-inline {
  padding-left: 0;
  list-style: none;
}
.build-with-bootstrap .list-inline-item {
  display: inline-block;
}
.build-with-bootstrap .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.build-with-bootstrap .initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}
.build-with-bootstrap .blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.build-with-bootstrap .blockquote > :last-child {
  margin-bottom: 0;
}
.build-with-bootstrap .blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.build-with-bootstrap .blockquote-footer::before {
  content: "— ";
}
.build-with-bootstrap .img-fluid {
  max-width: 100%;
  height: auto;
}
.build-with-bootstrap .img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}
.build-with-bootstrap .figure {
  display: inline-block;
}
.build-with-bootstrap .figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
.build-with-bootstrap .figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.build-with-bootstrap .container,
.build-with-bootstrap .container-fluid,
.build-with-bootstrap .container-xxl,
.build-with-bootstrap .container-xl,
.build-with-bootstrap .container-lg,
.build-with-bootstrap .container-md,
.build-with-bootstrap .container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .build-with-bootstrap .container-sm, .build-with-bootstrap .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .container-md, .build-with-bootstrap .container-sm, .build-with-bootstrap .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .container-lg, .build-with-bootstrap .container-md, .build-with-bootstrap .container-sm, .build-with-bootstrap .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .container-xl, .build-with-bootstrap .container-lg, .build-with-bootstrap .container-md, .build-with-bootstrap .container-sm, .build-with-bootstrap .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .container-xxl, .build-with-bootstrap .container-xl, .build-with-bootstrap .container-lg, .build-with-bootstrap .container-md, .build-with-bootstrap .container-sm, .build-with-bootstrap .container {
    max-width: 1320px;
  }
}
.build-with-bootstrap :root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}
.build-with-bootstrap .row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.build-with-bootstrap .row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
.build-with-bootstrap .col {
  flex: 1 0 0;
}
.build-with-bootstrap .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.build-with-bootstrap .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.build-with-bootstrap .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.build-with-bootstrap .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.build-with-bootstrap .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.build-with-bootstrap .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.build-with-bootstrap .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.build-with-bootstrap .col-auto {
  flex: 0 0 auto;
  width: auto;
}
.build-with-bootstrap .col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
.build-with-bootstrap .col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.build-with-bootstrap .col-3 {
  flex: 0 0 auto;
  width: 25%;
}
.build-with-bootstrap .col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.build-with-bootstrap .col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
.build-with-bootstrap .col-6 {
  flex: 0 0 auto;
  width: 50%;
}
.build-with-bootstrap .col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
.build-with-bootstrap .col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.build-with-bootstrap .col-9 {
  flex: 0 0 auto;
  width: 75%;
}
.build-with-bootstrap .col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
.build-with-bootstrap .col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
.build-with-bootstrap .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
.build-with-bootstrap .offset-1 {
  margin-left: 8.33333333%;
}
.build-with-bootstrap .offset-2 {
  margin-left: 16.66666667%;
}
.build-with-bootstrap .offset-3 {
  margin-left: 25%;
}
.build-with-bootstrap .offset-4 {
  margin-left: 33.33333333%;
}
.build-with-bootstrap .offset-5 {
  margin-left: 41.66666667%;
}
.build-with-bootstrap .offset-6 {
  margin-left: 50%;
}
.build-with-bootstrap .offset-7 {
  margin-left: 58.33333333%;
}
.build-with-bootstrap .offset-8 {
  margin-left: 66.66666667%;
}
.build-with-bootstrap .offset-9 {
  margin-left: 75%;
}
.build-with-bootstrap .offset-10 {
  margin-left: 83.33333333%;
}
.build-with-bootstrap .offset-11 {
  margin-left: 91.66666667%;
}
.build-with-bootstrap .g-0,
.build-with-bootstrap .gx-0 {
  --bs-gutter-x: 0;
}
.build-with-bootstrap .g-0,
.build-with-bootstrap .gy-0 {
  --bs-gutter-y: 0;
}
.build-with-bootstrap .g-1,
.build-with-bootstrap .gx-1 {
  --bs-gutter-x: 0.25rem;
}
.build-with-bootstrap .g-1,
.build-with-bootstrap .gy-1 {
  --bs-gutter-y: 0.25rem;
}
.build-with-bootstrap .g-2,
.build-with-bootstrap .gx-2 {
  --bs-gutter-x: 0.5rem;
}
.build-with-bootstrap .g-2,
.build-with-bootstrap .gy-2 {
  --bs-gutter-y: 0.5rem;
}
.build-with-bootstrap .g-3,
.build-with-bootstrap .gx-3 {
  --bs-gutter-x: 1rem;
}
.build-with-bootstrap .g-3,
.build-with-bootstrap .gy-3 {
  --bs-gutter-y: 1rem;
}
.build-with-bootstrap .g-4,
.build-with-bootstrap .gx-4 {
  --bs-gutter-x: 1.5rem;
}
.build-with-bootstrap .g-4,
.build-with-bootstrap .gy-4 {
  --bs-gutter-y: 1.5rem;
}
.build-with-bootstrap .g-5,
.build-with-bootstrap .gx-5 {
  --bs-gutter-x: 3rem;
}
.build-with-bootstrap .g-5,
.build-with-bootstrap .gy-5 {
  --bs-gutter-y: 3rem;
}
@media (min-width: 576px) {
  .build-with-bootstrap .col-sm {
    flex: 1 0 0;
  }
  .build-with-bootstrap .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .build-with-bootstrap .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .build-with-bootstrap .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .build-with-bootstrap .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .build-with-bootstrap .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .build-with-bootstrap .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .build-with-bootstrap .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .build-with-bootstrap .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .build-with-bootstrap .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .offset-sm-0 {
    margin-left: 0;
  }
  .build-with-bootstrap .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .build-with-bootstrap .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .build-with-bootstrap .offset-sm-3 {
    margin-left: 25%;
  }
  .build-with-bootstrap .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .build-with-bootstrap .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .build-with-bootstrap .offset-sm-6 {
    margin-left: 50%;
  }
  .build-with-bootstrap .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .build-with-bootstrap .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .build-with-bootstrap .offset-sm-9 {
    margin-left: 75%;
  }
  .build-with-bootstrap .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .build-with-bootstrap .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .build-with-bootstrap .g-sm-0,
  .build-with-bootstrap .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .build-with-bootstrap .g-sm-0,
  .build-with-bootstrap .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .build-with-bootstrap .g-sm-1,
  .build-with-bootstrap .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .build-with-bootstrap .g-sm-1,
  .build-with-bootstrap .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .build-with-bootstrap .g-sm-2,
  .build-with-bootstrap .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .build-with-bootstrap .g-sm-2,
  .build-with-bootstrap .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .build-with-bootstrap .g-sm-3,
  .build-with-bootstrap .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .build-with-bootstrap .g-sm-3,
  .build-with-bootstrap .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .build-with-bootstrap .g-sm-4,
  .build-with-bootstrap .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .build-with-bootstrap .g-sm-4,
  .build-with-bootstrap .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .build-with-bootstrap .g-sm-5,
  .build-with-bootstrap .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .build-with-bootstrap .g-sm-5,
  .build-with-bootstrap .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .col-md {
    flex: 1 0 0;
  }
  .build-with-bootstrap .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .build-with-bootstrap .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .build-with-bootstrap .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .build-with-bootstrap .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .build-with-bootstrap .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .build-with-bootstrap .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .build-with-bootstrap .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .build-with-bootstrap .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .build-with-bootstrap .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .offset-md-0 {
    margin-left: 0;
  }
  .build-with-bootstrap .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .build-with-bootstrap .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .build-with-bootstrap .offset-md-3 {
    margin-left: 25%;
  }
  .build-with-bootstrap .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .build-with-bootstrap .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .build-with-bootstrap .offset-md-6 {
    margin-left: 50%;
  }
  .build-with-bootstrap .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .build-with-bootstrap .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .build-with-bootstrap .offset-md-9 {
    margin-left: 75%;
  }
  .build-with-bootstrap .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .build-with-bootstrap .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .build-with-bootstrap .g-md-0,
  .build-with-bootstrap .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .build-with-bootstrap .g-md-0,
  .build-with-bootstrap .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .build-with-bootstrap .g-md-1,
  .build-with-bootstrap .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .build-with-bootstrap .g-md-1,
  .build-with-bootstrap .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .build-with-bootstrap .g-md-2,
  .build-with-bootstrap .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .build-with-bootstrap .g-md-2,
  .build-with-bootstrap .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .build-with-bootstrap .g-md-3,
  .build-with-bootstrap .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .build-with-bootstrap .g-md-3,
  .build-with-bootstrap .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .build-with-bootstrap .g-md-4,
  .build-with-bootstrap .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .build-with-bootstrap .g-md-4,
  .build-with-bootstrap .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .build-with-bootstrap .g-md-5,
  .build-with-bootstrap .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .build-with-bootstrap .g-md-5,
  .build-with-bootstrap .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .col-lg {
    flex: 1 0 0;
  }
  .build-with-bootstrap .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .build-with-bootstrap .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .build-with-bootstrap .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .build-with-bootstrap .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .build-with-bootstrap .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .build-with-bootstrap .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .build-with-bootstrap .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .build-with-bootstrap .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .build-with-bootstrap .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .offset-lg-0 {
    margin-left: 0;
  }
  .build-with-bootstrap .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .build-with-bootstrap .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .build-with-bootstrap .offset-lg-3 {
    margin-left: 25%;
  }
  .build-with-bootstrap .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .build-with-bootstrap .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .build-with-bootstrap .offset-lg-6 {
    margin-left: 50%;
  }
  .build-with-bootstrap .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .build-with-bootstrap .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .build-with-bootstrap .offset-lg-9 {
    margin-left: 75%;
  }
  .build-with-bootstrap .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .build-with-bootstrap .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .build-with-bootstrap .g-lg-0,
  .build-with-bootstrap .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .build-with-bootstrap .g-lg-0,
  .build-with-bootstrap .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .build-with-bootstrap .g-lg-1,
  .build-with-bootstrap .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .build-with-bootstrap .g-lg-1,
  .build-with-bootstrap .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .build-with-bootstrap .g-lg-2,
  .build-with-bootstrap .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .build-with-bootstrap .g-lg-2,
  .build-with-bootstrap .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .build-with-bootstrap .g-lg-3,
  .build-with-bootstrap .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .build-with-bootstrap .g-lg-3,
  .build-with-bootstrap .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .build-with-bootstrap .g-lg-4,
  .build-with-bootstrap .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .build-with-bootstrap .g-lg-4,
  .build-with-bootstrap .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .build-with-bootstrap .g-lg-5,
  .build-with-bootstrap .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .build-with-bootstrap .g-lg-5,
  .build-with-bootstrap .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .col-xl {
    flex: 1 0 0;
  }
  .build-with-bootstrap .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .build-with-bootstrap .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .build-with-bootstrap .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .build-with-bootstrap .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .build-with-bootstrap .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .build-with-bootstrap .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .build-with-bootstrap .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .build-with-bootstrap .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .build-with-bootstrap .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .offset-xl-0 {
    margin-left: 0;
  }
  .build-with-bootstrap .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .build-with-bootstrap .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .build-with-bootstrap .offset-xl-3 {
    margin-left: 25%;
  }
  .build-with-bootstrap .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .build-with-bootstrap .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .build-with-bootstrap .offset-xl-6 {
    margin-left: 50%;
  }
  .build-with-bootstrap .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .build-with-bootstrap .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .build-with-bootstrap .offset-xl-9 {
    margin-left: 75%;
  }
  .build-with-bootstrap .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .build-with-bootstrap .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .build-with-bootstrap .g-xl-0,
  .build-with-bootstrap .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .build-with-bootstrap .g-xl-0,
  .build-with-bootstrap .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .build-with-bootstrap .g-xl-1,
  .build-with-bootstrap .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .build-with-bootstrap .g-xl-1,
  .build-with-bootstrap .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .build-with-bootstrap .g-xl-2,
  .build-with-bootstrap .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .build-with-bootstrap .g-xl-2,
  .build-with-bootstrap .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .build-with-bootstrap .g-xl-3,
  .build-with-bootstrap .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .build-with-bootstrap .g-xl-3,
  .build-with-bootstrap .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .build-with-bootstrap .g-xl-4,
  .build-with-bootstrap .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .build-with-bootstrap .g-xl-4,
  .build-with-bootstrap .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .build-with-bootstrap .g-xl-5,
  .build-with-bootstrap .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .build-with-bootstrap .g-xl-5,
  .build-with-bootstrap .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .col-xxl {
    flex: 1 0 0;
  }
  .build-with-bootstrap .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .build-with-bootstrap .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .build-with-bootstrap .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .build-with-bootstrap .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .build-with-bootstrap .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .build-with-bootstrap .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .build-with-bootstrap .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .build-with-bootstrap .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .build-with-bootstrap .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .build-with-bootstrap .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .build-with-bootstrap .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .build-with-bootstrap .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .build-with-bootstrap .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .build-with-bootstrap .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .build-with-bootstrap .offset-xxl-0 {
    margin-left: 0;
  }
  .build-with-bootstrap .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .build-with-bootstrap .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .build-with-bootstrap .offset-xxl-3 {
    margin-left: 25%;
  }
  .build-with-bootstrap .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .build-with-bootstrap .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .build-with-bootstrap .offset-xxl-6 {
    margin-left: 50%;
  }
  .build-with-bootstrap .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .build-with-bootstrap .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .build-with-bootstrap .offset-xxl-9 {
    margin-left: 75%;
  }
  .build-with-bootstrap .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .build-with-bootstrap .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .build-with-bootstrap .g-xxl-0,
  .build-with-bootstrap .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .build-with-bootstrap .g-xxl-0,
  .build-with-bootstrap .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .build-with-bootstrap .g-xxl-1,
  .build-with-bootstrap .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .build-with-bootstrap .g-xxl-1,
  .build-with-bootstrap .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .build-with-bootstrap .g-xxl-2,
  .build-with-bootstrap .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .build-with-bootstrap .g-xxl-2,
  .build-with-bootstrap .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .build-with-bootstrap .g-xxl-3,
  .build-with-bootstrap .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .build-with-bootstrap .g-xxl-3,
  .build-with-bootstrap .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .build-with-bootstrap .g-xxl-4,
  .build-with-bootstrap .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .build-with-bootstrap .g-xxl-4,
  .build-with-bootstrap .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .build-with-bootstrap .g-xxl-5,
  .build-with-bootstrap .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .build-with-bootstrap .g-xxl-5,
  .build-with-bootstrap .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.build-with-bootstrap .table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.build-with-bootstrap .table > tbody {
  vertical-align: inherit;
}
.build-with-bootstrap .table > thead {
  vertical-align: bottom;
}
.build-with-bootstrap .table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}
.build-with-bootstrap .caption-top {
  caption-side: top;
}
.build-with-bootstrap .table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
.build-with-bootstrap .table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.build-with-bootstrap .table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}
.build-with-bootstrap .table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.build-with-bootstrap .table-borderless > :not(:first-child) {
  border-top-width: 0;
}
.build-with-bootstrap .table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.build-with-bootstrap .table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.build-with-bootstrap .table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}
.build-with-bootstrap .table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}
.build-with-bootstrap .table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.build-with-bootstrap .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 575.98px) {
  .build-with-bootstrap .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .build-with-bootstrap .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .build-with-bootstrap .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .build-with-bootstrap .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .build-with-bootstrap .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.build-with-bootstrap .form-label {
  margin-bottom: 0.5rem;
}
.build-with-bootstrap .col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.build-with-bootstrap .col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}
.build-with-bootstrap .col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}
.build-with-bootstrap .form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.build-with-bootstrap .form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-control {
    transition: none;
  }
}
.build-with-bootstrap .form-control[type=file] {
  overflow: hidden;
}
.build-with-bootstrap .form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.build-with-bootstrap .form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.build-with-bootstrap .form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.build-with-bootstrap .form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.build-with-bootstrap .form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.build-with-bootstrap .form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-control::file-selector-button {
    transition: none;
  }
}
.build-with-bootstrap .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}
.build-with-bootstrap .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.build-with-bootstrap .form-control-plaintext:focus {
  outline: 0;
}
.build-with-bootstrap .form-control-plaintext.form-control-sm, .build-with-bootstrap .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.build-with-bootstrap .form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.build-with-bootstrap .form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.build-with-bootstrap .form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.build-with-bootstrap .form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
.build-with-bootstrap textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
.build-with-bootstrap textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.build-with-bootstrap textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.build-with-bootstrap .form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.build-with-bootstrap .form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.build-with-bootstrap .form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.build-with-bootstrap .form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.build-with-bootstrap .form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.build-with-bootstrap .form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.build-with-bootstrap .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-select {
    transition: none;
  }
}
.build-with-bootstrap .form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .form-select[multiple], .build-with-bootstrap .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.build-with-bootstrap .form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.build-with-bootstrap .form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}
.build-with-bootstrap .form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.build-with-bootstrap .form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.build-with-bootstrap [data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.build-with-bootstrap .form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.build-with-bootstrap .form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
.build-with-bootstrap .form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.build-with-bootstrap .form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}
.build-with-bootstrap .form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.build-with-bootstrap .form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.build-with-bootstrap .form-check-input[type=radio] {
  border-radius: 50%;
}
.build-with-bootstrap .form-check-input:active {
  filter: brightness(90%);
}
.build-with-bootstrap .form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.build-with-bootstrap .form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.build-with-bootstrap .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.build-with-bootstrap .form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.build-with-bootstrap .form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.build-with-bootstrap .form-check-input[disabled] ~ .form-check-label, .build-with-bootstrap .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
.build-with-bootstrap .form-switch {
  padding-left: 2.5em;
}
.build-with-bootstrap .form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-switch .form-check-input {
    transition: none;
  }
}
.build-with-bootstrap .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.build-with-bootstrap .form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.build-with-bootstrap .form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.build-with-bootstrap .form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}
.build-with-bootstrap .form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.build-with-bootstrap .btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.build-with-bootstrap .btn-check[disabled] + .btn, .build-with-bootstrap .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
.build-with-bootstrap [data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.build-with-bootstrap .form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.build-with-bootstrap .form-range:focus {
  outline: 0;
}
.build-with-bootstrap .form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .form-range::-moz-focus-outer {
  border: 0;
}
.build-with-bootstrap .form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.build-with-bootstrap .form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.build-with-bootstrap .form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.build-with-bootstrap .form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-range::-moz-range-thumb {
    transition: none;
  }
}
.build-with-bootstrap .form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.build-with-bootstrap .form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.build-with-bootstrap .form-range:disabled {
  pointer-events: none;
}
.build-with-bootstrap .form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.build-with-bootstrap .form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}
.build-with-bootstrap .form-floating {
  position: relative;
}
.build-with-bootstrap .form-floating > .form-control,
.build-with-bootstrap .form-floating > .form-control-plaintext,
.build-with-bootstrap .form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.build-with-bootstrap .form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .form-floating > label {
    transition: none;
  }
}
.build-with-bootstrap .form-floating > .form-control,
.build-with-bootstrap .form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.build-with-bootstrap .form-floating > .form-control::placeholder,
.build-with-bootstrap .form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.build-with-bootstrap .form-floating > .form-control:focus, .build-with-bootstrap .form-floating > .form-control:not(:placeholder-shown),
.build-with-bootstrap .form-floating > .form-control-plaintext:focus,
.build-with-bootstrap .form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.build-with-bootstrap .form-floating > .form-control:-webkit-autofill,
.build-with-bootstrap .form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.build-with-bootstrap .form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.build-with-bootstrap .form-floating > .form-control:focus ~ label,
.build-with-bootstrap .form-floating > .form-control:not(:placeholder-shown) ~ label,
.build-with-bootstrap .form-floating > .form-control-plaintext ~ label,
.build-with-bootstrap .form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.build-with-bootstrap .form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.build-with-bootstrap .form-floating > textarea:focus ~ label::after,
.build-with-bootstrap .form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.build-with-bootstrap .form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.build-with-bootstrap .form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.build-with-bootstrap .form-floating > :disabled ~ label,
.build-with-bootstrap .form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.build-with-bootstrap .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.build-with-bootstrap .input-group > .form-control,
.build-with-bootstrap .input-group > .form-select,
.build-with-bootstrap .input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.build-with-bootstrap .input-group > .form-control:focus,
.build-with-bootstrap .input-group > .form-select:focus,
.build-with-bootstrap .input-group > .form-floating:focus-within {
  z-index: 5;
}
.build-with-bootstrap .input-group .btn {
  position: relative;
  z-index: 2;
}
.build-with-bootstrap .input-group .btn:focus {
  z-index: 5;
}
.build-with-bootstrap .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}
.build-with-bootstrap .input-group-lg > .form-control,
.build-with-bootstrap .input-group-lg > .form-select,
.build-with-bootstrap .input-group-lg > .input-group-text,
.build-with-bootstrap .input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.build-with-bootstrap .input-group-sm > .form-control,
.build-with-bootstrap .input-group-sm > .form-select,
.build-with-bootstrap .input-group-sm > .input-group-text,
.build-with-bootstrap .input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.build-with-bootstrap .input-group-lg > .form-select,
.build-with-bootstrap .input-group-sm > .form-select {
  padding-right: 3rem;
}
.build-with-bootstrap .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.build-with-bootstrap .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.build-with-bootstrap .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.build-with-bootstrap .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.build-with-bootstrap .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.build-with-bootstrap .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.build-with-bootstrap .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.build-with-bootstrap .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.build-with-bootstrap .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.build-with-bootstrap .input-group > .form-floating:not(:first-child) > .form-control,
.build-with-bootstrap .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.build-with-bootstrap .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}
.build-with-bootstrap .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}
.was-validated .build-with-bootstrap:valid ~ .valid-feedback,
.was-validated .build-with-bootstrap:valid ~ .valid-tooltip, .build-with-bootstrap.is-valid ~ .valid-feedback,
.build-with-bootstrap.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .build-with-bootstrap .form-control:valid, .build-with-bootstrap .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .build-with-bootstrap .form-control:valid:focus, .build-with-bootstrap .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .build-with-bootstrap textarea.form-control:valid, .build-with-bootstrap textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .build-with-bootstrap .form-select:valid, .build-with-bootstrap .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .build-with-bootstrap .form-select:valid:not([multiple]):not([size]), .was-validated .build-with-bootstrap .form-select:valid:not([multiple])[size="1"], .build-with-bootstrap .form-select.is-valid:not([multiple]):not([size]), .build-with-bootstrap .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .build-with-bootstrap .form-select:valid:focus, .build-with-bootstrap .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .build-with-bootstrap .form-control-color:valid, .build-with-bootstrap .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .build-with-bootstrap .form-check-input:valid, .build-with-bootstrap .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .build-with-bootstrap .form-check-input:valid:checked, .build-with-bootstrap .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .build-with-bootstrap .form-check-input:valid:focus, .build-with-bootstrap .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .build-with-bootstrap .form-check-input:valid ~ .form-check-label, .build-with-bootstrap .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}
.build-with-bootstrap .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated .build-with-bootstrap .input-group > .form-control:not(:focus):valid, .build-with-bootstrap .input-group > .form-control:not(:focus).is-valid,
.was-validated .build-with-bootstrap .input-group > .form-select:not(:focus):valid,
.build-with-bootstrap .input-group > .form-select:not(:focus).is-valid,
.was-validated .build-with-bootstrap .input-group > .form-floating:not(:focus-within):valid,
.build-with-bootstrap .input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
.build-with-bootstrap .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}
.build-with-bootstrap .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}
.was-validated .build-with-bootstrap:invalid ~ .invalid-feedback,
.was-validated .build-with-bootstrap:invalid ~ .invalid-tooltip, .build-with-bootstrap.is-invalid ~ .invalid-feedback,
.build-with-bootstrap.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .build-with-bootstrap .form-control:invalid, .build-with-bootstrap .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .build-with-bootstrap .form-control:invalid:focus, .build-with-bootstrap .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .build-with-bootstrap textarea.form-control:invalid, .build-with-bootstrap textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .build-with-bootstrap .form-select:invalid, .build-with-bootstrap .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .build-with-bootstrap .form-select:invalid:not([multiple]):not([size]), .was-validated .build-with-bootstrap .form-select:invalid:not([multiple])[size="1"], .build-with-bootstrap .form-select.is-invalid:not([multiple]):not([size]), .build-with-bootstrap .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .build-with-bootstrap .form-select:invalid:focus, .build-with-bootstrap .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .build-with-bootstrap .form-control-color:invalid, .build-with-bootstrap .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .build-with-bootstrap .form-check-input:invalid, .build-with-bootstrap .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .build-with-bootstrap .form-check-input:invalid:checked, .build-with-bootstrap .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .build-with-bootstrap .form-check-input:invalid:focus, .build-with-bootstrap .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .build-with-bootstrap .form-check-input:invalid ~ .form-check-label, .build-with-bootstrap .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}
.build-with-bootstrap .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated .build-with-bootstrap .input-group > .form-control:not(:focus):invalid, .build-with-bootstrap .input-group > .form-control:not(:focus).is-invalid,
.was-validated .build-with-bootstrap .input-group > .form-select:not(:focus):invalid,
.build-with-bootstrap .input-group > .form-select:not(:focus).is-invalid,
.was-validated .build-with-bootstrap .input-group > .form-floating:not(:focus-within):invalid,
.build-with-bootstrap .input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
.build-with-bootstrap .btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .btn {
    transition: none;
  }
}
.build-with-bootstrap .btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .build-with-bootstrap .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.build-with-bootstrap .btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .build-with-bootstrap .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .build-with-bootstrap .btn, :not(.btn-check) + .build-with-bootstrap .btn:active, .build-with-bootstrap .btn:first-child:active, .build-with-bootstrap .btn.active, .build-with-bootstrap .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .build-with-bootstrap .btn:focus-visible, :not(.btn-check) + .build-with-bootstrap .btn:active:focus-visible, .build-with-bootstrap .btn:first-child:active:focus-visible, .build-with-bootstrap .btn.active:focus-visible, .build-with-bootstrap .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .build-with-bootstrap .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.build-with-bootstrap .btn:disabled, .build-with-bootstrap .btn.disabled, fieldset:disabled .build-with-bootstrap .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}
.build-with-bootstrap .btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}
.build-with-bootstrap .btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}
.build-with-bootstrap .btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}
.build-with-bootstrap .btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}
.build-with-bootstrap .btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}
.build-with-bootstrap .btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}
.build-with-bootstrap .btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}
.build-with-bootstrap .btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}
.build-with-bootstrap .btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}
.build-with-bootstrap .btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.build-with-bootstrap .btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.build-with-bootstrap .btn-link:hover {
  color: var(--bs-btn-hover-color);
}
.build-with-bootstrap .btn-lg, .build-with-bootstrap .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}
.build-with-bootstrap .btn-sm, .build-with-bootstrap .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}
.build-with-bootstrap .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .fade {
    transition: none;
  }
}
.build-with-bootstrap .fade:not(.show) {
  opacity: 0;
}
.build-with-bootstrap .collapse:not(.show) {
  display: none;
}
.build-with-bootstrap .collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .collapsing {
    transition: none;
  }
}
.build-with-bootstrap .collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .collapsing.collapse-horizontal {
    transition: none;
  }
}
.build-with-bootstrap .dropup,
.build-with-bootstrap .dropend,
.build-with-bootstrap .dropdown,
.build-with-bootstrap .dropstart,
.build-with-bootstrap .dropup-center,
.build-with-bootstrap .dropdown-center {
  position: relative;
}
.build-with-bootstrap .dropdown-toggle {
  white-space: nowrap;
}
.build-with-bootstrap .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.build-with-bootstrap .dropdown-toggle:empty::after {
  margin-left: 0;
}
.build-with-bootstrap .dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.build-with-bootstrap .dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}
.build-with-bootstrap .dropdown-menu-start {
  --bs-position: start;
}
.build-with-bootstrap .dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}
.build-with-bootstrap .dropdown-menu-end {
  --bs-position: end;
}
.build-with-bootstrap .dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  .build-with-bootstrap .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .build-with-bootstrap .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .build-with-bootstrap .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .build-with-bootstrap .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .dropdown-menu-md-start {
    --bs-position: start;
  }
  .build-with-bootstrap .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .build-with-bootstrap .dropdown-menu-md-end {
    --bs-position: end;
  }
  .build-with-bootstrap .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .build-with-bootstrap .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .build-with-bootstrap .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .build-with-bootstrap .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .build-with-bootstrap .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .build-with-bootstrap .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .build-with-bootstrap .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .build-with-bootstrap .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .build-with-bootstrap .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .build-with-bootstrap .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.build-with-bootstrap .dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.build-with-bootstrap .dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.build-with-bootstrap .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
.build-with-bootstrap .dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.build-with-bootstrap .dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.build-with-bootstrap .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.build-with-bootstrap .dropend .dropdown-toggle::after {
  vertical-align: 0;
}
.build-with-bootstrap .dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.build-with-bootstrap .dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.build-with-bootstrap .dropstart .dropdown-toggle::after {
  display: none;
}
.build-with-bootstrap .dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.build-with-bootstrap .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.build-with-bootstrap .dropstart .dropdown-toggle::before {
  vertical-align: 0;
}
.build-with-bootstrap .dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}
.build-with-bootstrap .dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.build-with-bootstrap .dropdown-item:hover, .build-with-bootstrap .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.build-with-bootstrap .dropdown-item.active, .build-with-bootstrap .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.build-with-bootstrap .dropdown-item.disabled, .build-with-bootstrap .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
.build-with-bootstrap .dropdown-menu.show {
  display: block;
}
.build-with-bootstrap .dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}
.build-with-bootstrap .dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}
.build-with-bootstrap .dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}
.build-with-bootstrap .btn-group,
.build-with-bootstrap .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.build-with-bootstrap .btn-group > .btn,
.build-with-bootstrap .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.build-with-bootstrap .btn-group > .btn-check:checked + .btn,
.build-with-bootstrap .btn-group > .btn-check:focus + .btn,
.build-with-bootstrap .btn-group > .btn:hover,
.build-with-bootstrap .btn-group > .btn:focus,
.build-with-bootstrap .btn-group > .btn:active,
.build-with-bootstrap .btn-group > .btn.active,
.build-with-bootstrap .btn-group-vertical > .btn-check:checked + .btn,
.build-with-bootstrap .btn-group-vertical > .btn-check:focus + .btn,
.build-with-bootstrap .btn-group-vertical > .btn:hover,
.build-with-bootstrap .btn-group-vertical > .btn:focus,
.build-with-bootstrap .btn-group-vertical > .btn:active,
.build-with-bootstrap .btn-group-vertical > .btn.active {
  z-index: 1;
}
.build-with-bootstrap .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.build-with-bootstrap .btn-toolbar .input-group {
  width: auto;
}
.build-with-bootstrap .btn-group {
  border-radius: var(--bs-border-radius);
}
.build-with-bootstrap .btn-group > :not(.btn-check:first-child) + .btn,
.build-with-bootstrap .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.build-with-bootstrap .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.build-with-bootstrap .btn-group > .btn.dropdown-toggle-split:first-child,
.build-with-bootstrap .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.build-with-bootstrap .btn-group > .btn:nth-child(n+3),
.build-with-bootstrap .btn-group > :not(.btn-check) + .btn,
.build-with-bootstrap .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.build-with-bootstrap .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.build-with-bootstrap .dropdown-toggle-split::after, .dropup .build-with-bootstrap .dropdown-toggle-split::after, .dropend .build-with-bootstrap .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .build-with-bootstrap .dropdown-toggle-split::before {
  margin-right: 0;
}
.build-with-bootstrap .btn-sm + .dropdown-toggle-split, .build-with-bootstrap .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.build-with-bootstrap .btn-lg + .dropdown-toggle-split, .build-with-bootstrap .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.build-with-bootstrap .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.build-with-bootstrap .btn-group-vertical > .btn,
.build-with-bootstrap .btn-group-vertical > .btn-group {
  width: 100%;
}
.build-with-bootstrap .btn-group-vertical > .btn:not(:first-child),
.build-with-bootstrap .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.build-with-bootstrap .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.build-with-bootstrap .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.build-with-bootstrap .btn-group-vertical > .btn:nth-child(n+3),
.build-with-bootstrap .btn-group-vertical > :not(.btn-check) + .btn,
.build-with-bootstrap .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.build-with-bootstrap .nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.build-with-bootstrap .nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .nav-link {
    transition: none;
  }
}
.build-with-bootstrap .nav-link:hover, .build-with-bootstrap .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.build-with-bootstrap .nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.build-with-bootstrap .nav-link.disabled, .build-with-bootstrap .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}
.build-with-bootstrap .nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.build-with-bootstrap .nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.build-with-bootstrap .nav-tabs .nav-link:hover, .build-with-bootstrap .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.build-with-bootstrap .nav-tabs .nav-link.active,
.build-with-bootstrap .nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.build-with-bootstrap .nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.build-with-bootstrap .nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.build-with-bootstrap .nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.build-with-bootstrap .nav-pills .nav-link.active,
.build-with-bootstrap .nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}
.build-with-bootstrap .nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.build-with-bootstrap .nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.build-with-bootstrap .nav-underline .nav-link:hover, .build-with-bootstrap .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.build-with-bootstrap .nav-underline .nav-link.active,
.build-with-bootstrap .nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}
.build-with-bootstrap .nav-fill > .nav-link,
.build-with-bootstrap .nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.build-with-bootstrap .nav-justified > .nav-link,
.build-with-bootstrap .nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}
.build-with-bootstrap .nav-fill .nav-item .nav-link,
.build-with-bootstrap .nav-justified .nav-item .nav-link {
  width: 100%;
}
.build-with-bootstrap .tab-content > .tab-pane {
  display: none;
}
.build-with-bootstrap .tab-content > .active {
  display: block;
}
.build-with-bootstrap .navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.build-with-bootstrap .navbar > .container,
.build-with-bootstrap .navbar > .container-fluid,
.build-with-bootstrap .navbar > .container-sm,
.build-with-bootstrap .navbar > .container-md,
.build-with-bootstrap .navbar > .container-lg,
.build-with-bootstrap .navbar > .container-xl,
.build-with-bootstrap .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.build-with-bootstrap .navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.build-with-bootstrap .navbar-brand:hover, .build-with-bootstrap .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}
.build-with-bootstrap .navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.build-with-bootstrap .navbar-nav .nav-link.active, .build-with-bootstrap .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.build-with-bootstrap .navbar-nav .dropdown-menu {
  position: static;
}
.build-with-bootstrap .navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.build-with-bootstrap .navbar-text a,
.build-with-bootstrap .navbar-text a:hover,
.build-with-bootstrap .navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}
.build-with-bootstrap .navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}
.build-with-bootstrap .navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .navbar-toggler {
    transition: none;
  }
}
.build-with-bootstrap .navbar-toggler:hover {
  text-decoration: none;
}
.build-with-bootstrap .navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}
.build-with-bootstrap .navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}
.build-with-bootstrap .navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}
@media (min-width: 576px) {
  .build-with-bootstrap .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .build-with-bootstrap .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .build-with-bootstrap .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .build-with-bootstrap .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .build-with-bootstrap .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .build-with-bootstrap .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .build-with-bootstrap .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .build-with-bootstrap .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .build-with-bootstrap .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .build-with-bootstrap .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .build-with-bootstrap .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .build-with-bootstrap .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .build-with-bootstrap .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .build-with-bootstrap .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .build-with-bootstrap .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .build-with-bootstrap .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.build-with-bootstrap .navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.build-with-bootstrap .navbar-expand .navbar-nav {
  flex-direction: row;
}
.build-with-bootstrap .navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.build-with-bootstrap .navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.build-with-bootstrap .navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.build-with-bootstrap .navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.build-with-bootstrap .navbar-expand .navbar-toggler {
  display: none;
}
.build-with-bootstrap .navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.build-with-bootstrap .navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.build-with-bootstrap .navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}
.build-with-bootstrap .navbar-dark,
.build-with-bootstrap .navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.build-with-bootstrap [data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.build-with-bootstrap .card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.build-with-bootstrap .card > hr {
  margin-right: 0;
  margin-left: 0;
}
.build-with-bootstrap .card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.build-with-bootstrap .card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card > .card-header + .list-group,
.build-with-bootstrap .card > .list-group + .card-footer {
  border-top: 0;
}
.build-with-bootstrap .card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}
.build-with-bootstrap .card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}
.build-with-bootstrap .card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}
.build-with-bootstrap .card-text:last-child {
  margin-bottom: 0;
}
.build-with-bootstrap .card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}
.build-with-bootstrap .card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.build-with-bootstrap .card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}
.build-with-bootstrap .card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.build-with-bootstrap .card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.build-with-bootstrap .card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
.build-with-bootstrap .card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}
.build-with-bootstrap .card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card-img,
.build-with-bootstrap .card-img-top,
.build-with-bootstrap .card-img-bottom {
  width: 100%;
}
.build-with-bootstrap .card-img,
.build-with-bootstrap .card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card-img,
.build-with-bootstrap .card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.build-with-bootstrap .card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .build-with-bootstrap .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .build-with-bootstrap .card-group > .card {
    flex: 1 0 0;
    margin-bottom: 0;
  }
  .build-with-bootstrap .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:last-child) > .card-img-top,
  .build-with-bootstrap .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:last-child) > .card-img-bottom,
  .build-with-bootstrap .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:first-child) > .card-img-top,
  .build-with-bootstrap .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .build-with-bootstrap .card-group > .card:not(:first-child) > .card-img-bottom,
  .build-with-bootstrap .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}
.build-with-bootstrap .accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}
.build-with-bootstrap .accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .accordion-button {
    transition: none;
  }
}
.build-with-bootstrap .accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.build-with-bootstrap .accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.build-with-bootstrap .accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .accordion-button::after {
    transition: none;
  }
}
.build-with-bootstrap .accordion-button:hover {
  z-index: 2;
}
.build-with-bootstrap .accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}
.build-with-bootstrap .accordion-header {
  margin-bottom: 0;
}
.build-with-bootstrap .accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.build-with-bootstrap .accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.build-with-bootstrap .accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.build-with-bootstrap .accordion-item:not(:first-of-type) {
  border-top: 0;
}
.build-with-bootstrap .accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.build-with-bootstrap .accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.build-with-bootstrap .accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.build-with-bootstrap .accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}
.build-with-bootstrap .accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.build-with-bootstrap .accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.build-with-bootstrap .accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.build-with-bootstrap .accordion-flush > .accordion-item > .accordion-collapse,
.build-with-bootstrap .accordion-flush > .accordion-item > .accordion-header .accordion-button,
.build-with-bootstrap .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.build-with-bootstrap [data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.build-with-bootstrap .breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}
.build-with-bootstrap .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.build-with-bootstrap .breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.build-with-bootstrap .breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}
.build-with-bootstrap .pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}
.build-with-bootstrap .page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .page-link {
    transition: none;
  }
}
.build-with-bootstrap .page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.build-with-bootstrap .page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.build-with-bootstrap .page-link.active, .active > .build-with-bootstrap .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.build-with-bootstrap .page-link.disabled, .disabled > .build-with-bootstrap .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}
.build-with-bootstrap .page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.build-with-bootstrap .page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.build-with-bootstrap .page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}
.build-with-bootstrap .pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
.build-with-bootstrap .pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}
.build-with-bootstrap .badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.build-with-bootstrap .badge:empty {
  display: none;
}
.build-with-bootstrap .btn .badge {
  position: relative;
  top: -1px;
}
.build-with-bootstrap .alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}
.build-with-bootstrap .alert-heading {
  color: inherit;
}
.build-with-bootstrap .alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}
.build-with-bootstrap .alert-dismissible {
  padding-right: 3rem;
}
.build-with-bootstrap .alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}
.build-with-bootstrap .alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}
.build-with-bootstrap .alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}
.build-with-bootstrap .alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}
.build-with-bootstrap .alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}
.build-with-bootstrap .alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}
.build-with-bootstrap .alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}
.build-with-bootstrap .alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}
.build-with-bootstrap .alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.build-with-bootstrap .progress,
.build-with-bootstrap .progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}
.build-with-bootstrap .progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .progress-bar {
    transition: none;
  }
}
.build-with-bootstrap .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}
.build-with-bootstrap .progress-stacked > .progress {
  overflow: visible;
}
.build-with-bootstrap .progress-stacked > .progress > .progress-bar {
  width: 100%;
}
.build-with-bootstrap .progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .progress-bar-animated {
    animation: none;
  }
}
.build-with-bootstrap .list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}
.build-with-bootstrap .list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.build-with-bootstrap .list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}
.build-with-bootstrap .list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.build-with-bootstrap .list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.build-with-bootstrap .list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.build-with-bootstrap .list-group-item.disabled, .build-with-bootstrap .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.build-with-bootstrap .list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.build-with-bootstrap .list-group-item + .list-group-item {
  border-top-width: 0;
}
.build-with-bootstrap .list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}
.build-with-bootstrap .list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.build-with-bootstrap .list-group-item-action:not(.active):hover, .build-with-bootstrap .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.build-with-bootstrap .list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}
.build-with-bootstrap .list-group-horizontal {
  flex-direction: row;
}
.build-with-bootstrap .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.build-with-bootstrap .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.build-with-bootstrap .list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.build-with-bootstrap .list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.build-with-bootstrap .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}
@media (min-width: 576px) {
  .build-with-bootstrap .list-group-horizontal-sm {
    flex-direction: row;
  }
  .build-with-bootstrap .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .build-with-bootstrap .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .build-with-bootstrap .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .list-group-horizontal-md {
    flex-direction: row;
  }
  .build-with-bootstrap .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .build-with-bootstrap .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .build-with-bootstrap .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .list-group-horizontal-lg {
    flex-direction: row;
  }
  .build-with-bootstrap .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .build-with-bootstrap .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .build-with-bootstrap .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .list-group-horizontal-xl {
    flex-direction: row;
  }
  .build-with-bootstrap .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .build-with-bootstrap .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .build-with-bootstrap .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.build-with-bootstrap .list-group-flush {
  border-radius: 0;
}
.build-with-bootstrap .list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.build-with-bootstrap .list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
.build-with-bootstrap .list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}
.build-with-bootstrap .list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}
.build-with-bootstrap .list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}
.build-with-bootstrap .list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}
.build-with-bootstrap .list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}
.build-with-bootstrap .list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}
.build-with-bootstrap .list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}
.build-with-bootstrap .list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}
.build-with-bootstrap .btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.build-with-bootstrap .btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.build-with-bootstrap .btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.build-with-bootstrap .btn-close:disabled, .build-with-bootstrap .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}
.build-with-bootstrap .btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}
.build-with-bootstrap :root,
.build-with-bootstrap [data-bs-theme=light] {
  --bs-btn-close-filter: ;
}
.build-with-bootstrap [data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}
.build-with-bootstrap .toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.build-with-bootstrap .toast.showing {
  opacity: 0;
}
.build-with-bootstrap .toast:not(.show) {
  display: none;
}
.build-with-bootstrap .toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.build-with-bootstrap .toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}
.build-with-bootstrap .toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.build-with-bootstrap .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}
.build-with-bootstrap .toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}
.build-with-bootstrap .modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.build-with-bootstrap .modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .build-with-bootstrap .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .build-with-bootstrap .modal-dialog {
    transition: none;
  }
}
.modal.show .build-with-bootstrap .modal-dialog {
  transform: none;
}
.modal.modal-static .build-with-bootstrap .modal-dialog {
  transform: scale(1.02);
}
.build-with-bootstrap .modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.build-with-bootstrap .modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.build-with-bootstrap .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.build-with-bootstrap .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}
.build-with-bootstrap .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}
.build-with-bootstrap .modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.build-with-bootstrap .modal-backdrop.fade {
  opacity: 0;
}
.build-with-bootstrap .modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}
.build-with-bootstrap .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.build-with-bootstrap .modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}
.build-with-bootstrap .modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}
.build-with-bootstrap .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}
.build-with-bootstrap .modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.build-with-bootstrap .modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  .build-with-bootstrap .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .build-with-bootstrap .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .build-with-bootstrap .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .modal-lg,
  .build-with-bootstrap .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.build-with-bootstrap .modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.build-with-bootstrap .modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.build-with-bootstrap .modal-fullscreen .modal-header,
.build-with-bootstrap .modal-fullscreen .modal-footer {
  border-radius: 0;
}
.build-with-bootstrap .modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  .build-with-bootstrap .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .build-with-bootstrap .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-sm-down .modal-header,
  .build-with-bootstrap .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .build-with-bootstrap .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .build-with-bootstrap .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-md-down .modal-header,
  .build-with-bootstrap .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .build-with-bootstrap .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .build-with-bootstrap .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-lg-down .modal-header,
  .build-with-bootstrap .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .build-with-bootstrap .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xl-down .modal-header,
  .build-with-bootstrap .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .build-with-bootstrap .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xxl-down .modal-header,
  .build-with-bootstrap .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .build-with-bootstrap .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.build-with-bootstrap .tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.build-with-bootstrap .tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.build-with-bootstrap .tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.build-with-bootstrap .tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.build-with-bootstrap .bs-tooltip-top .tooltip-arrow, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.build-with-bootstrap .bs-tooltip-top .tooltip-arrow::before, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}
.build-with-bootstrap {
  /* rtl:begin:ignore */
}
.build-with-bootstrap .bs-tooltip-end .tooltip-arrow, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.build-with-bootstrap .bs-tooltip-end .tooltip-arrow::before, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}
.build-with-bootstrap {
  /* rtl:end:ignore */
}
.build-with-bootstrap .bs-tooltip-bottom .tooltip-arrow, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.build-with-bootstrap .bs-tooltip-bottom .tooltip-arrow::before, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}
.build-with-bootstrap {
  /* rtl:begin:ignore */
}
.build-with-bootstrap .bs-tooltip-start .tooltip-arrow, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.build-with-bootstrap .bs-tooltip-start .tooltip-arrow::before, .build-with-bootstrap .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}
.build-with-bootstrap {
  /* rtl:end:ignore */
}
.build-with-bootstrap .tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}
.build-with-bootstrap .popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.build-with-bootstrap .popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.build-with-bootstrap .popover .popover-arrow::before, .build-with-bootstrap .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}
.build-with-bootstrap .bs-popover-top > .popover-arrow, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.build-with-bootstrap .bs-popover-top > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .build-with-bootstrap .bs-popover-top > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.build-with-bootstrap .bs-popover-top > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.build-with-bootstrap .bs-popover-top > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}
.build-with-bootstrap {
  /* rtl:begin:ignore */
}
.build-with-bootstrap .bs-popover-end > .popover-arrow, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.build-with-bootstrap .bs-popover-end > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .build-with-bootstrap .bs-popover-end > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.build-with-bootstrap .bs-popover-end > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.build-with-bootstrap .bs-popover-end > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}
.build-with-bootstrap {
  /* rtl:end:ignore */
}
.build-with-bootstrap .bs-popover-bottom > .popover-arrow, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.build-with-bootstrap .bs-popover-bottom > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .build-with-bootstrap .bs-popover-bottom > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.build-with-bootstrap .bs-popover-bottom > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.build-with-bootstrap .bs-popover-bottom > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.build-with-bootstrap .bs-popover-bottom .popover-header::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}
.build-with-bootstrap {
  /* rtl:begin:ignore */
}
.build-with-bootstrap .bs-popover-start > .popover-arrow, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.build-with-bootstrap .bs-popover-start > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .build-with-bootstrap .bs-popover-start > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.build-with-bootstrap .bs-popover-start > .popover-arrow::before, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.build-with-bootstrap .bs-popover-start > .popover-arrow::after, .build-with-bootstrap .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}
.build-with-bootstrap {
  /* rtl:end:ignore */
}
.build-with-bootstrap .popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.build-with-bootstrap .popover-header:empty {
  display: none;
}
.build-with-bootstrap .popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}
.build-with-bootstrap .carousel {
  position: relative;
}
.build-with-bootstrap .carousel.pointer-event {
  touch-action: pan-y;
}
.build-with-bootstrap .carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.build-with-bootstrap .carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
.build-with-bootstrap .carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .carousel-item {
    transition: none;
  }
}
.build-with-bootstrap .carousel-item.active,
.build-with-bootstrap .carousel-item-next,
.build-with-bootstrap .carousel-item-prev {
  display: block;
}
.build-with-bootstrap .carousel-item-next:not(.carousel-item-start),
.build-with-bootstrap .active.carousel-item-end {
  transform: translateX(100%);
}
.build-with-bootstrap .carousel-item-prev:not(.carousel-item-end),
.build-with-bootstrap .active.carousel-item-start {
  transform: translateX(-100%);
}
.build-with-bootstrap .carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.build-with-bootstrap .carousel-fade .carousel-item.active,
.build-with-bootstrap .carousel-fade .carousel-item-next.carousel-item-start,
.build-with-bootstrap .carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.build-with-bootstrap .carousel-fade .active.carousel-item-start,
.build-with-bootstrap .carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .carousel-fade .active.carousel-item-start,
  .build-with-bootstrap .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.build-with-bootstrap .carousel-control-prev,
.build-with-bootstrap .carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .carousel-control-prev,
  .build-with-bootstrap .carousel-control-next {
    transition: none;
  }
}
.build-with-bootstrap .carousel-control-prev:hover, .build-with-bootstrap .carousel-control-prev:focus,
.build-with-bootstrap .carousel-control-next:hover,
.build-with-bootstrap .carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
.build-with-bootstrap .carousel-control-prev {
  left: 0;
}
.build-with-bootstrap .carousel-control-next {
  right: 0;
}
.build-with-bootstrap .carousel-control-prev-icon,
.build-with-bootstrap .carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}
.build-with-bootstrap .carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}
.build-with-bootstrap .carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}
.build-with-bootstrap .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.build-with-bootstrap .carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.build-with-bootstrap .carousel-indicators .active {
  opacity: 1;
}
.build-with-bootstrap .carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}
.build-with-bootstrap .carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}
.build-with-bootstrap :root,
.build-with-bootstrap [data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}
.build-with-bootstrap [data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}
.build-with-bootstrap .spinner-grow,
.build-with-bootstrap .spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.build-with-bootstrap .spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.build-with-bootstrap .spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.build-with-bootstrap .spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.build-with-bootstrap .spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .spinner-border,
  .build-with-bootstrap .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.build-with-bootstrap .offcanvas, .build-with-bootstrap .offcanvas-xxl, .build-with-bootstrap .offcanvas-xl, .build-with-bootstrap .offcanvas-lg, .build-with-bootstrap .offcanvas-md, .build-with-bootstrap .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}
@media (max-width: 575.98px) {
  .build-with-bootstrap .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .build-with-bootstrap .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .build-with-bootstrap .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .build-with-bootstrap .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .build-with-bootstrap .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .build-with-bootstrap .offcanvas-sm.showing, .build-with-bootstrap .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .build-with-bootstrap .offcanvas-sm.showing, .build-with-bootstrap .offcanvas-sm.hiding, .build-with-bootstrap .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .build-with-bootstrap .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .build-with-bootstrap .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .build-with-bootstrap .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .build-with-bootstrap .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .build-with-bootstrap .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .build-with-bootstrap .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .build-with-bootstrap .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .build-with-bootstrap .offcanvas-md.showing, .build-with-bootstrap .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .build-with-bootstrap .offcanvas-md.showing, .build-with-bootstrap .offcanvas-md.hiding, .build-with-bootstrap .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .build-with-bootstrap .offcanvas-md .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .build-with-bootstrap .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .build-with-bootstrap .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .build-with-bootstrap .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .build-with-bootstrap .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .build-with-bootstrap .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .build-with-bootstrap .offcanvas-lg.showing, .build-with-bootstrap .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .build-with-bootstrap .offcanvas-lg.showing, .build-with-bootstrap .offcanvas-lg.hiding, .build-with-bootstrap .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .build-with-bootstrap .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .build-with-bootstrap .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .build-with-bootstrap .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .build-with-bootstrap .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .build-with-bootstrap .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .build-with-bootstrap .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .build-with-bootstrap .offcanvas-xl.showing, .build-with-bootstrap .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .build-with-bootstrap .offcanvas-xl.showing, .build-with-bootstrap .offcanvas-xl.hiding, .build-with-bootstrap .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .build-with-bootstrap .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .build-with-bootstrap .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .build-with-bootstrap .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .build-with-bootstrap .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .build-with-bootstrap .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .build-with-bootstrap .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .build-with-bootstrap .offcanvas-xxl.showing, .build-with-bootstrap .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .build-with-bootstrap .offcanvas-xxl.showing, .build-with-bootstrap .offcanvas-xxl.hiding, .build-with-bootstrap .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .build-with-bootstrap .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .build-with-bootstrap .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.build-with-bootstrap .offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .offcanvas {
    transition: none;
  }
}
.build-with-bootstrap .offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.build-with-bootstrap .offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.build-with-bootstrap .offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.build-with-bootstrap .offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.build-with-bootstrap .offcanvas.showing, .build-with-bootstrap .offcanvas.show:not(.hiding) {
  transform: none;
}
.build-with-bootstrap .offcanvas.showing, .build-with-bootstrap .offcanvas.hiding, .build-with-bootstrap .offcanvas.show {
  visibility: visible;
}
.build-with-bootstrap .offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.build-with-bootstrap .offcanvas-backdrop.fade {
  opacity: 0;
}
.build-with-bootstrap .offcanvas-backdrop.show {
  opacity: 0.5;
}
.build-with-bootstrap .offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.build-with-bootstrap .offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}
.build-with-bootstrap .offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}
.build-with-bootstrap .offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}
.build-with-bootstrap .placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.build-with-bootstrap .placeholder.btn::before {
  display: inline-block;
  content: "";
}
.build-with-bootstrap .placeholder-xs {
  min-height: 0.6em;
}
.build-with-bootstrap .placeholder-sm {
  min-height: 0.8em;
}
.build-with-bootstrap .placeholder-lg {
  min-height: 1.2em;
}
.build-with-bootstrap .placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.build-with-bootstrap .placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}
@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.build-with-bootstrap .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.build-with-bootstrap .text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}
.build-with-bootstrap .link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-primary:hover, .build-with-bootstrap .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-secondary:hover, .build-with-bootstrap .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-success:hover, .build-with-bootstrap .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-info:hover, .build-with-bootstrap .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-warning:hover, .build-with-bootstrap .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-danger:hover, .build-with-bootstrap .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-light:hover, .build-with-bootstrap .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-dark:hover, .build-with-bootstrap .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-body-emphasis:hover, .build-with-bootstrap .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}
.build-with-bootstrap .focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}
.build-with-bootstrap .icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.build-with-bootstrap .icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .build-with-bootstrap .icon-link > .bi {
    transition: none;
  }
}
.build-with-bootstrap .icon-link-hover:hover > .bi, .build-with-bootstrap .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}
.build-with-bootstrap .ratio {
  position: relative;
  width: 100%;
}
.build-with-bootstrap .ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.build-with-bootstrap .ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.build-with-bootstrap .ratio-1x1 {
  --bs-aspect-ratio: 100%;
}
.build-with-bootstrap .ratio-4x3 {
  --bs-aspect-ratio: 75%;
}
.build-with-bootstrap .ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}
.build-with-bootstrap .ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}
.build-with-bootstrap .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.build-with-bootstrap .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.build-with-bootstrap .sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
.build-with-bootstrap .sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  .build-with-bootstrap .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .build-with-bootstrap .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .build-with-bootstrap .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .build-with-bootstrap .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .build-with-bootstrap .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .build-with-bootstrap .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.build-with-bootstrap .hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
.build-with-bootstrap .vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
.build-with-bootstrap .visually-hidden,
.build-with-bootstrap .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.build-with-bootstrap .visually-hidden:not(caption),
.build-with-bootstrap .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.build-with-bootstrap .visually-hidden *,
.build-with-bootstrap .visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}
.build-with-bootstrap .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
.build-with-bootstrap .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build-with-bootstrap .vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
.build-with-bootstrap .align-baseline {
  vertical-align: baseline !important;
}
.build-with-bootstrap .align-top {
  vertical-align: top !important;
}
.build-with-bootstrap .align-middle {
  vertical-align: middle !important;
}
.build-with-bootstrap .align-bottom {
  vertical-align: bottom !important;
}
.build-with-bootstrap .align-text-bottom {
  vertical-align: text-bottom !important;
}
.build-with-bootstrap .align-text-top {
  vertical-align: text-top !important;
}
.build-with-bootstrap .float-start {
  float: left !important;
}
.build-with-bootstrap .float-end {
  float: right !important;
}
.build-with-bootstrap .float-none {
  float: none !important;
}
.build-with-bootstrap .object-fit-contain {
  object-fit: contain !important;
}
.build-with-bootstrap .object-fit-cover {
  object-fit: cover !important;
}
.build-with-bootstrap .object-fit-fill {
  object-fit: fill !important;
}
.build-with-bootstrap .object-fit-scale {
  object-fit: scale-down !important;
}
.build-with-bootstrap .object-fit-none {
  object-fit: none !important;
}
.build-with-bootstrap .opacity-0 {
  opacity: 0 !important;
}
.build-with-bootstrap .opacity-25 {
  opacity: 0.25 !important;
}
.build-with-bootstrap .opacity-50 {
  opacity: 0.5 !important;
}
.build-with-bootstrap .opacity-75 {
  opacity: 0.75 !important;
}
.build-with-bootstrap .opacity-100 {
  opacity: 1 !important;
}
.build-with-bootstrap .overflow-auto {
  overflow: auto !important;
}
.build-with-bootstrap .overflow-hidden {
  overflow: hidden !important;
}
.build-with-bootstrap .overflow-visible {
  overflow: visible !important;
}
.build-with-bootstrap .overflow-scroll {
  overflow: scroll !important;
}
.build-with-bootstrap .overflow-x-auto {
  overflow-x: auto !important;
}
.build-with-bootstrap .overflow-x-hidden {
  overflow-x: hidden !important;
}
.build-with-bootstrap .overflow-x-visible {
  overflow-x: visible !important;
}
.build-with-bootstrap .overflow-x-scroll {
  overflow-x: scroll !important;
}
.build-with-bootstrap .overflow-y-auto {
  overflow-y: auto !important;
}
.build-with-bootstrap .overflow-y-hidden {
  overflow-y: hidden !important;
}
.build-with-bootstrap .overflow-y-visible {
  overflow-y: visible !important;
}
.build-with-bootstrap .overflow-y-scroll {
  overflow-y: scroll !important;
}
.build-with-bootstrap .d-inline {
  display: inline !important;
}
.build-with-bootstrap .d-inline-block {
  display: inline-block !important;
}
.build-with-bootstrap .d-block {
  display: block !important;
}
.build-with-bootstrap .d-grid {
  display: grid !important;
}
.build-with-bootstrap .d-inline-grid {
  display: inline-grid !important;
}
.build-with-bootstrap .d-table {
  display: table !important;
}
.build-with-bootstrap .d-table-row {
  display: table-row !important;
}
.build-with-bootstrap .d-table-cell {
  display: table-cell !important;
}
.build-with-bootstrap .d-flex {
  display: flex !important;
}
.build-with-bootstrap .d-inline-flex {
  display: inline-flex !important;
}
.build-with-bootstrap .d-none {
  display: none !important;
}
.build-with-bootstrap .shadow {
  box-shadow: var(--bs-box-shadow) !important;
}
.build-with-bootstrap .shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}
.build-with-bootstrap .shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}
.build-with-bootstrap .shadow-none {
  box-shadow: none !important;
}
.build-with-bootstrap .focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}
.build-with-bootstrap .position-static {
  position: static !important;
}
.build-with-bootstrap .position-relative {
  position: relative !important;
}
.build-with-bootstrap .position-absolute {
  position: absolute !important;
}
.build-with-bootstrap .position-fixed {
  position: fixed !important;
}
.build-with-bootstrap .position-sticky {
  position: sticky !important;
}
.build-with-bootstrap .top-0 {
  top: 0 !important;
}
.build-with-bootstrap .top-50 {
  top: 50% !important;
}
.build-with-bootstrap .top-100 {
  top: 100% !important;
}
.build-with-bootstrap .bottom-0 {
  bottom: 0 !important;
}
.build-with-bootstrap .bottom-50 {
  bottom: 50% !important;
}
.build-with-bootstrap .bottom-100 {
  bottom: 100% !important;
}
.build-with-bootstrap .start-0 {
  left: 0 !important;
}
.build-with-bootstrap .start-50 {
  left: 50% !important;
}
.build-with-bootstrap .start-100 {
  left: 100% !important;
}
.build-with-bootstrap .end-0 {
  right: 0 !important;
}
.build-with-bootstrap .end-50 {
  right: 50% !important;
}
.build-with-bootstrap .end-100 {
  right: 100% !important;
}
.build-with-bootstrap .translate-middle {
  transform: translate(-50%, -50%) !important;
}
.build-with-bootstrap .translate-middle-x {
  transform: translateX(-50%) !important;
}
.build-with-bootstrap .translate-middle-y {
  transform: translateY(-50%) !important;
}
.build-with-bootstrap .border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.build-with-bootstrap .border-0 {
  border: 0 !important;
}
.build-with-bootstrap .border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.build-with-bootstrap .border-top-0 {
  border-top: 0 !important;
}
.build-with-bootstrap .border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.build-with-bootstrap .border-end-0 {
  border-right: 0 !important;
}
.build-with-bootstrap .border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.build-with-bootstrap .border-bottom-0 {
  border-bottom: 0 !important;
}
.build-with-bootstrap .border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.build-with-bootstrap .border-start-0 {
  border-left: 0 !important;
}
.build-with-bootstrap .border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}
.build-with-bootstrap .border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}
.build-with-bootstrap .border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}
.build-with-bootstrap .border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}
.build-with-bootstrap .border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}
.build-with-bootstrap .border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}
.build-with-bootstrap .border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}
.build-with-bootstrap .border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}
.build-with-bootstrap .border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}
.build-with-bootstrap .border-1 {
  border-width: 1px !important;
}
.build-with-bootstrap .border-2 {
  border-width: 2px !important;
}
.build-with-bootstrap .border-3 {
  border-width: 3px !important;
}
.build-with-bootstrap .border-4 {
  border-width: 4px !important;
}
.build-with-bootstrap .border-5 {
  border-width: 5px !important;
}
.build-with-bootstrap .border-opacity-10 {
  --bs-border-opacity: 0.1;
}
.build-with-bootstrap .border-opacity-25 {
  --bs-border-opacity: 0.25;
}
.build-with-bootstrap .border-opacity-50 {
  --bs-border-opacity: 0.5;
}
.build-with-bootstrap .border-opacity-75 {
  --bs-border-opacity: 0.75;
}
.build-with-bootstrap .border-opacity-100 {
  --bs-border-opacity: 1;
}
.build-with-bootstrap .w-25 {
  width: 25% !important;
}
.build-with-bootstrap .w-50 {
  width: 50% !important;
}
.build-with-bootstrap .w-75 {
  width: 75% !important;
}
.build-with-bootstrap .w-100 {
  width: 100% !important;
}
.build-with-bootstrap .w-auto {
  width: auto !important;
}
.build-with-bootstrap .mw-100 {
  max-width: 100% !important;
}
.build-with-bootstrap .vw-100 {
  width: 100vw !important;
}
.build-with-bootstrap .min-vw-100 {
  min-width: 100vw !important;
}
.build-with-bootstrap .h-25 {
  height: 25% !important;
}
.build-with-bootstrap .h-50 {
  height: 50% !important;
}
.build-with-bootstrap .h-75 {
  height: 75% !important;
}
.build-with-bootstrap .h-100 {
  height: 100% !important;
}
.build-with-bootstrap .h-auto {
  height: auto !important;
}
.build-with-bootstrap .mh-100 {
  max-height: 100% !important;
}
.build-with-bootstrap .vh-100 {
  height: 100vh !important;
}
.build-with-bootstrap .min-vh-100 {
  min-height: 100vh !important;
}
.build-with-bootstrap .flex-fill {
  flex: 1 1 auto !important;
}
.build-with-bootstrap .flex-row {
  flex-direction: row !important;
}
.build-with-bootstrap .flex-column {
  flex-direction: column !important;
}
.build-with-bootstrap .flex-row-reverse {
  flex-direction: row-reverse !important;
}
.build-with-bootstrap .flex-column-reverse {
  flex-direction: column-reverse !important;
}
.build-with-bootstrap .flex-grow-0 {
  flex-grow: 0 !important;
}
.build-with-bootstrap .flex-grow-1 {
  flex-grow: 1 !important;
}
.build-with-bootstrap .flex-shrink-0 {
  flex-shrink: 0 !important;
}
.build-with-bootstrap .flex-shrink-1 {
  flex-shrink: 1 !important;
}
.build-with-bootstrap .flex-wrap {
  flex-wrap: wrap !important;
}
.build-with-bootstrap .flex-nowrap {
  flex-wrap: nowrap !important;
}
.build-with-bootstrap .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.build-with-bootstrap .justify-content-start {
  justify-content: flex-start !important;
}
.build-with-bootstrap .justify-content-end {
  justify-content: flex-end !important;
}
.build-with-bootstrap .justify-content-center {
  justify-content: center !important;
}
.build-with-bootstrap .justify-content-between {
  justify-content: space-between !important;
}
.build-with-bootstrap .justify-content-around {
  justify-content: space-around !important;
}
.build-with-bootstrap .justify-content-evenly {
  justify-content: space-evenly !important;
}
.build-with-bootstrap .align-items-start {
  align-items: flex-start !important;
}
.build-with-bootstrap .align-items-end {
  align-items: flex-end !important;
}
.build-with-bootstrap .align-items-center {
  align-items: center !important;
}
.build-with-bootstrap .align-items-baseline {
  align-items: baseline !important;
}
.build-with-bootstrap .align-items-stretch {
  align-items: stretch !important;
}
.build-with-bootstrap .align-content-start {
  align-content: flex-start !important;
}
.build-with-bootstrap .align-content-end {
  align-content: flex-end !important;
}
.build-with-bootstrap .align-content-center {
  align-content: center !important;
}
.build-with-bootstrap .align-content-between {
  align-content: space-between !important;
}
.build-with-bootstrap .align-content-around {
  align-content: space-around !important;
}
.build-with-bootstrap .align-content-stretch {
  align-content: stretch !important;
}
.build-with-bootstrap .align-self-auto {
  align-self: auto !important;
}
.build-with-bootstrap .align-self-start {
  align-self: flex-start !important;
}
.build-with-bootstrap .align-self-end {
  align-self: flex-end !important;
}
.build-with-bootstrap .align-self-center {
  align-self: center !important;
}
.build-with-bootstrap .align-self-baseline {
  align-self: baseline !important;
}
.build-with-bootstrap .align-self-stretch {
  align-self: stretch !important;
}
.build-with-bootstrap .order-first {
  order: -1 !important;
}
.build-with-bootstrap .order-0 {
  order: 0 !important;
}
.build-with-bootstrap .order-1 {
  order: 1 !important;
}
.build-with-bootstrap .order-2 {
  order: 2 !important;
}
.build-with-bootstrap .order-3 {
  order: 3 !important;
}
.build-with-bootstrap .order-4 {
  order: 4 !important;
}
.build-with-bootstrap .order-5 {
  order: 5 !important;
}
.build-with-bootstrap .order-last {
  order: 6 !important;
}
.build-with-bootstrap .m-0 {
  margin: 0 !important;
}
.build-with-bootstrap .m-1 {
  margin: 0.25rem !important;
}
.build-with-bootstrap .m-2 {
  margin: 0.5rem !important;
}
.build-with-bootstrap .m-3 {
  margin: 1rem !important;
}
.build-with-bootstrap .m-4 {
  margin: 1.5rem !important;
}
.build-with-bootstrap .m-5 {
  margin: 3rem !important;
}
.build-with-bootstrap .m-auto {
  margin: auto !important;
}
.build-with-bootstrap .mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.build-with-bootstrap .mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}
.build-with-bootstrap .mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}
.build-with-bootstrap .mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}
.build-with-bootstrap .mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}
.build-with-bootstrap .mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}
.build-with-bootstrap .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.build-with-bootstrap .my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.build-with-bootstrap .my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.build-with-bootstrap .my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.build-with-bootstrap .my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.build-with-bootstrap .my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.build-with-bootstrap .my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.build-with-bootstrap .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.build-with-bootstrap .mt-0 {
  margin-top: 0 !important;
}
.build-with-bootstrap .mt-1 {
  margin-top: 0.25rem !important;
}
.build-with-bootstrap .mt-2 {
  margin-top: 0.5rem !important;
}
.build-with-bootstrap .mt-3 {
  margin-top: 1rem !important;
}
.build-with-bootstrap .mt-4 {
  margin-top: 1.5rem !important;
}
.build-with-bootstrap .mt-5 {
  margin-top: 3rem !important;
}
.build-with-bootstrap .mt-auto {
  margin-top: auto !important;
}
.build-with-bootstrap .me-0 {
  margin-right: 0 !important;
}
.build-with-bootstrap .me-1 {
  margin-right: 0.25rem !important;
}
.build-with-bootstrap .me-2 {
  margin-right: 0.5rem !important;
}
.build-with-bootstrap .me-3 {
  margin-right: 1rem !important;
}
.build-with-bootstrap .me-4 {
  margin-right: 1.5rem !important;
}
.build-with-bootstrap .me-5 {
  margin-right: 3rem !important;
}
.build-with-bootstrap .me-auto {
  margin-right: auto !important;
}
.build-with-bootstrap .mb-0 {
  margin-bottom: 0 !important;
}
.build-with-bootstrap .mb-1 {
  margin-bottom: 0.25rem !important;
}
.build-with-bootstrap .mb-2 {
  margin-bottom: 0.5rem !important;
}
.build-with-bootstrap .mb-3 {
  margin-bottom: 1rem !important;
}
.build-with-bootstrap .mb-4 {
  margin-bottom: 1.5rem !important;
}
.build-with-bootstrap .mb-5 {
  margin-bottom: 3rem !important;
}
.build-with-bootstrap .mb-auto {
  margin-bottom: auto !important;
}
.build-with-bootstrap .ms-0 {
  margin-left: 0 !important;
}
.build-with-bootstrap .ms-1 {
  margin-left: 0.25rem !important;
}
.build-with-bootstrap .ms-2 {
  margin-left: 0.5rem !important;
}
.build-with-bootstrap .ms-3 {
  margin-left: 1rem !important;
}
.build-with-bootstrap .ms-4 {
  margin-left: 1.5rem !important;
}
.build-with-bootstrap .ms-5 {
  margin-left: 3rem !important;
}
.build-with-bootstrap .ms-auto {
  margin-left: auto !important;
}
.build-with-bootstrap .p-0 {
  padding: 0 !important;
}
.build-with-bootstrap .p-1 {
  padding: 0.25rem !important;
}
.build-with-bootstrap .p-2 {
  padding: 0.5rem !important;
}
.build-with-bootstrap .p-3 {
  padding: 1rem !important;
}
.build-with-bootstrap .p-4 {
  padding: 1.5rem !important;
}
.build-with-bootstrap .p-5 {
  padding: 3rem !important;
}
.build-with-bootstrap .px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.build-with-bootstrap .px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}
.build-with-bootstrap .px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.build-with-bootstrap .px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}
.build-with-bootstrap .px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.build-with-bootstrap .px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}
.build-with-bootstrap .py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.build-with-bootstrap .py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.build-with-bootstrap .py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.build-with-bootstrap .py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.build-with-bootstrap .py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.build-with-bootstrap .py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.build-with-bootstrap .pt-0 {
  padding-top: 0 !important;
}
.build-with-bootstrap .pt-1 {
  padding-top: 0.25rem !important;
}
.build-with-bootstrap .pt-2 {
  padding-top: 0.5rem !important;
}
.build-with-bootstrap .pt-3 {
  padding-top: 1rem !important;
}
.build-with-bootstrap .pt-4 {
  padding-top: 1.5rem !important;
}
.build-with-bootstrap .pt-5 {
  padding-top: 3rem !important;
}
.build-with-bootstrap .pe-0 {
  padding-right: 0 !important;
}
.build-with-bootstrap .pe-1 {
  padding-right: 0.25rem !important;
}
.build-with-bootstrap .pe-2 {
  padding-right: 0.5rem !important;
}
.build-with-bootstrap .pe-3 {
  padding-right: 1rem !important;
}
.build-with-bootstrap .pe-4 {
  padding-right: 1.5rem !important;
}
.build-with-bootstrap .pe-5 {
  padding-right: 3rem !important;
}
.build-with-bootstrap .pb-0 {
  padding-bottom: 0 !important;
}
.build-with-bootstrap .pb-1 {
  padding-bottom: 0.25rem !important;
}
.build-with-bootstrap .pb-2 {
  padding-bottom: 0.5rem !important;
}
.build-with-bootstrap .pb-3 {
  padding-bottom: 1rem !important;
}
.build-with-bootstrap .pb-4 {
  padding-bottom: 1.5rem !important;
}
.build-with-bootstrap .pb-5 {
  padding-bottom: 3rem !important;
}
.build-with-bootstrap .ps-0 {
  padding-left: 0 !important;
}
.build-with-bootstrap .ps-1 {
  padding-left: 0.25rem !important;
}
.build-with-bootstrap .ps-2 {
  padding-left: 0.5rem !important;
}
.build-with-bootstrap .ps-3 {
  padding-left: 1rem !important;
}
.build-with-bootstrap .ps-4 {
  padding-left: 1.5rem !important;
}
.build-with-bootstrap .ps-5 {
  padding-left: 3rem !important;
}
.build-with-bootstrap .gap-0 {
  gap: 0 !important;
}
.build-with-bootstrap .gap-1 {
  gap: 0.25rem !important;
}
.build-with-bootstrap .gap-2 {
  gap: 0.5rem !important;
}
.build-with-bootstrap .gap-3 {
  gap: 1rem !important;
}
.build-with-bootstrap .gap-4 {
  gap: 1.5rem !important;
}
.build-with-bootstrap .gap-5 {
  gap: 3rem !important;
}
.build-with-bootstrap .row-gap-0 {
  row-gap: 0 !important;
}
.build-with-bootstrap .row-gap-1 {
  row-gap: 0.25rem !important;
}
.build-with-bootstrap .row-gap-2 {
  row-gap: 0.5rem !important;
}
.build-with-bootstrap .row-gap-3 {
  row-gap: 1rem !important;
}
.build-with-bootstrap .row-gap-4 {
  row-gap: 1.5rem !important;
}
.build-with-bootstrap .row-gap-5 {
  row-gap: 3rem !important;
}
.build-with-bootstrap .column-gap-0 {
  column-gap: 0 !important;
}
.build-with-bootstrap .column-gap-1 {
  column-gap: 0.25rem !important;
}
.build-with-bootstrap .column-gap-2 {
  column-gap: 0.5rem !important;
}
.build-with-bootstrap .column-gap-3 {
  column-gap: 1rem !important;
}
.build-with-bootstrap .column-gap-4 {
  column-gap: 1.5rem !important;
}
.build-with-bootstrap .column-gap-5 {
  column-gap: 3rem !important;
}
.build-with-bootstrap .font-monospace {
  font-family: var(--bs-font-monospace) !important;
}
.build-with-bootstrap .fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}
.build-with-bootstrap .fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}
.build-with-bootstrap .fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}
.build-with-bootstrap .fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}
.build-with-bootstrap .fs-5 {
  font-size: 1.25rem !important;
}
.build-with-bootstrap .fs-6 {
  font-size: 1rem !important;
}
.build-with-bootstrap .fst-italic {
  font-style: italic !important;
}
.build-with-bootstrap .fst-normal {
  font-style: normal !important;
}
.build-with-bootstrap .fw-lighter {
  font-weight: lighter !important;
}
.build-with-bootstrap .fw-light {
  font-weight: 300 !important;
}
.build-with-bootstrap .fw-normal {
  font-weight: 400 !important;
}
.build-with-bootstrap .fw-medium {
  font-weight: 500 !important;
}
.build-with-bootstrap .fw-semibold {
  font-weight: 600 !important;
}
.build-with-bootstrap .fw-bold {
  font-weight: 700 !important;
}
.build-with-bootstrap .fw-bolder {
  font-weight: bolder !important;
}
.build-with-bootstrap .lh-1 {
  line-height: 1 !important;
}
.build-with-bootstrap .lh-sm {
  line-height: 1.25 !important;
}
.build-with-bootstrap .lh-base {
  line-height: 1.5 !important;
}
.build-with-bootstrap .lh-lg {
  line-height: 2 !important;
}
.build-with-bootstrap .text-start {
  text-align: left !important;
}
.build-with-bootstrap .text-end {
  text-align: right !important;
}
.build-with-bootstrap .text-center {
  text-align: center !important;
}
.build-with-bootstrap .text-decoration-none {
  text-decoration: none !important;
}
.build-with-bootstrap .text-decoration-underline {
  text-decoration: underline !important;
}
.build-with-bootstrap .text-decoration-line-through {
  text-decoration: line-through !important;
}
.build-with-bootstrap .text-lowercase {
  text-transform: lowercase !important;
}
.build-with-bootstrap .text-uppercase {
  text-transform: uppercase !important;
}
.build-with-bootstrap .text-capitalize {
  text-transform: capitalize !important;
}
.build-with-bootstrap .text-wrap {
  white-space: normal !important;
}
.build-with-bootstrap .text-nowrap {
  white-space: nowrap !important;
}
.build-with-bootstrap {
  /* rtl:begin:remove */
}
.build-with-bootstrap .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}
.build-with-bootstrap {
  /* rtl:end:remove */
}
.build-with-bootstrap .text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}
.build-with-bootstrap .text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.build-with-bootstrap .text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}
.build-with-bootstrap .text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}
.build-with-bootstrap .text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.build-with-bootstrap .text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}
.build-with-bootstrap .text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}
.build-with-bootstrap .text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}
.build-with-bootstrap .text-opacity-25 {
  --bs-text-opacity: 0.25;
}
.build-with-bootstrap .text-opacity-50 {
  --bs-text-opacity: 0.5;
}
.build-with-bootstrap .text-opacity-75 {
  --bs-text-opacity: 0.75;
}
.build-with-bootstrap .text-opacity-100 {
  --bs-text-opacity: 1;
}
.build-with-bootstrap .text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}
.build-with-bootstrap .text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}
.build-with-bootstrap .text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}
.build-with-bootstrap .text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}
.build-with-bootstrap .text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}
.build-with-bootstrap .text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}
.build-with-bootstrap .text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}
.build-with-bootstrap .text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}
.build-with-bootstrap .link-opacity-10 {
  --bs-link-opacity: 0.1;
}
.build-with-bootstrap .link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}
.build-with-bootstrap .link-opacity-25 {
  --bs-link-opacity: 0.25;
}
.build-with-bootstrap .link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}
.build-with-bootstrap .link-opacity-50 {
  --bs-link-opacity: 0.5;
}
.build-with-bootstrap .link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}
.build-with-bootstrap .link-opacity-75 {
  --bs-link-opacity: 0.75;
}
.build-with-bootstrap .link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}
.build-with-bootstrap .link-opacity-100 {
  --bs-link-opacity: 1;
}
.build-with-bootstrap .link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}
.build-with-bootstrap .link-offset-1 {
  text-underline-offset: 0.125em !important;
}
.build-with-bootstrap .link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}
.build-with-bootstrap .link-offset-2 {
  text-underline-offset: 0.25em !important;
}
.build-with-bootstrap .link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}
.build-with-bootstrap .link-offset-3 {
  text-underline-offset: 0.375em !important;
}
.build-with-bootstrap .link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}
.build-with-bootstrap .link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}
.build-with-bootstrap .link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.build-with-bootstrap .link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}
.build-with-bootstrap .link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}
.build-with-bootstrap .link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}
.build-with-bootstrap .link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}
.build-with-bootstrap .link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}
.build-with-bootstrap .link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}
.build-with-bootstrap .link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}
.build-with-bootstrap .link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}
.build-with-bootstrap .link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}
.build-with-bootstrap .link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}
.build-with-bootstrap .link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}
.build-with-bootstrap .link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}
.build-with-bootstrap .bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}
.build-with-bootstrap .bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.build-with-bootstrap .bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}
.build-with-bootstrap .bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}
.build-with-bootstrap .bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}
.build-with-bootstrap .bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}
.build-with-bootstrap .bg-opacity-100 {
  --bs-bg-opacity: 1;
}
.build-with-bootstrap .bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}
.build-with-bootstrap .bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}
.build-with-bootstrap .bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}
.build-with-bootstrap .bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}
.build-with-bootstrap .bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}
.build-with-bootstrap .bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}
.build-with-bootstrap .bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}
.build-with-bootstrap .bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}
.build-with-bootstrap .bg-gradient {
  background-image: var(--bs-gradient) !important;
}
.build-with-bootstrap .user-select-all {
  user-select: all !important;
}
.build-with-bootstrap .user-select-auto {
  user-select: auto !important;
}
.build-with-bootstrap .user-select-none {
  user-select: none !important;
}
.build-with-bootstrap .pe-none {
  pointer-events: none !important;
}
.build-with-bootstrap .pe-auto {
  pointer-events: auto !important;
}
.build-with-bootstrap .rounded {
  border-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-0 {
  border-radius: 0 !important;
}
.build-with-bootstrap .rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}
.build-with-bootstrap .rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}
.build-with-bootstrap .rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}
.build-with-bootstrap .rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}
.build-with-bootstrap .rounded-circle {
  border-radius: 50% !important;
}
.build-with-bootstrap .rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}
.build-with-bootstrap .rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.build-with-bootstrap .rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}
.build-with-bootstrap .rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}
.build-with-bootstrap .rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}
.build-with-bootstrap .rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}
.build-with-bootstrap .rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}
.build-with-bootstrap .rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}
.build-with-bootstrap .rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.build-with-bootstrap .rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}
.build-with-bootstrap .rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}
.build-with-bootstrap .rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}
.build-with-bootstrap .rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}
.build-with-bootstrap .rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
.build-with-bootstrap .rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}
.build-with-bootstrap .rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.build-with-bootstrap .rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}
.build-with-bootstrap .rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}
.build-with-bootstrap .rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}
.build-with-bootstrap .rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}
.build-with-bootstrap .rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.build-with-bootstrap .rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}
.build-with-bootstrap .rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.build-with-bootstrap .rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}
.build-with-bootstrap .rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.build-with-bootstrap .rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}
.build-with-bootstrap .rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}
.build-with-bootstrap .rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}
.build-with-bootstrap .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}
.build-with-bootstrap .rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}
.build-with-bootstrap .visible {
  visibility: visible !important;
}
.build-with-bootstrap .invisible {
  visibility: hidden !important;
}
.build-with-bootstrap .z-n1 {
  z-index: -1 !important;
}
.build-with-bootstrap .z-0 {
  z-index: 0 !important;
}
.build-with-bootstrap .z-1 {
  z-index: 1 !important;
}
.build-with-bootstrap .z-2 {
  z-index: 2 !important;
}
.build-with-bootstrap .z-3 {
  z-index: 3 !important;
}
@media (min-width: 576px) {
  .build-with-bootstrap .float-sm-start {
    float: left !important;
  }
  .build-with-bootstrap .float-sm-end {
    float: right !important;
  }
  .build-with-bootstrap .float-sm-none {
    float: none !important;
  }
  .build-with-bootstrap .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .build-with-bootstrap .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .build-with-bootstrap .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .build-with-bootstrap .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .build-with-bootstrap .object-fit-sm-none {
    object-fit: none !important;
  }
  .build-with-bootstrap .d-sm-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-sm-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-sm-block {
    display: block !important;
  }
  .build-with-bootstrap .d-sm-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-sm-table {
    display: table !important;
  }
  .build-with-bootstrap .d-sm-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-sm-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-sm-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-sm-none {
    display: none !important;
  }
  .build-with-bootstrap .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .build-with-bootstrap .flex-sm-row {
    flex-direction: row !important;
  }
  .build-with-bootstrap .flex-sm-column {
    flex-direction: column !important;
  }
  .build-with-bootstrap .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .build-with-bootstrap .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .build-with-bootstrap .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .build-with-bootstrap .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .build-with-bootstrap .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .build-with-bootstrap .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .build-with-bootstrap .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .build-with-bootstrap .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .build-with-bootstrap .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .build-with-bootstrap .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .build-with-bootstrap .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .build-with-bootstrap .justify-content-sm-center {
    justify-content: center !important;
  }
  .build-with-bootstrap .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .build-with-bootstrap .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .build-with-bootstrap .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .build-with-bootstrap .align-items-sm-start {
    align-items: flex-start !important;
  }
  .build-with-bootstrap .align-items-sm-end {
    align-items: flex-end !important;
  }
  .build-with-bootstrap .align-items-sm-center {
    align-items: center !important;
  }
  .build-with-bootstrap .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .build-with-bootstrap .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .build-with-bootstrap .align-content-sm-start {
    align-content: flex-start !important;
  }
  .build-with-bootstrap .align-content-sm-end {
    align-content: flex-end !important;
  }
  .build-with-bootstrap .align-content-sm-center {
    align-content: center !important;
  }
  .build-with-bootstrap .align-content-sm-between {
    align-content: space-between !important;
  }
  .build-with-bootstrap .align-content-sm-around {
    align-content: space-around !important;
  }
  .build-with-bootstrap .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .build-with-bootstrap .align-self-sm-auto {
    align-self: auto !important;
  }
  .build-with-bootstrap .align-self-sm-start {
    align-self: flex-start !important;
  }
  .build-with-bootstrap .align-self-sm-end {
    align-self: flex-end !important;
  }
  .build-with-bootstrap .align-self-sm-center {
    align-self: center !important;
  }
  .build-with-bootstrap .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .build-with-bootstrap .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .build-with-bootstrap .order-sm-first {
    order: -1 !important;
  }
  .build-with-bootstrap .order-sm-0 {
    order: 0 !important;
  }
  .build-with-bootstrap .order-sm-1 {
    order: 1 !important;
  }
  .build-with-bootstrap .order-sm-2 {
    order: 2 !important;
  }
  .build-with-bootstrap .order-sm-3 {
    order: 3 !important;
  }
  .build-with-bootstrap .order-sm-4 {
    order: 4 !important;
  }
  .build-with-bootstrap .order-sm-5 {
    order: 5 !important;
  }
  .build-with-bootstrap .order-sm-last {
    order: 6 !important;
  }
  .build-with-bootstrap .m-sm-0 {
    margin: 0 !important;
  }
  .build-with-bootstrap .m-sm-1 {
    margin: 0.25rem !important;
  }
  .build-with-bootstrap .m-sm-2 {
    margin: 0.5rem !important;
  }
  .build-with-bootstrap .m-sm-3 {
    margin: 1rem !important;
  }
  .build-with-bootstrap .m-sm-4 {
    margin: 1.5rem !important;
  }
  .build-with-bootstrap .m-sm-5 {
    margin: 3rem !important;
  }
  .build-with-bootstrap .m-sm-auto {
    margin: auto !important;
  }
  .build-with-bootstrap .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .build-with-bootstrap .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .build-with-bootstrap .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .mt-sm-0 {
    margin-top: 0 !important;
  }
  .build-with-bootstrap .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .build-with-bootstrap .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .build-with-bootstrap .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .build-with-bootstrap .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .build-with-bootstrap .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .build-with-bootstrap .mt-sm-auto {
    margin-top: auto !important;
  }
  .build-with-bootstrap .me-sm-0 {
    margin-right: 0 !important;
  }
  .build-with-bootstrap .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .build-with-bootstrap .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .build-with-bootstrap .me-sm-3 {
    margin-right: 1rem !important;
  }
  .build-with-bootstrap .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .build-with-bootstrap .me-sm-5 {
    margin-right: 3rem !important;
  }
  .build-with-bootstrap .me-sm-auto {
    margin-right: auto !important;
  }
  .build-with-bootstrap .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .ms-sm-0 {
    margin-left: 0 !important;
  }
  .build-with-bootstrap .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .ms-sm-auto {
    margin-left: auto !important;
  }
  .build-with-bootstrap .p-sm-0 {
    padding: 0 !important;
  }
  .build-with-bootstrap .p-sm-1 {
    padding: 0.25rem !important;
  }
  .build-with-bootstrap .p-sm-2 {
    padding: 0.5rem !important;
  }
  .build-with-bootstrap .p-sm-3 {
    padding: 1rem !important;
  }
  .build-with-bootstrap .p-sm-4 {
    padding: 1.5rem !important;
  }
  .build-with-bootstrap .p-sm-5 {
    padding: 3rem !important;
  }
  .build-with-bootstrap .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .build-with-bootstrap .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .pt-sm-0 {
    padding-top: 0 !important;
  }
  .build-with-bootstrap .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .build-with-bootstrap .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .build-with-bootstrap .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .build-with-bootstrap .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .build-with-bootstrap .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .build-with-bootstrap .pe-sm-0 {
    padding-right: 0 !important;
  }
  .build-with-bootstrap .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .build-with-bootstrap .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .build-with-bootstrap .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .build-with-bootstrap .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .build-with-bootstrap .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .build-with-bootstrap .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .ps-sm-0 {
    padding-left: 0 !important;
  }
  .build-with-bootstrap .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .gap-sm-0 {
    gap: 0 !important;
  }
  .build-with-bootstrap .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .build-with-bootstrap .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .build-with-bootstrap .gap-sm-3 {
    gap: 1rem !important;
  }
  .build-with-bootstrap .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .build-with-bootstrap .gap-sm-5 {
    gap: 3rem !important;
  }
  .build-with-bootstrap .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .build-with-bootstrap .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .build-with-bootstrap .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .build-with-bootstrap .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .build-with-bootstrap .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .build-with-bootstrap .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .build-with-bootstrap .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .build-with-bootstrap .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .build-with-bootstrap .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .build-with-bootstrap .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .build-with-bootstrap .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .build-with-bootstrap .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .build-with-bootstrap .text-sm-start {
    text-align: left !important;
  }
  .build-with-bootstrap .text-sm-end {
    text-align: right !important;
  }
  .build-with-bootstrap .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .build-with-bootstrap .float-md-start {
    float: left !important;
  }
  .build-with-bootstrap .float-md-end {
    float: right !important;
  }
  .build-with-bootstrap .float-md-none {
    float: none !important;
  }
  .build-with-bootstrap .object-fit-md-contain {
    object-fit: contain !important;
  }
  .build-with-bootstrap .object-fit-md-cover {
    object-fit: cover !important;
  }
  .build-with-bootstrap .object-fit-md-fill {
    object-fit: fill !important;
  }
  .build-with-bootstrap .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .build-with-bootstrap .object-fit-md-none {
    object-fit: none !important;
  }
  .build-with-bootstrap .d-md-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-md-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-md-block {
    display: block !important;
  }
  .build-with-bootstrap .d-md-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-md-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-md-table {
    display: table !important;
  }
  .build-with-bootstrap .d-md-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-md-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-md-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-md-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-md-none {
    display: none !important;
  }
  .build-with-bootstrap .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .build-with-bootstrap .flex-md-row {
    flex-direction: row !important;
  }
  .build-with-bootstrap .flex-md-column {
    flex-direction: column !important;
  }
  .build-with-bootstrap .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .build-with-bootstrap .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .build-with-bootstrap .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .build-with-bootstrap .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .build-with-bootstrap .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .build-with-bootstrap .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .build-with-bootstrap .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .build-with-bootstrap .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .build-with-bootstrap .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .build-with-bootstrap .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .build-with-bootstrap .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .build-with-bootstrap .justify-content-md-center {
    justify-content: center !important;
  }
  .build-with-bootstrap .justify-content-md-between {
    justify-content: space-between !important;
  }
  .build-with-bootstrap .justify-content-md-around {
    justify-content: space-around !important;
  }
  .build-with-bootstrap .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .build-with-bootstrap .align-items-md-start {
    align-items: flex-start !important;
  }
  .build-with-bootstrap .align-items-md-end {
    align-items: flex-end !important;
  }
  .build-with-bootstrap .align-items-md-center {
    align-items: center !important;
  }
  .build-with-bootstrap .align-items-md-baseline {
    align-items: baseline !important;
  }
  .build-with-bootstrap .align-items-md-stretch {
    align-items: stretch !important;
  }
  .build-with-bootstrap .align-content-md-start {
    align-content: flex-start !important;
  }
  .build-with-bootstrap .align-content-md-end {
    align-content: flex-end !important;
  }
  .build-with-bootstrap .align-content-md-center {
    align-content: center !important;
  }
  .build-with-bootstrap .align-content-md-between {
    align-content: space-between !important;
  }
  .build-with-bootstrap .align-content-md-around {
    align-content: space-around !important;
  }
  .build-with-bootstrap .align-content-md-stretch {
    align-content: stretch !important;
  }
  .build-with-bootstrap .align-self-md-auto {
    align-self: auto !important;
  }
  .build-with-bootstrap .align-self-md-start {
    align-self: flex-start !important;
  }
  .build-with-bootstrap .align-self-md-end {
    align-self: flex-end !important;
  }
  .build-with-bootstrap .align-self-md-center {
    align-self: center !important;
  }
  .build-with-bootstrap .align-self-md-baseline {
    align-self: baseline !important;
  }
  .build-with-bootstrap .align-self-md-stretch {
    align-self: stretch !important;
  }
  .build-with-bootstrap .order-md-first {
    order: -1 !important;
  }
  .build-with-bootstrap .order-md-0 {
    order: 0 !important;
  }
  .build-with-bootstrap .order-md-1 {
    order: 1 !important;
  }
  .build-with-bootstrap .order-md-2 {
    order: 2 !important;
  }
  .build-with-bootstrap .order-md-3 {
    order: 3 !important;
  }
  .build-with-bootstrap .order-md-4 {
    order: 4 !important;
  }
  .build-with-bootstrap .order-md-5 {
    order: 5 !important;
  }
  .build-with-bootstrap .order-md-last {
    order: 6 !important;
  }
  .build-with-bootstrap .m-md-0 {
    margin: 0 !important;
  }
  .build-with-bootstrap .m-md-1 {
    margin: 0.25rem !important;
  }
  .build-with-bootstrap .m-md-2 {
    margin: 0.5rem !important;
  }
  .build-with-bootstrap .m-md-3 {
    margin: 1rem !important;
  }
  .build-with-bootstrap .m-md-4 {
    margin: 1.5rem !important;
  }
  .build-with-bootstrap .m-md-5 {
    margin: 3rem !important;
  }
  .build-with-bootstrap .m-md-auto {
    margin: auto !important;
  }
  .build-with-bootstrap .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .build-with-bootstrap .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .build-with-bootstrap .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .mt-md-0 {
    margin-top: 0 !important;
  }
  .build-with-bootstrap .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .build-with-bootstrap .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .build-with-bootstrap .mt-md-3 {
    margin-top: 1rem !important;
  }
  .build-with-bootstrap .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .build-with-bootstrap .mt-md-5 {
    margin-top: 3rem !important;
  }
  .build-with-bootstrap .mt-md-auto {
    margin-top: auto !important;
  }
  .build-with-bootstrap .me-md-0 {
    margin-right: 0 !important;
  }
  .build-with-bootstrap .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .build-with-bootstrap .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .build-with-bootstrap .me-md-3 {
    margin-right: 1rem !important;
  }
  .build-with-bootstrap .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .build-with-bootstrap .me-md-5 {
    margin-right: 3rem !important;
  }
  .build-with-bootstrap .me-md-auto {
    margin-right: auto !important;
  }
  .build-with-bootstrap .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .mb-md-auto {
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .ms-md-0 {
    margin-left: 0 !important;
  }
  .build-with-bootstrap .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .ms-md-3 {
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .ms-md-5 {
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .ms-md-auto {
    margin-left: auto !important;
  }
  .build-with-bootstrap .p-md-0 {
    padding: 0 !important;
  }
  .build-with-bootstrap .p-md-1 {
    padding: 0.25rem !important;
  }
  .build-with-bootstrap .p-md-2 {
    padding: 0.5rem !important;
  }
  .build-with-bootstrap .p-md-3 {
    padding: 1rem !important;
  }
  .build-with-bootstrap .p-md-4 {
    padding: 1.5rem !important;
  }
  .build-with-bootstrap .p-md-5 {
    padding: 3rem !important;
  }
  .build-with-bootstrap .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .build-with-bootstrap .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .pt-md-0 {
    padding-top: 0 !important;
  }
  .build-with-bootstrap .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .build-with-bootstrap .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .build-with-bootstrap .pt-md-3 {
    padding-top: 1rem !important;
  }
  .build-with-bootstrap .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .build-with-bootstrap .pt-md-5 {
    padding-top: 3rem !important;
  }
  .build-with-bootstrap .pe-md-0 {
    padding-right: 0 !important;
  }
  .build-with-bootstrap .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .build-with-bootstrap .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .build-with-bootstrap .pe-md-3 {
    padding-right: 1rem !important;
  }
  .build-with-bootstrap .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .build-with-bootstrap .pe-md-5 {
    padding-right: 3rem !important;
  }
  .build-with-bootstrap .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .ps-md-0 {
    padding-left: 0 !important;
  }
  .build-with-bootstrap .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .ps-md-3 {
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .ps-md-5 {
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .gap-md-0 {
    gap: 0 !important;
  }
  .build-with-bootstrap .gap-md-1 {
    gap: 0.25rem !important;
  }
  .build-with-bootstrap .gap-md-2 {
    gap: 0.5rem !important;
  }
  .build-with-bootstrap .gap-md-3 {
    gap: 1rem !important;
  }
  .build-with-bootstrap .gap-md-4 {
    gap: 1.5rem !important;
  }
  .build-with-bootstrap .gap-md-5 {
    gap: 3rem !important;
  }
  .build-with-bootstrap .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .build-with-bootstrap .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .build-with-bootstrap .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .build-with-bootstrap .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .build-with-bootstrap .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .build-with-bootstrap .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .build-with-bootstrap .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .build-with-bootstrap .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .build-with-bootstrap .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .build-with-bootstrap .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .build-with-bootstrap .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .build-with-bootstrap .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .build-with-bootstrap .text-md-start {
    text-align: left !important;
  }
  .build-with-bootstrap .text-md-end {
    text-align: right !important;
  }
  .build-with-bootstrap .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .build-with-bootstrap .float-lg-start {
    float: left !important;
  }
  .build-with-bootstrap .float-lg-end {
    float: right !important;
  }
  .build-with-bootstrap .float-lg-none {
    float: none !important;
  }
  .build-with-bootstrap .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .build-with-bootstrap .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .build-with-bootstrap .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .build-with-bootstrap .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .build-with-bootstrap .object-fit-lg-none {
    object-fit: none !important;
  }
  .build-with-bootstrap .d-lg-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-lg-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-lg-block {
    display: block !important;
  }
  .build-with-bootstrap .d-lg-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-lg-table {
    display: table !important;
  }
  .build-with-bootstrap .d-lg-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-lg-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-lg-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-lg-none {
    display: none !important;
  }
  .build-with-bootstrap .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .build-with-bootstrap .flex-lg-row {
    flex-direction: row !important;
  }
  .build-with-bootstrap .flex-lg-column {
    flex-direction: column !important;
  }
  .build-with-bootstrap .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .build-with-bootstrap .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .build-with-bootstrap .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .build-with-bootstrap .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .build-with-bootstrap .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .build-with-bootstrap .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .build-with-bootstrap .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .build-with-bootstrap .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .build-with-bootstrap .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .build-with-bootstrap .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .build-with-bootstrap .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .build-with-bootstrap .justify-content-lg-center {
    justify-content: center !important;
  }
  .build-with-bootstrap .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .build-with-bootstrap .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .build-with-bootstrap .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .build-with-bootstrap .align-items-lg-start {
    align-items: flex-start !important;
  }
  .build-with-bootstrap .align-items-lg-end {
    align-items: flex-end !important;
  }
  .build-with-bootstrap .align-items-lg-center {
    align-items: center !important;
  }
  .build-with-bootstrap .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .build-with-bootstrap .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .build-with-bootstrap .align-content-lg-start {
    align-content: flex-start !important;
  }
  .build-with-bootstrap .align-content-lg-end {
    align-content: flex-end !important;
  }
  .build-with-bootstrap .align-content-lg-center {
    align-content: center !important;
  }
  .build-with-bootstrap .align-content-lg-between {
    align-content: space-between !important;
  }
  .build-with-bootstrap .align-content-lg-around {
    align-content: space-around !important;
  }
  .build-with-bootstrap .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .build-with-bootstrap .align-self-lg-auto {
    align-self: auto !important;
  }
  .build-with-bootstrap .align-self-lg-start {
    align-self: flex-start !important;
  }
  .build-with-bootstrap .align-self-lg-end {
    align-self: flex-end !important;
  }
  .build-with-bootstrap .align-self-lg-center {
    align-self: center !important;
  }
  .build-with-bootstrap .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .build-with-bootstrap .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .build-with-bootstrap .order-lg-first {
    order: -1 !important;
  }
  .build-with-bootstrap .order-lg-0 {
    order: 0 !important;
  }
  .build-with-bootstrap .order-lg-1 {
    order: 1 !important;
  }
  .build-with-bootstrap .order-lg-2 {
    order: 2 !important;
  }
  .build-with-bootstrap .order-lg-3 {
    order: 3 !important;
  }
  .build-with-bootstrap .order-lg-4 {
    order: 4 !important;
  }
  .build-with-bootstrap .order-lg-5 {
    order: 5 !important;
  }
  .build-with-bootstrap .order-lg-last {
    order: 6 !important;
  }
  .build-with-bootstrap .m-lg-0 {
    margin: 0 !important;
  }
  .build-with-bootstrap .m-lg-1 {
    margin: 0.25rem !important;
  }
  .build-with-bootstrap .m-lg-2 {
    margin: 0.5rem !important;
  }
  .build-with-bootstrap .m-lg-3 {
    margin: 1rem !important;
  }
  .build-with-bootstrap .m-lg-4 {
    margin: 1.5rem !important;
  }
  .build-with-bootstrap .m-lg-5 {
    margin: 3rem !important;
  }
  .build-with-bootstrap .m-lg-auto {
    margin: auto !important;
  }
  .build-with-bootstrap .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .build-with-bootstrap .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .build-with-bootstrap .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .mt-lg-0 {
    margin-top: 0 !important;
  }
  .build-with-bootstrap .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .build-with-bootstrap .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .build-with-bootstrap .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .build-with-bootstrap .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .build-with-bootstrap .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .build-with-bootstrap .mt-lg-auto {
    margin-top: auto !important;
  }
  .build-with-bootstrap .me-lg-0 {
    margin-right: 0 !important;
  }
  .build-with-bootstrap .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .build-with-bootstrap .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .build-with-bootstrap .me-lg-3 {
    margin-right: 1rem !important;
  }
  .build-with-bootstrap .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .build-with-bootstrap .me-lg-5 {
    margin-right: 3rem !important;
  }
  .build-with-bootstrap .me-lg-auto {
    margin-right: auto !important;
  }
  .build-with-bootstrap .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .ms-lg-0 {
    margin-left: 0 !important;
  }
  .build-with-bootstrap .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .ms-lg-auto {
    margin-left: auto !important;
  }
  .build-with-bootstrap .p-lg-0 {
    padding: 0 !important;
  }
  .build-with-bootstrap .p-lg-1 {
    padding: 0.25rem !important;
  }
  .build-with-bootstrap .p-lg-2 {
    padding: 0.5rem !important;
  }
  .build-with-bootstrap .p-lg-3 {
    padding: 1rem !important;
  }
  .build-with-bootstrap .p-lg-4 {
    padding: 1.5rem !important;
  }
  .build-with-bootstrap .p-lg-5 {
    padding: 3rem !important;
  }
  .build-with-bootstrap .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .build-with-bootstrap .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .pt-lg-0 {
    padding-top: 0 !important;
  }
  .build-with-bootstrap .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .build-with-bootstrap .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .build-with-bootstrap .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .build-with-bootstrap .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .build-with-bootstrap .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .build-with-bootstrap .pe-lg-0 {
    padding-right: 0 !important;
  }
  .build-with-bootstrap .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .build-with-bootstrap .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .build-with-bootstrap .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .build-with-bootstrap .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .build-with-bootstrap .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .build-with-bootstrap .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .ps-lg-0 {
    padding-left: 0 !important;
  }
  .build-with-bootstrap .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .gap-lg-0 {
    gap: 0 !important;
  }
  .build-with-bootstrap .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .build-with-bootstrap .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .build-with-bootstrap .gap-lg-3 {
    gap: 1rem !important;
  }
  .build-with-bootstrap .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .build-with-bootstrap .gap-lg-5 {
    gap: 3rem !important;
  }
  .build-with-bootstrap .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .build-with-bootstrap .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .build-with-bootstrap .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .build-with-bootstrap .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .build-with-bootstrap .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .build-with-bootstrap .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .build-with-bootstrap .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .build-with-bootstrap .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .build-with-bootstrap .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .build-with-bootstrap .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .build-with-bootstrap .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .build-with-bootstrap .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .build-with-bootstrap .text-lg-start {
    text-align: left !important;
  }
  .build-with-bootstrap .text-lg-end {
    text-align: right !important;
  }
  .build-with-bootstrap .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .float-xl-start {
    float: left !important;
  }
  .build-with-bootstrap .float-xl-end {
    float: right !important;
  }
  .build-with-bootstrap .float-xl-none {
    float: none !important;
  }
  .build-with-bootstrap .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .build-with-bootstrap .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .build-with-bootstrap .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .build-with-bootstrap .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .build-with-bootstrap .object-fit-xl-none {
    object-fit: none !important;
  }
  .build-with-bootstrap .d-xl-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-xl-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-xl-block {
    display: block !important;
  }
  .build-with-bootstrap .d-xl-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-xl-table {
    display: table !important;
  }
  .build-with-bootstrap .d-xl-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-xl-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-xl-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-xl-none {
    display: none !important;
  }
  .build-with-bootstrap .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .build-with-bootstrap .flex-xl-row {
    flex-direction: row !important;
  }
  .build-with-bootstrap .flex-xl-column {
    flex-direction: column !important;
  }
  .build-with-bootstrap .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .build-with-bootstrap .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .build-with-bootstrap .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .build-with-bootstrap .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .build-with-bootstrap .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .build-with-bootstrap .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .build-with-bootstrap .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .build-with-bootstrap .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .build-with-bootstrap .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .build-with-bootstrap .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .build-with-bootstrap .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .build-with-bootstrap .justify-content-xl-center {
    justify-content: center !important;
  }
  .build-with-bootstrap .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .build-with-bootstrap .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .build-with-bootstrap .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .build-with-bootstrap .align-items-xl-start {
    align-items: flex-start !important;
  }
  .build-with-bootstrap .align-items-xl-end {
    align-items: flex-end !important;
  }
  .build-with-bootstrap .align-items-xl-center {
    align-items: center !important;
  }
  .build-with-bootstrap .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .build-with-bootstrap .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .build-with-bootstrap .align-content-xl-start {
    align-content: flex-start !important;
  }
  .build-with-bootstrap .align-content-xl-end {
    align-content: flex-end !important;
  }
  .build-with-bootstrap .align-content-xl-center {
    align-content: center !important;
  }
  .build-with-bootstrap .align-content-xl-between {
    align-content: space-between !important;
  }
  .build-with-bootstrap .align-content-xl-around {
    align-content: space-around !important;
  }
  .build-with-bootstrap .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .build-with-bootstrap .align-self-xl-auto {
    align-self: auto !important;
  }
  .build-with-bootstrap .align-self-xl-start {
    align-self: flex-start !important;
  }
  .build-with-bootstrap .align-self-xl-end {
    align-self: flex-end !important;
  }
  .build-with-bootstrap .align-self-xl-center {
    align-self: center !important;
  }
  .build-with-bootstrap .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .build-with-bootstrap .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .build-with-bootstrap .order-xl-first {
    order: -1 !important;
  }
  .build-with-bootstrap .order-xl-0 {
    order: 0 !important;
  }
  .build-with-bootstrap .order-xl-1 {
    order: 1 !important;
  }
  .build-with-bootstrap .order-xl-2 {
    order: 2 !important;
  }
  .build-with-bootstrap .order-xl-3 {
    order: 3 !important;
  }
  .build-with-bootstrap .order-xl-4 {
    order: 4 !important;
  }
  .build-with-bootstrap .order-xl-5 {
    order: 5 !important;
  }
  .build-with-bootstrap .order-xl-last {
    order: 6 !important;
  }
  .build-with-bootstrap .m-xl-0 {
    margin: 0 !important;
  }
  .build-with-bootstrap .m-xl-1 {
    margin: 0.25rem !important;
  }
  .build-with-bootstrap .m-xl-2 {
    margin: 0.5rem !important;
  }
  .build-with-bootstrap .m-xl-3 {
    margin: 1rem !important;
  }
  .build-with-bootstrap .m-xl-4 {
    margin: 1.5rem !important;
  }
  .build-with-bootstrap .m-xl-5 {
    margin: 3rem !important;
  }
  .build-with-bootstrap .m-xl-auto {
    margin: auto !important;
  }
  .build-with-bootstrap .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .build-with-bootstrap .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .build-with-bootstrap .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .mt-xl-0 {
    margin-top: 0 !important;
  }
  .build-with-bootstrap .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .build-with-bootstrap .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .build-with-bootstrap .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .build-with-bootstrap .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .build-with-bootstrap .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .build-with-bootstrap .mt-xl-auto {
    margin-top: auto !important;
  }
  .build-with-bootstrap .me-xl-0 {
    margin-right: 0 !important;
  }
  .build-with-bootstrap .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .build-with-bootstrap .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .build-with-bootstrap .me-xl-3 {
    margin-right: 1rem !important;
  }
  .build-with-bootstrap .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .build-with-bootstrap .me-xl-5 {
    margin-right: 3rem !important;
  }
  .build-with-bootstrap .me-xl-auto {
    margin-right: auto !important;
  }
  .build-with-bootstrap .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .ms-xl-0 {
    margin-left: 0 !important;
  }
  .build-with-bootstrap .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .ms-xl-auto {
    margin-left: auto !important;
  }
  .build-with-bootstrap .p-xl-0 {
    padding: 0 !important;
  }
  .build-with-bootstrap .p-xl-1 {
    padding: 0.25rem !important;
  }
  .build-with-bootstrap .p-xl-2 {
    padding: 0.5rem !important;
  }
  .build-with-bootstrap .p-xl-3 {
    padding: 1rem !important;
  }
  .build-with-bootstrap .p-xl-4 {
    padding: 1.5rem !important;
  }
  .build-with-bootstrap .p-xl-5 {
    padding: 3rem !important;
  }
  .build-with-bootstrap .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .build-with-bootstrap .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .pt-xl-0 {
    padding-top: 0 !important;
  }
  .build-with-bootstrap .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .build-with-bootstrap .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .build-with-bootstrap .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .build-with-bootstrap .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .build-with-bootstrap .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .build-with-bootstrap .pe-xl-0 {
    padding-right: 0 !important;
  }
  .build-with-bootstrap .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .build-with-bootstrap .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .build-with-bootstrap .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .build-with-bootstrap .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .build-with-bootstrap .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .build-with-bootstrap .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .ps-xl-0 {
    padding-left: 0 !important;
  }
  .build-with-bootstrap .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .gap-xl-0 {
    gap: 0 !important;
  }
  .build-with-bootstrap .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .build-with-bootstrap .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .build-with-bootstrap .gap-xl-3 {
    gap: 1rem !important;
  }
  .build-with-bootstrap .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .build-with-bootstrap .gap-xl-5 {
    gap: 3rem !important;
  }
  .build-with-bootstrap .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .build-with-bootstrap .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .build-with-bootstrap .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .build-with-bootstrap .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .build-with-bootstrap .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .build-with-bootstrap .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .build-with-bootstrap .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .build-with-bootstrap .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .build-with-bootstrap .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .build-with-bootstrap .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .build-with-bootstrap .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .build-with-bootstrap .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .build-with-bootstrap .text-xl-start {
    text-align: left !important;
  }
  .build-with-bootstrap .text-xl-end {
    text-align: right !important;
  }
  .build-with-bootstrap .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .build-with-bootstrap .float-xxl-start {
    float: left !important;
  }
  .build-with-bootstrap .float-xxl-end {
    float: right !important;
  }
  .build-with-bootstrap .float-xxl-none {
    float: none !important;
  }
  .build-with-bootstrap .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .build-with-bootstrap .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .build-with-bootstrap .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .build-with-bootstrap .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .build-with-bootstrap .object-fit-xxl-none {
    object-fit: none !important;
  }
  .build-with-bootstrap .d-xxl-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-xxl-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-xxl-block {
    display: block !important;
  }
  .build-with-bootstrap .d-xxl-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-xxl-table {
    display: table !important;
  }
  .build-with-bootstrap .d-xxl-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-xxl-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-xxl-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-xxl-none {
    display: none !important;
  }
  .build-with-bootstrap .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .build-with-bootstrap .flex-xxl-row {
    flex-direction: row !important;
  }
  .build-with-bootstrap .flex-xxl-column {
    flex-direction: column !important;
  }
  .build-with-bootstrap .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .build-with-bootstrap .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .build-with-bootstrap .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .build-with-bootstrap .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .build-with-bootstrap .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .build-with-bootstrap .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .build-with-bootstrap .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .build-with-bootstrap .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .build-with-bootstrap .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .build-with-bootstrap .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .build-with-bootstrap .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .build-with-bootstrap .justify-content-xxl-center {
    justify-content: center !important;
  }
  .build-with-bootstrap .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .build-with-bootstrap .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .build-with-bootstrap .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .build-with-bootstrap .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .build-with-bootstrap .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .build-with-bootstrap .align-items-xxl-center {
    align-items: center !important;
  }
  .build-with-bootstrap .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .build-with-bootstrap .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .build-with-bootstrap .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .build-with-bootstrap .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .build-with-bootstrap .align-content-xxl-center {
    align-content: center !important;
  }
  .build-with-bootstrap .align-content-xxl-between {
    align-content: space-between !important;
  }
  .build-with-bootstrap .align-content-xxl-around {
    align-content: space-around !important;
  }
  .build-with-bootstrap .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .build-with-bootstrap .align-self-xxl-auto {
    align-self: auto !important;
  }
  .build-with-bootstrap .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .build-with-bootstrap .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .build-with-bootstrap .align-self-xxl-center {
    align-self: center !important;
  }
  .build-with-bootstrap .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .build-with-bootstrap .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .build-with-bootstrap .order-xxl-first {
    order: -1 !important;
  }
  .build-with-bootstrap .order-xxl-0 {
    order: 0 !important;
  }
  .build-with-bootstrap .order-xxl-1 {
    order: 1 !important;
  }
  .build-with-bootstrap .order-xxl-2 {
    order: 2 !important;
  }
  .build-with-bootstrap .order-xxl-3 {
    order: 3 !important;
  }
  .build-with-bootstrap .order-xxl-4 {
    order: 4 !important;
  }
  .build-with-bootstrap .order-xxl-5 {
    order: 5 !important;
  }
  .build-with-bootstrap .order-xxl-last {
    order: 6 !important;
  }
  .build-with-bootstrap .m-xxl-0 {
    margin: 0 !important;
  }
  .build-with-bootstrap .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .build-with-bootstrap .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .build-with-bootstrap .m-xxl-3 {
    margin: 1rem !important;
  }
  .build-with-bootstrap .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .build-with-bootstrap .m-xxl-5 {
    margin: 3rem !important;
  }
  .build-with-bootstrap .m-xxl-auto {
    margin: auto !important;
  }
  .build-with-bootstrap .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .build-with-bootstrap .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .build-with-bootstrap .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .build-with-bootstrap .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .build-with-bootstrap .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .build-with-bootstrap .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .build-with-bootstrap .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .build-with-bootstrap .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .build-with-bootstrap .mt-xxl-auto {
    margin-top: auto !important;
  }
  .build-with-bootstrap .me-xxl-0 {
    margin-right: 0 !important;
  }
  .build-with-bootstrap .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .build-with-bootstrap .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .build-with-bootstrap .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .build-with-bootstrap .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .build-with-bootstrap .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .build-with-bootstrap .me-xxl-auto {
    margin-right: auto !important;
  }
  .build-with-bootstrap .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .build-with-bootstrap .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .build-with-bootstrap .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .build-with-bootstrap .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .build-with-bootstrap .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .build-with-bootstrap .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .build-with-bootstrap .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .build-with-bootstrap .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .build-with-bootstrap .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .build-with-bootstrap .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .build-with-bootstrap .ms-xxl-auto {
    margin-left: auto !important;
  }
  .build-with-bootstrap .p-xxl-0 {
    padding: 0 !important;
  }
  .build-with-bootstrap .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .build-with-bootstrap .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .build-with-bootstrap .p-xxl-3 {
    padding: 1rem !important;
  }
  .build-with-bootstrap .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .build-with-bootstrap .p-xxl-5 {
    padding: 3rem !important;
  }
  .build-with-bootstrap .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .build-with-bootstrap .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .build-with-bootstrap .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .build-with-bootstrap .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .build-with-bootstrap .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .build-with-bootstrap .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .build-with-bootstrap .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .build-with-bootstrap .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .build-with-bootstrap .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .build-with-bootstrap .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .build-with-bootstrap .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .build-with-bootstrap .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .build-with-bootstrap .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .build-with-bootstrap .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .build-with-bootstrap .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .build-with-bootstrap .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .build-with-bootstrap .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .build-with-bootstrap .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .build-with-bootstrap .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .build-with-bootstrap .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .build-with-bootstrap .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .build-with-bootstrap .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .build-with-bootstrap .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .build-with-bootstrap .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .build-with-bootstrap .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .build-with-bootstrap .gap-xxl-0 {
    gap: 0 !important;
  }
  .build-with-bootstrap .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .build-with-bootstrap .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .build-with-bootstrap .gap-xxl-3 {
    gap: 1rem !important;
  }
  .build-with-bootstrap .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .build-with-bootstrap .gap-xxl-5 {
    gap: 3rem !important;
  }
  .build-with-bootstrap .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .build-with-bootstrap .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .build-with-bootstrap .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .build-with-bootstrap .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .build-with-bootstrap .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .build-with-bootstrap .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .build-with-bootstrap .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .build-with-bootstrap .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .build-with-bootstrap .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .build-with-bootstrap .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .build-with-bootstrap .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .build-with-bootstrap .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .build-with-bootstrap .text-xxl-start {
    text-align: left !important;
  }
  .build-with-bootstrap .text-xxl-end {
    text-align: right !important;
  }
  .build-with-bootstrap .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .build-with-bootstrap .fs-1 {
    font-size: 2.5rem !important;
  }
  .build-with-bootstrap .fs-2 {
    font-size: 2rem !important;
  }
  .build-with-bootstrap .fs-3 {
    font-size: 1.75rem !important;
  }
  .build-with-bootstrap .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .build-with-bootstrap .d-print-inline {
    display: inline !important;
  }
  .build-with-bootstrap .d-print-inline-block {
    display: inline-block !important;
  }
  .build-with-bootstrap .d-print-block {
    display: block !important;
  }
  .build-with-bootstrap .d-print-grid {
    display: grid !important;
  }
  .build-with-bootstrap .d-print-inline-grid {
    display: inline-grid !important;
  }
  .build-with-bootstrap .d-print-table {
    display: table !important;
  }
  .build-with-bootstrap .d-print-table-row {
    display: table-row !important;
  }
  .build-with-bootstrap .d-print-table-cell {
    display: table-cell !important;
  }
  .build-with-bootstrap .d-print-flex {
    display: flex !important;
  }
  .build-with-bootstrap .d-print-inline-flex {
    display: inline-flex !important;
  }
  .build-with-bootstrap .d-print-none {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/bootstrap-wrapper.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ADPF;;AGzGI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;ADPJ;;AIjKA;;;EAGE,sBAAA;AJoKF;AIrJI;EANJ;IAOM,uBAAA;EJwJJ;AACF;AI3IA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AJ6IF;AIpIA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;ALnf9B;AI5HA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AJ4HF;AIzHA;EFuMQ,iCAAA;AF3ER;AEjFI;EE3CJ;IF8MQ,iBAAA;EF9EN;AACF;AI5HA;EFkMQ,iCAAA;AFnER;AEzFI;EEtCJ;IFyMQ,eAAA;EFtEN;AACF;AI/HA;EF6LQ,+BAAA;AF3DR;AEjGI;EEjCJ;IFoMQ,kBAAA;EF9DN;AACF;AIlIA;EFwLQ,iCAAA;AFnDR;AEzGI;EE5BJ;IF+LQ,iBAAA;EFtDN;AACF;AIrIA;EF+KM,kBALI;AFlCV;AInIA;EF0KM,eALI;AF/BV;AI3HA;EACE,aAAA;EACA,mBCwV0B;AL3N5B;AInHA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AJqHF;AI/GA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJiHF;AI3GA;;EAEE,kBAAA;AJ6GF;AI1GA;;;EAGE,aAAA;EACA,mBAAA;AJ4GF;AIzGA;;;;EAIE,gBAAA;AJ2GF;AIxGA;EACE,gBC6b4B;ALnV9B;AIrGA;EACE,qBAAA;EACA,cAAA;AJuGF;AIjGA;EACE,gBAAA;AJmGF;AI3FA;;EAEE,mBCsa4B;ALzU9B;AIrFA;EF6EM,kBALI;AFgBV;AIjFA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AJmFF;AI1EA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AJ4EF;AIzEA;EAAM,eAAA;AJ4EN;AI3EA;EAAM,WAAA;AJ8EN;AIzEA;EACE,gEAAA;EACA,0BCgNwC;ALrI1C;AIzEE;EACE,mDAAA;AJ2EJ;AIhEE;EAEE,cAAA;EACA,qBAAA;AJiEJ;AI1DA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AFoDV;AIrDA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AF2DV;AInDE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AJqDJ;AIjDA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AJmDF;AIhDE;EACE,cAAA;AJkDJ;AI9CA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;ANsVJ;AI9CE;EACE,UAAA;EF7BE,cALI;AFmFV;AItCA;EACE,gBAAA;AJwCF;AIlCA;;EAEE,sBAAA;AJoCF;AI5BA;EACE,oBAAA;EACA,yBAAA;AJ8BF;AI3BA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;AJ6BF;AItBA;EAEE,mBAAA;EACA,gCAAA;AJuBF;AIpBA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJsBF;AIdA;EACE,qBAAA;AJgBF;AIVA;EAEE,gBAAA;AJWF;AIHA;EACE,UAAA;AJKF;AIAA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AJEF;AIEA;;EAEE,oBAAA;AJAF;AIKA;EACE,eAAA;AJHF;AIMA;EAGE,iBAAA;AJNF;AISE;EACE,UAAA;AJPJ;AIcA;EACE,wBAAA;AJZF;AIoBA;;;;EAIE,0BAAA;AJlBF;AIqBI;;;;EACE,eAAA;AJhBN;AIuBA;EACE,UAAA;EACA,kBAAA;AJrBF;AI0BA;EACE,gBAAA;AJxBF;AIkCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJhCF;AIwCA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AF6KR;AEzUI;EEyWJ;IFtMQ,iBAAA;EF0KN;AACF;AIoCE;EACE,WAAA;AJlCJ;AIyCA;;;;;;;EAOE,UAAA;AJvCF;AI0CA;EACE,YAAA;AJxCF;AIiDA;EACE,6BAAA;EACA,oBAAA;AJ/CF;AIkDE;EACE,eAAA;EACA,oBAAA;AJhDJ;AAneA;EI4hBA;;;;;;;GAAA;AJ/CA;AI0DA;EACE,wBAAA;AJxDF;AI6DA;EACE,UAAA;AJ3DF;AIkEA;EACE,aAAA;EACA,0BAAA;AJhEF;AIqEA;EACE,qBAAA;AJnEF;AIwEA;EACE,SAAA;AJtEF;AI6EA;EACE,kBAAA;EACA,eAAA;AJ3EF;AImFA;EACE,wBAAA;AJjFF;AIyFA;EACE,wBAAA;AJvFF;AOpfA;ELmQM,kBALI;EK5PR,gBFwoB4B;ALlJ9B;AOjfE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AFsPR;AElZI;EKpGF;ILuQM,eAAA;EFmPN;AACF;AO3fE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AFgQR;AE5ZI;EKpGF;ILuQM,iBAAA;EF6PN;AACF;AOrgBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AF0QR;AEtaI;EKpGF;ILuQM,eAAA;EFuQN;AACF;AO/gBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AFoRR;AEhbI;EKpGF;ILuQM,iBAAA;EFiRN;AACF;AOzhBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AF8RR;AE1bI;EKpGF;ILuQM,eAAA;EF2RN;AACF;AOniBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AFwSR;AEpcI;EKpGF;ILuQM,iBAAA;EFqSN;AACF;AOrhBA;ECvDE,eAAA;EACA,gBAAA;AR+kBF;AOphBA;EC5DE,eAAA;EACA,gBAAA;ARmlBF;AOrhBA;EACE,qBAAA;APuhBF;AOrhBE;EACE,oBFsoB0B;AL/G9B;AO7gBA;EL8MM,kBALI;EKvMR,yBAAA;AP+gBF;AO3gBA;EACE,mBFiUO;EH1HH,kBALI;AF4UV;AO3gBE;EACE,gBAAA;AP6gBJ;AOzgBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;ALimBX;AOzgBE;EACE,aAAA;AP2gBJ;AS3mBA;ECIE,eAAA;EAGA,YAAA;AVwmBF;ASzmBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AVgnBF;ASlmBA;EAEE,qBAAA;ATmmBF;AShmBA;EACE,qBAAA;EACA,cAAA;ATkmBF;AS/lBA;EPyPM,kBALI;EOlPR,gCJkjDkC;ALj9BpC;AWnoBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AZ+oBF;AazlBI;EF5CE;IACE,gBNkee;ELsKrB;AACF;Aa9lBI;EF5CE;IACE,gBNkee;EL2KrB;AACF;AanmBI;EF5CE;IACE,gBNkee;ELgLrB;AACF;AaxmBI;EF5CE;IACE,iBNkee;ELqLrB;AACF;Aa7mBI;EF5CE;IACE,iBNkee;EL0LrB;AACF;Ac7qBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AdmrBJ;Ac9qBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AfsrBF;AcprBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AfgrBF;AejoBM;EACE,WAAA;AfmoBR;AehoBM;EApCJ,cAAA;EACA,WAAA;AfuqBF;AezpBE;EACE,cAAA;EACA,WAAA;Af2pBJ;Ae7pBE;EACE,cAAA;EACA,UAAA;Af+pBJ;AejqBE;EACE,cAAA;EACA,mBAAA;AfmqBJ;AerqBE;EACE,cAAA;EACA,UAAA;AfuqBJ;AezqBE;EACE,cAAA;EACA,UAAA;Af2qBJ;Ae7qBE;EACE,cAAA;EACA,mBAAA;Af+qBJ;AehpBM;EAhDJ,cAAA;EACA,WAAA;AfmsBF;Ae9oBU;EAhEN,cAAA;EACA,kBAAA;AfitBJ;AelpBU;EAhEN,cAAA;EACA,mBAAA;AfqtBJ;AetpBU;EAhEN,cAAA;EACA,UAAA;AfytBJ;Ae1pBU;EAhEN,cAAA;EACA,mBAAA;Af6tBJ;Ae9pBU;EAhEN,cAAA;EACA,mBAAA;AfiuBJ;AelqBU;EAhEN,cAAA;EACA,UAAA;AfquBJ;AetqBU;EAhEN,cAAA;EACA,mBAAA;AfyuBJ;Ae1qBU;EAhEN,cAAA;EACA,mBAAA;Af6uBJ;Ae9qBU;EAhEN,cAAA;EACA,UAAA;AfivBJ;AelrBU;EAhEN,cAAA;EACA,mBAAA;AfqvBJ;AetrBU;EAhEN,cAAA;EACA,mBAAA;AfyvBJ;Ae1rBU;EAhEN,cAAA;EACA,WAAA;Af6vBJ;AetrBY;EAxDV,wBAAA;AfivBF;AezrBY;EAxDV,yBAAA;AfovBF;Ae5rBY;EAxDV,gBAAA;AfuvBF;Ae/rBY;EAxDV,yBAAA;Af0vBF;AelsBY;EAxDV,yBAAA;Af6vBF;AersBY;EAxDV,gBAAA;AfgwBF;AexsBY;EAxDV,yBAAA;AfmwBF;Ae3sBY;EAxDV,yBAAA;AfswBF;Ae9sBY;EAxDV,gBAAA;AfywBF;AejtBY;EAxDV,yBAAA;Af4wBF;AeptBY;EAxDV,yBAAA;Af+wBF;Ae5sBQ;;EAEE,gBAAA;Af8sBV;Ae3sBQ;;EAEE,gBAAA;Af6sBV;AeptBQ;;EAEE,sBAAA;AfstBV;AentBQ;;EAEE,sBAAA;AfqtBV;Ae5tBQ;;EAEE,qBAAA;Af8tBV;Ae3tBQ;;EAEE,qBAAA;Af6tBV;AepuBQ;;EAEE,mBAAA;AfsuBV;AenuBQ;;EAEE,mBAAA;AfquBV;Ae5uBQ;;EAEE,qBAAA;Af8uBV;Ae3uBQ;;EAEE,qBAAA;Af6uBV;AepvBQ;;EAEE,mBAAA;AfsvBV;AenvBQ;;EAEE,mBAAA;AfqvBV;Aa/yBI;EEUE;IACE,WAAA;EfwyBN;EeryBI;IApCJ,cAAA;IACA,WAAA;Ef40BA;Ee9zBA;IACE,cAAA;IACA,WAAA;Efg0BF;Eel0BA;IACE,cAAA;IACA,UAAA;Efo0BF;Eet0BA;IACE,cAAA;IACA,mBAAA;Efw0BF;Ee10BA;IACE,cAAA;IACA,UAAA;Ef40BF;Ee90BA;IACE,cAAA;IACA,UAAA;Efg1BF;Eel1BA;IACE,cAAA;IACA,mBAAA;Efo1BF;EerzBI;IAhDJ,cAAA;IACA,WAAA;Efw2BA;EenzBQ;IAhEN,cAAA;IACA,kBAAA;Efs3BF;EevzBQ;IAhEN,cAAA;IACA,mBAAA;Ef03BF;Ee3zBQ;IAhEN,cAAA;IACA,UAAA;Ef83BF;Ee/zBQ;IAhEN,cAAA;IACA,mBAAA;Efk4BF;Een0BQ;IAhEN,cAAA;IACA,mBAAA;Efs4BF;Eev0BQ;IAhEN,cAAA;IACA,UAAA;Ef04BF;Ee30BQ;IAhEN,cAAA;IACA,mBAAA;Ef84BF;Ee/0BQ;IAhEN,cAAA;IACA,mBAAA;Efk5BF;Een1BQ;IAhEN,cAAA;IACA,UAAA;Efs5BF;Eev1BQ;IAhEN,cAAA;IACA,mBAAA;Ef05BF;Ee31BQ;IAhEN,cAAA;IACA,mBAAA;Ef85BF;Ee/1BQ;IAhEN,cAAA;IACA,WAAA;Efk6BF;Ee31BU;IAxDV,cAAA;Efs5BA;Ee91BU;IAxDV,wBAAA;Efy5BA;Eej2BU;IAxDV,yBAAA;Ef45BA;Eep2BU;IAxDV,gBAAA;Ef+5BA;Eev2BU;IAxDV,yBAAA;Efk6BA;Ee12BU;IAxDV,yBAAA;Efq6BA;Ee72BU;IAxDV,gBAAA;Efw6BA;Eeh3BU;IAxDV,yBAAA;Ef26BA;Een3BU;IAxDV,yBAAA;Ef86BA;Eet3BU;IAxDV,gBAAA;Efi7BA;Eez3BU;IAxDV,yBAAA;Efo7BA;Ee53BU;IAxDV,yBAAA;Efu7BA;Eep3BM;;IAEE,gBAAA;Efs3BR;Een3BM;;IAEE,gBAAA;Efq3BR;Ee53BM;;IAEE,sBAAA;Ef83BR;Ee33BM;;IAEE,sBAAA;Ef63BR;Eep4BM;;IAEE,qBAAA;Efs4BR;Een4BM;;IAEE,qBAAA;Efq4BR;Ee54BM;;IAEE,mBAAA;Ef84BR;Ee34BM;;IAEE,mBAAA;Ef64BR;Eep5BM;;IAEE,qBAAA;Efs5BR;Een5BM;;IAEE,qBAAA;Efq5BR;Ee55BM;;IAEE,mBAAA;Ef85BR;Ee35BM;;IAEE,mBAAA;Ef65BR;AACF;Aax9BI;EEUE;IACE,WAAA;Efi9BN;Ee98BI;IApCJ,cAAA;IACA,WAAA;Efq/BA;Eev+BA;IACE,cAAA;IACA,WAAA;Efy+BF;Ee3+BA;IACE,cAAA;IACA,UAAA;Ef6+BF;Ee/+BA;IACE,cAAA;IACA,mBAAA;Efi/BF;Een/BA;IACE,cAAA;IACA,UAAA;Efq/BF;Eev/BA;IACE,cAAA;IACA,UAAA;Efy/BF;Ee3/BA;IACE,cAAA;IACA,mBAAA;Ef6/BF;Ee99BI;IAhDJ,cAAA;IACA,WAAA;EfihCA;Ee59BQ;IAhEN,cAAA;IACA,kBAAA;Ef+hCF;Eeh+BQ;IAhEN,cAAA;IACA,mBAAA;EfmiCF;Eep+BQ;IAhEN,cAAA;IACA,UAAA;EfuiCF;Eex+BQ;IAhEN,cAAA;IACA,mBAAA;Ef2iCF;Ee5+BQ;IAhEN,cAAA;IACA,mBAAA;Ef+iCF;Eeh/BQ;IAhEN,cAAA;IACA,UAAA;EfmjCF;Eep/BQ;IAhEN,cAAA;IACA,mBAAA;EfujCF;Eex/BQ;IAhEN,cAAA;IACA,mBAAA;Ef2jCF;Ee5/BQ;IAhEN,cAAA;IACA,UAAA;Ef+jCF;EehgCQ;IAhEN,cAAA;IACA,mBAAA;EfmkCF;EepgCQ;IAhEN,cAAA;IACA,mBAAA;EfukCF;EexgCQ;IAhEN,cAAA;IACA,WAAA;Ef2kCF;EepgCU;IAxDV,cAAA;Ef+jCA;EevgCU;IAxDV,wBAAA;EfkkCA;Ee1gCU;IAxDV,yBAAA;EfqkCA;Ee7gCU;IAxDV,gBAAA;EfwkCA;EehhCU;IAxDV,yBAAA;Ef2kCA;EenhCU;IAxDV,yBAAA;Ef8kCA;EethCU;IAxDV,gBAAA;EfilCA;EezhCU;IAxDV,yBAAA;EfolCA;Ee5hCU;IAxDV,yBAAA;EfulCA;Ee/hCU;IAxDV,gBAAA;Ef0lCA;EeliCU;IAxDV,yBAAA;Ef6lCA;EeriCU;IAxDV,yBAAA;EfgmCA;Ee7hCM;;IAEE,gBAAA;Ef+hCR;Ee5hCM;;IAEE,gBAAA;Ef8hCR;EeriCM;;IAEE,sBAAA;EfuiCR;EepiCM;;IAEE,sBAAA;EfsiCR;Ee7iCM;;IAEE,qBAAA;Ef+iCR;Ee5iCM;;IAEE,qBAAA;Ef8iCR;EerjCM;;IAEE,mBAAA;EfujCR;EepjCM;;IAEE,mBAAA;EfsjCR;Ee7jCM;;IAEE,qBAAA;Ef+jCR;Ee5jCM;;IAEE,qBAAA;Ef8jCR;EerkCM;;IAEE,mBAAA;EfukCR;EepkCM;;IAEE,mBAAA;EfskCR;AACF;AajoCI;EEUE;IACE,WAAA;Ef0nCN;EevnCI;IApCJ,cAAA;IACA,WAAA;Ef8pCA;EehpCA;IACE,cAAA;IACA,WAAA;EfkpCF;EeppCA;IACE,cAAA;IACA,UAAA;EfspCF;EexpCA;IACE,cAAA;IACA,mBAAA;Ef0pCF;Ee5pCA;IACE,cAAA;IACA,UAAA;Ef8pCF;EehqCA;IACE,cAAA;IACA,UAAA;EfkqCF;EepqCA;IACE,cAAA;IACA,mBAAA;EfsqCF;EevoCI;IAhDJ,cAAA;IACA,WAAA;Ef0rCA;EeroCQ;IAhEN,cAAA;IACA,kBAAA;EfwsCF;EezoCQ;IAhEN,cAAA;IACA,mBAAA;Ef4sCF;Ee7oCQ;IAhEN,cAAA;IACA,UAAA;EfgtCF;EejpCQ;IAhEN,cAAA;IACA,mBAAA;EfotCF;EerpCQ;IAhEN,cAAA;IACA,mBAAA;EfwtCF;EezpCQ;IAhEN,cAAA;IACA,UAAA;Ef4tCF;Ee7pCQ;IAhEN,cAAA;IACA,mBAAA;EfguCF;EejqCQ;IAhEN,cAAA;IACA,mBAAA;EfouCF;EerqCQ;IAhEN,cAAA;IACA,UAAA;EfwuCF;EezqCQ;IAhEN,cAAA;IACA,mBAAA;Ef4uCF;Ee7qCQ;IAhEN,cAAA;IACA,mBAAA;EfgvCF;EejrCQ;IAhEN,cAAA;IACA,WAAA;EfovCF;Ee7qCU;IAxDV,cAAA;EfwuCA;EehrCU;IAxDV,wBAAA;Ef2uCA;EenrCU;IAxDV,yBAAA;Ef8uCA;EetrCU;IAxDV,gBAAA;EfivCA;EezrCU;IAxDV,yBAAA;EfovCA;Ee5rCU;IAxDV,yBAAA;EfuvCA;Ee/rCU;IAxDV,gBAAA;Ef0vCA;EelsCU;IAxDV,yBAAA;Ef6vCA;EersCU;IAxDV,yBAAA;EfgwCA;EexsCU;IAxDV,gBAAA;EfmwCA;Ee3sCU;IAxDV,yBAAA;EfswCA;Ee9sCU;IAxDV,yBAAA;EfywCA;EetsCM;;IAEE,gBAAA;EfwsCR;EersCM;;IAEE,gBAAA;EfusCR;Ee9sCM;;IAEE,sBAAA;EfgtCR;Ee7sCM;;IAEE,sBAAA;Ef+sCR;EettCM;;IAEE,qBAAA;EfwtCR;EertCM;;IAEE,qBAAA;EfutCR;Ee9tCM;;IAEE,mBAAA;EfguCR;Ee7tCM;;IAEE,mBAAA;Ef+tCR;EetuCM;;IAEE,qBAAA;EfwuCR;EeruCM;;IAEE,qBAAA;EfuuCR;Ee9uCM;;IAEE,mBAAA;EfgvCR;Ee7uCM;;IAEE,mBAAA;Ef+uCR;AACF;Aa1yCI;EEUE;IACE,WAAA;EfmyCN;EehyCI;IApCJ,cAAA;IACA,WAAA;Efu0CA;EezzCA;IACE,cAAA;IACA,WAAA;Ef2zCF;Ee7zCA;IACE,cAAA;IACA,UAAA;Ef+zCF;Eej0CA;IACE,cAAA;IACA,mBAAA;Efm0CF;Eer0CA;IACE,cAAA;IACA,UAAA;Efu0CF;Eez0CA;IACE,cAAA;IACA,UAAA;Ef20CF;Ee70CA;IACE,cAAA;IACA,mBAAA;Ef+0CF;EehzCI;IAhDJ,cAAA;IACA,WAAA;Efm2CA;Ee9yCQ;IAhEN,cAAA;IACA,kBAAA;Efi3CF;EelzCQ;IAhEN,cAAA;IACA,mBAAA;Efq3CF;EetzCQ;IAhEN,cAAA;IACA,UAAA;Efy3CF;Ee1zCQ;IAhEN,cAAA;IACA,mBAAA;Ef63CF;Ee9zCQ;IAhEN,cAAA;IACA,mBAAA;Efi4CF;Eel0CQ;IAhEN,cAAA;IACA,UAAA;Efq4CF;Eet0CQ;IAhEN,cAAA;IACA,mBAAA;Efy4CF;Ee10CQ;IAhEN,cAAA;IACA,mBAAA;Ef64CF;Ee90CQ;IAhEN,cAAA;IACA,UAAA;Efi5CF;Eel1CQ;IAhEN,cAAA;IACA,mBAAA;Efq5CF;Eet1CQ;IAhEN,cAAA;IACA,mBAAA;Efy5CF;Ee11CQ;IAhEN,cAAA;IACA,WAAA;Ef65CF;Eet1CU;IAxDV,cAAA;Efi5CA;Eez1CU;IAxDV,wBAAA;Efo5CA;Ee51CU;IAxDV,yBAAA;Efu5CA;Ee/1CU;IAxDV,gBAAA;Ef05CA;Eel2CU;IAxDV,yBAAA;Ef65CA;Eer2CU;IAxDV,yBAAA;Efg6CA;Eex2CU;IAxDV,gBAAA;Efm6CA;Ee32CU;IAxDV,yBAAA;Efs6CA;Ee92CU;IAxDV,yBAAA;Efy6CA;Eej3CU;IAxDV,gBAAA;Ef46CA;Eep3CU;IAxDV,yBAAA;Ef+6CA;Eev3CU;IAxDV,yBAAA;Efk7CA;Ee/2CM;;IAEE,gBAAA;Efi3CR;Ee92CM;;IAEE,gBAAA;Efg3CR;Eev3CM;;IAEE,sBAAA;Efy3CR;Eet3CM;;IAEE,sBAAA;Efw3CR;Ee/3CM;;IAEE,qBAAA;Efi4CR;Ee93CM;;IAEE,qBAAA;Efg4CR;Eev4CM;;IAEE,mBAAA;Efy4CR;Eet4CM;;IAEE,mBAAA;Efw4CR;Ee/4CM;;IAEE,qBAAA;Efi5CR;Ee94CM;;IAEE,qBAAA;Efg5CR;Eev5CM;;IAEE,mBAAA;Efy5CR;Eet5CM;;IAEE,mBAAA;Efw5CR;AACF;Aan9CI;EEUE;IACE,WAAA;Ef48CN;Eez8CI;IApCJ,cAAA;IACA,WAAA;Efg/CA;Eel+CA;IACE,cAAA;IACA,WAAA;Efo+CF;Eet+CA;IACE,cAAA;IACA,UAAA;Efw+CF;Ee1+CA;IACE,cAAA;IACA,mBAAA;Ef4+CF;Ee9+CA;IACE,cAAA;IACA,UAAA;Efg/CF;Eel/CA;IACE,cAAA;IACA,UAAA;Efo/CF;Eet/CA;IACE,cAAA;IACA,mBAAA;Efw/CF;Eez9CI;IAhDJ,cAAA;IACA,WAAA;Ef4gDA;Eev9CQ;IAhEN,cAAA;IACA,kBAAA;Ef0hDF;Ee39CQ;IAhEN,cAAA;IACA,mBAAA;Ef8hDF;Ee/9CQ;IAhEN,cAAA;IACA,UAAA;EfkiDF;Een+CQ;IAhEN,cAAA;IACA,mBAAA;EfsiDF;Eev+CQ;IAhEN,cAAA;IACA,mBAAA;Ef0iDF;Ee3+CQ;IAhEN,cAAA;IACA,UAAA;Ef8iDF;Ee/+CQ;IAhEN,cAAA;IACA,mBAAA;EfkjDF;Een/CQ;IAhEN,cAAA;IACA,mBAAA;EfsjDF;Eev/CQ;IAhEN,cAAA;IACA,UAAA;Ef0jDF;Ee3/CQ;IAhEN,cAAA;IACA,mBAAA;Ef8jDF;Ee//CQ;IAhEN,cAAA;IACA,mBAAA;EfkkDF;EengDQ;IAhEN,cAAA;IACA,WAAA;EfskDF;Ee//CU;IAxDV,cAAA;Ef0jDA;EelgDU;IAxDV,wBAAA;Ef6jDA;EergDU;IAxDV,yBAAA;EfgkDA;EexgDU;IAxDV,gBAAA;EfmkDA;Ee3gDU;IAxDV,yBAAA;EfskDA;Ee9gDU;IAxDV,yBAAA;EfykDA;EejhDU;IAxDV,gBAAA;Ef4kDA;EephDU;IAxDV,yBAAA;Ef+kDA;EevhDU;IAxDV,yBAAA;EfklDA;Ee1hDU;IAxDV,gBAAA;EfqlDA;Ee7hDU;IAxDV,yBAAA;EfwlDA;EehiDU;IAxDV,yBAAA;Ef2lDA;EexhDM;;IAEE,gBAAA;Ef0hDR;EevhDM;;IAEE,gBAAA;EfyhDR;EehiDM;;IAEE,sBAAA;EfkiDR;Ee/hDM;;IAEE,sBAAA;EfiiDR;EexiDM;;IAEE,qBAAA;Ef0iDR;EeviDM;;IAEE,qBAAA;EfyiDR;EehjDM;;IAEE,mBAAA;EfkjDR;Ee/iDM;;IAEE,mBAAA;EfijDR;EexjDM;;IAEE,qBAAA;Ef0jDR;EevjDM;;IAEE,qBAAA;EfyjDR;EehkDM;;IAEE,mBAAA;EfkkDR;Ee/jDM;;IAEE,mBAAA;EfikDR;AACF;AgBvrDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AhBsrDF;AgB/qDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AhBgrDJ;AgB7qDE;EACE,uBAAA;AhB+qDJ;AgB5qDE;EACE,sBAAA;AhB8qDJ;AgB1qDA;EACE,+DAAA;AhB4qDF;AgBrqDA;EACE,iBAAA;AhBuqDF;AgB7pDE;EACE,wBAAA;AhB+pDJ;AgBhpDE;EACE,sCAAA;AhBkpDJ;AgB/oDI;EACE,sCAAA;AhBipDN;AgB1oDE;EACE,sBAAA;AhB4oDJ;AgBzoDE;EACE,mBAAA;AhB2oDJ;AgBjoDE;EACE,oDAAA;EACA,8CAAA;AhBmoDJ;AgB7nDE;EACE,oDAAA;EACA,8CAAA;AhB+nDJ;AgBvnDA;EACE,oDAAA;EACA,8CAAA;AhBynDF;AgBjnDE;EACE,mDAAA;EACA,6CAAA;AhBmnDJ;AiB/vDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB0vDJ;AiB5wDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBuwDJ;AiBzxDE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBoxDJ;AiBtyDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBiyDJ;AiBnzDE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB8yDJ;AiBh0DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB2zDJ;AiB70DE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBw0DJ;AiB11DE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBq1DJ;AgBpsDI;EACE,gBAAA;EACA,iCAAA;AhBssDN;AajyDI;EGyFA;IACE,gBAAA;IACA,iCAAA;EhB2sDJ;AACF;AavyDI;EGyFA;IACE,gBAAA;IACA,iCAAA;EhBitDJ;AACF;Aa7yDI;EGyFA;IACE,gBAAA;IACA,iCAAA;EhButDJ;AACF;AanzDI;EGyFA;IACE,gBAAA;IACA,iCAAA;EhB6tDJ;AACF;AazzDI;EGyFA;IACE,gBAAA;IACA,iCAAA;EhBmuDJ;AACF;AkBv4DA;EACE,qBbu2BsC;ALkiCxC;AkBh4DA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ALiyC9B;AkB53DA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AFgoDV;AkB33DA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AFqoDV;AmB35DA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;AL4jCxC;AoBh6DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ApB65DF;AqB/5DM;EDhBN;ICiBQ,gBAAA;ErBk6DN;AACF;AoBh6DE;EACE,gBAAA;ApBk6DJ;AoBh6DI;EACE,eAAA;ApBk6DN;AoB75DE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;ALy4CxB;AoBv5DE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ApB24DJ;AoBt4DE;EACE,cAAA;EACA,UAAA;ApBw4DJ;AoBp4DE;EACE,gCf40BoC;Ee10BpC,UAAA;ApBq4DJ;AoB73DE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ApB43DJ;AoBx3DE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ApB03DJ;AqBh9DM;ED0EJ;ICzEM,gBAAA;ErBm9DN;AACF;AoB53DE;EACE,wCf47B8B;ALk8BlC;AoBr3DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ApBu3DF;AoBr3DE;EACE,UAAA;ApBu3DJ;AoBp3DE;EAEE,gBAAA;EACA,eAAA;ApBq3DJ;AoB12DA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;ANi/DJ;AoB12DE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ALwuC9B;AoBx2DA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;AN4/DJ;AoBx2DE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AL+uC9B;AoBl2DE;EACE,oEf6uBoC;ALunCxC;AoBj2DE;EACE,mEf0uBoC;ALynCxC;AoBh2DE;EACE,iEfuuBoC;AL2nCxC;AoB71DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AL8wC9B;AoB71DE;EACE,eAAA;ApB+1DJ;AoB51DE;EACE,oBAAA;EdvLA,sCAAA;ANshEJ;AoB31DE;EACE,oBAAA;Ed5LA,sCAAA;AN0hEJ;AoB11DE;EAAoB,+Df8sBkB;AL+oCxC;AoB51DE;EAAoB,6Df8sBkB;ALipCxC;AuB9iEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AvB6iEF;AqBljEM;EEfN;IFgBQ,gBAAA;ErBqjEN;AACF;AuBhjEE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AL6kClC;AuB1iEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AvB2iEJ;AuBxiEE;EAEE,wClBu1BoC;ALktCxC;AuBpiEE;EACE,kBAAA;EACA,uCAAA;AvBsiEJ;AuBliEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AN+kEJ;AuBjiEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;ANslEJ;AuB9hEI;EACE,gEAAA;AvBgiEN;AwBxmEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ALqsC1C;AwBxmEE;EACE,WAAA;EACA,mBAAA;AxB0mEJ;AwBtmEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AxBwmEF;AwBtmEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AxBwmEJ;AwBpmEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AxBqmEF;AwBlmEE;ElB3BE,qBAAA;ANgoEJ;AwBjmEE;EAEE,kBnBm4BsC;AL+tC1C;AwB/lEE;EACE,uBnB03BsC;ALuuC1C;AwB9lEE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ALkmDxB;AwB7lEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AL4nEV;AwB7lEI;EAII,iEAAA;AxB4lER;AwBxlEI;EAII,iEAAA;AxBulER;AwBllEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AxBglEN;AwB5kEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AL4uC3C;AwBvkEI;EACE,eAAA;EACA,YnBy1BqC;ALgvC3C;AwB3jEA;EACE,mBnBo1BgC;ALyuClC;AwB3jEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AxB4jEJ;AqB9qEM;EG0GJ;IHzGM,gBAAA;ErBirEN;AACF;AwB/jEI;EACE,4DAAA;AxBikEN;AwB9jEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AxB4jER;AwBvjEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AxByjEJ;AwBvjEI;EACE,oBAAA;EACA,cAAA;AxByjEN;AwBpjEA;EACE,qBAAA;EACA,kBnBsyBgC;ALgxClC;AwBnjEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AxBqjEF;AwBjjEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AL65C9B;AwB5iEI;EACE,4DAAA;AxB8iEN;AyBjuEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AzBmuEF;AyBjuEE;EACE,UAAA;AzBmuEJ;AyB/tEI;EAA0B,kEpB8gCa;ALotC3C;AyBjuEI;EAA0B,kEpB6gCa;ALutC3C;AyBjuEE;EACE,SAAA;AzBmuEJ;AyBhuEE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;AzBiuEJ;AqBhvEM;EIMJ;IJLM,gBAAA;ErBmvEN;AACF;AyBpuEI;EHjCF,0CjB8hCyC;AL0uC3C;AyBluEE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;ANkwEJ;AyBhuEE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;AzBiuEJ;AqB1wEM;EIiCJ;IJhCM,gBAAA;ErB6wEN;AACF;AyBpuEI;EH3DF,0CjB8hCyC;ALowC3C;AyBluEE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;AN4xEJ;AyBhuEE;EACE,oBAAA;AzBkuEJ;AyBhuEI;EACE,2CpBg9BqC;ALkxC3C;AyB/tEI;EACE,2CpB48BqC;ALqxC3C;A0BxzEA;EACE,kBAAA;A1B0zEF;A0BxzEE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;ALmxCxC;A0BvzEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A1ByzEJ;AqBh0EM;EKTJ;ILUM,gBAAA;ErBm0EN;AACF;A0B3zEE;;EAEE,qBAAA;A1B6zEJ;A0B3zEI;;EACE,kBAAA;A1B8zEN;A0B3zEI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;ALozCxC;A0B3zEI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ALyzCxC;A0B1zEE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;AL4lD9B;A0BrzEI;;;;EACE,8DrBy/BkC;ALi0CxC;A0BrzEI;EACE,8DrBm/BkC;ALo0CxC;A0BlzEI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;ANi3EJ;A0BlzEE;EACE,wCrBkzBoC;ALkgDxC;A0BhzEI;EACE,sCAAA;A1BkzEN;A0B9yEE;;EAEE,crBhFO;ALg4EX;A2B14EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A3B44EF;A2B14EE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A3B44EJ;A2Bx4EE;;;EAGE,UAAA;A3B04EJ;A2Bp4EE;EACE,kBAAA;EACA,UAAA;A3Bs4EJ;A2Bp4EI;EACE,UAAA;A3Bs4EN;A2B33EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;ANo6EJ;A2Bp3EA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AN46EJ;A2Bn3EA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;ANo7EJ;A2Bl3EA;;EAEE,mBAAA;A3Bo3EF;A2Bv2EI;;;;ErBjEA,0BAAA;EACA,6BAAA;AN86EJ;A2Br2EI;;;;ErB1EA,0BAAA;EACA,6BAAA;ANq7EJ;A2B/1EE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AN46EJ;A2B/1EE;;ErB9EE,yBAAA;EACA,4BAAA;ANi7EJ;A4Bz8EE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;ALw5CzB;A4Bv8EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;ANo+EJ;A4Bp8EI;;;EAEE,cAAA;A5Bu8EN;A4Bt/EI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5Bk8ER;A4B/7EM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;ALs7CzB;A4BlgFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A5Bs7ER;A4BtgFI;EAuFE,+CvBq/BmB;AL67CzB;A4B/6EQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A5Bg7EV;A4B56EM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;ALu8CzB;A4BnhFI;EAkHI,yCAAA;A5Bo6ER;A4BthFI;EAyHE,+CvBm9BmB;AL68CzB;A4B95EM;EACE,4CvBg9BiB;ALg9CzB;A4B75EM;EACE,2DvB48BiB;ALm9CzB;A4B55EM;EACE,iCvBw8BiB;ALs9CzB;A4Bz5EI;EACE,kBAAA;A5B25EN;A4BriFI;;;;;EAoJM,UAAA;A5Bw5EV;A4BxhFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ALu+CzB;A4BthFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;ANmjFJ;A4BnhFI;;;EAEE,cAAA;A5BshFN;A4BrkFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5BihFR;A4B9gFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;ALqgDzB;A4BjlFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A5BqgFR;A4BrlFI;EAuFE,iDvBq/BmB;AL4gDzB;A4B9/EQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A5B+/EV;A4B3/EM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;ALshDzB;A4BlmFI;EAkHI,yCAAA;A5Bm/ER;A4BrmFI;EAyHE,iDvBm9BmB;AL4hDzB;A4B7+EM;EACE,8CvBg9BiB;AL+hDzB;A4B5+EM;EACE,0DvB48BiB;ALkiDzB;A4B3+EM;EACE,mCvBw8BiB;ALqiDzB;A4Bx+EI;EACE,kBAAA;A5B0+EN;A4BpnFI;;;;;EAsJM,UAAA;A5Bq+EV;A6B7nFA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A7B0nFF;AqB9oFM;EQhBN;IRiBQ,gBAAA;ErBipFN;AACF;A6B7nFE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A7B8nFJ;A6B3nFE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A7B4nFJ;A6BznFE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A7BunFN;A6BnnFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A7BinFN;A6B7mFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A7BymFJ;A6BtmFI;EAKI,0CAAA;A7BomFR;A6B/lFE;EAKI,0CAAA;A7B6lFN;A6BzlFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A7BwlFJ;A6B5kFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8rFF;A6B5lFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8sFF;A6B5mFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8tFF;A6B5nFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8uFF;A6B5oFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8vFF;A6B5pFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8wFF;A6B5qFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8xFF;A6B5rFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8yFF;A6BlrFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9BqyFF;A6BlsFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9BqzFF;A6BltFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq0FF;A6BluFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq1FF;A6BlvFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq2FF;A6BlwFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq3FF;A6BlxFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq4FF;A6BlyFE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bq5FF;A6BtyFA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ALyhF1C;A6B7xFE;EACE,0BAAA;A7B+xFJ;A6B5xFE;EACE,gCAAA;A7B8xFJ;A6BnxFA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A9Bu6FF;A6BrxFA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A9B66FF;A+Bh/FA;EVgBM,gCUfJ;A/Bk/FF;AqB/9FM;EUpBN;IVqBQ,gBAAA;ErBk+FN;AACF;A+Br/FE;EACE,UAAA;A/Bu/FJ;A+Bj/FE;EACE,aAAA;A/Bm/FJ;A+B/+FA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A/Bi/FF;AqB/+FM;EULN;IVMQ,gBAAA;ErBk/FN;AACF;A+Bp/FE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;A/Bs/FJ;AqBz/FM;EUAJ;IVCM,gBAAA;ErB4/FN;AACF;AgCjhGA;;;;;;EAME,kBAAA;AhCmhGF;AgChhGA;EACE,mBAAA;AhCkhGF;AiC1/FI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AjCkiGF;AiCx+FI;EACE,cAAA;AjC0+FN;AgCxhGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;ANikGJ;AgCphGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AhCshGJ;AgC9/FI;EACE,oBAAA;AhCggGN;AgC9/FM;EACE,WAAA;EACA,OAAA;AhCggGR;AgC5/FI;EACE,kBAAA;AhC8/FN;AgC5/FM;EACE,QAAA;EACA,UAAA;AhC8/FR;AaxiGI;EmB4BA;IACE,oBAAA;EhC+gGJ;EgC7gGI;IACE,WAAA;IACA,OAAA;EhC+gGN;EgC3gGE;IACE,kBAAA;EhC6gGJ;EgC3gGI;IACE,QAAA;IACA,UAAA;EhC6gGN;AACF;AaxjGI;EmB4BA;IACE,oBAAA;EhC+hGJ;EgC7hGI;IACE,WAAA;IACA,OAAA;EhC+hGN;EgC3hGE;IACE,kBAAA;EhC6hGJ;EgC3hGI;IACE,QAAA;IACA,UAAA;EhC6hGN;AACF;AaxkGI;EmB4BA;IACE,oBAAA;EhC+iGJ;EgC7iGI;IACE,WAAA;IACA,OAAA;EhC+iGN;EgC3iGE;IACE,kBAAA;EhC6iGJ;EgC3iGI;IACE,QAAA;IACA,UAAA;EhC6iGN;AACF;AaxlGI;EmB4BA;IACE,oBAAA;EhC+jGJ;EgC7jGI;IACE,WAAA;IACA,OAAA;EhC+jGN;EgC3jGE;IACE,kBAAA;EhC6jGJ;EgC3jGI;IACE,QAAA;IACA,UAAA;EhC6jGN;AACF;AaxmGI;EmB4BA;IACE,oBAAA;EhC+kGJ;EgC7kGI;IACE,WAAA;IACA,OAAA;EhC+kGN;EgC3kGE;IACE,kBAAA;EhC6kGJ;EgC3kGI;IACE,QAAA;IACA,UAAA;EhC6kGN;AACF;AgCpkGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AhCskGJ;AiC1pGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AjC2rGF;AiCxoGI;EACE,cAAA;AjC0oGN;AgC1kGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AhC4kGJ;AiC9qGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AjCwsGF;AiC5pGI;EACE,cAAA;AjC8pGN;AgCplGI;EACE,iBAAA;AhCslGN;AgChlGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AhCklGJ;AiCrsGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AjCusGN;AiC5rGM;EACE,aAAA;AjC8rGR;AiC3rGM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AjCiuGF;AiC3rGI;EACE,cAAA;AjC6rGN;AgClmGI;EACE,iBAAA;AhComGN;AgC7lGA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AhC+lGF;AgCzlGA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;ANkwGJ;AgCzlGE;EAEE,0CAAA;EV1LF,kDU4LuB;AhCylGzB;AgCtlGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AhCulGzB;AgCplGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AhCqlGJ;AgC/kGA;EACE,cAAA;AhCilGF;AgC7kGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AhC+kGF;AgC3kGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AhC6kGF;AgCzkGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AhC0kGF;AkCh0GA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlCk0GF;AkCh0GE;;EACE,kBAAA;EACA,cAAA;AlCm0GJ;AkC9zGE;;;;;;;;;;;;EAME,UAAA;AlCs0GJ;AkCj0GA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlCm0GF;AkCj0GE;EACE,WAAA;AlCm0GJ;AkC/zGA;E5BhBI,sCAAA;ANk1GJ;AkC9zGE;;EAEE,8CAAA;AlCg0GJ;AkC5zGE;;;E5BVE,0BAAA;EACA,6BAAA;AN20GJ;AkCxzGE;;;E5BNE,yBAAA;EACA,4BAAA;ANm0GJ;AkC3yGA;EACE,wBAAA;EACA,uBAAA;AlC6yGF;AkC3yGE;EAGE,cAAA;AlC2yGJ;AkCxyGE;EACE,eAAA;AlC0yGJ;AkCtyGA;EACE,uBAAA;EACA,sBAAA;AlCwyGF;AkCryGA;EACE,sBAAA;EACA,qBAAA;AlCuyGF;AkCnxGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlCqxGF;AkCnxGE;;EAEE,WAAA;AlCqxGJ;AkClxGE;;EAEE,6CAAA;AlCoxGJ;AkChxGE;;E5B1FE,6BAAA;EACA,4BAAA;AN82GJ;AkC5wGE;;;E5BjHE,yBAAA;EACA,0BAAA;ANk4GJ;AmC15GA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCw5GF;AmCr5GA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AnCu5GF;AqBn6GM;EcGN;IdFQ,gBAAA;ErBs6GN;AACF;AmC15GE;EAEE,qCAAA;AnC25GJ;AmCv5GE;EACE,UAAA;EACA,kD9BkhBoB;ALu4FxB;AmCr5GE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AnCs5GJ;AmC94GA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AnC64GF;AmC34GE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AN27GJ;AmC54GI;EAGE,kBAAA;EACA,wDAAA;AnC44GN;AmCx4GE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AnC04GJ;AmCv4GE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AN08GJ;AmC/3GA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;AnCg4GF;AmC73GE;E7B5FE,gDAAA;AN49GJ;AmC53GE;;EAEE,4CAAA;EbjHF,oDakHuB;AnC83GzB;AmCr3GA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AnCo3GF;AmCl3GE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AnCo3GJ;AmCl3GI;EAEE,iCAAA;AnCm3GN;AmC/2GE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;AnCi3GJ;AmCv2GE;;EAEE,cAAA;EACA,kBAAA;AnCy2GJ;AmCp2GE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;AnCs2GJ;AmCh2GE;;EACE,WAAA;AnCm2GJ;AmCz1GE;EACE,aAAA;AnC21GJ;AmCz1GE;EACE,cAAA;AnC21GJ;AoCxhHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ApCuhHF;AoCjhHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ApCyhHJ;AoCrgHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ApCugHF;AoCrgHE;EAEE,yCAAA;ApCsgHJ;AoC5/GA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC0/GF;AoCv/GI;EAEE,oCAAA;ApCw/GN;AoCp/GE;EACE,gBAAA;ApCs/GJ;AoC7+GA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ApC++GF;AoC7+GE;;;EAGE,oCAAA;ApC++GJ;AoCl+GA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ApCk+GF;AoC99GA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ApCg+GF;AqBzmHM;EeiIN;IfhIQ,gBAAA;ErB4mHN;AACF;AoCn+GE;EACE,qBAAA;ApCq+GJ;AoCl+GE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ApCo+GJ;AoC99GA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ApCg+GF;AoC79GA;EACE,yCAAA;EACA,gBAAA;ApC+9GF;AazlHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EpCq9GN;EoCn9GM;IACE,mBAAA;EpCq9GR;EoCn9GQ;IACE,kBAAA;EpCq9GV;EoCl9GQ;IACE,kDAAA;IACA,iDAAA;EpCo9GV;EoCh9GM;IACE,iBAAA;EpCk9GR;EoC/8GM;IACE,wBAAA;IACA,gBAAA;EpCi9GR;EoC98GM;IACE,aAAA;EpCg9GR;EoC78GM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EpC68GR;EoC18GQ;IACE,aAAA;EpC48GV;EoCz8GQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpC28GV;AACF;AaxoHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EpCogHN;EoClgHM;IACE,mBAAA;EpCogHR;EoClgHQ;IACE,kBAAA;EpCogHV;EoCjgHQ;IACE,kDAAA;IACA,iDAAA;EpCmgHV;EoC//GM;IACE,iBAAA;EpCigHR;EoC9/GM;IACE,wBAAA;IACA,gBAAA;EpCggHR;EoC7/GM;IACE,aAAA;EpC+/GR;EoC5/GM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EpC4/GR;EoCz/GQ;IACE,aAAA;EpC2/GV;EoCx/GQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpC0/GV;AACF;AavrHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EpCmjHN;EoCjjHM;IACE,mBAAA;EpCmjHR;EoCjjHQ;IACE,kBAAA;EpCmjHV;EoChjHQ;IACE,kDAAA;IACA,iDAAA;EpCkjHV;EoC9iHM;IACE,iBAAA;EpCgjHR;EoC7iHM;IACE,wBAAA;IACA,gBAAA;EpC+iHR;EoC5iHM;IACE,aAAA;EpC8iHR;EoC3iHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EpC2iHR;EoCxiHQ;IACE,aAAA;EpC0iHV;EoCviHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCyiHV;AACF;AatuHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EpCkmHN;EoChmHM;IACE,mBAAA;EpCkmHR;EoChmHQ;IACE,kBAAA;EpCkmHV;EoC/lHQ;IACE,kDAAA;IACA,iDAAA;EpCimHV;EoC7lHM;IACE,iBAAA;EpC+lHR;EoC5lHM;IACE,wBAAA;IACA,gBAAA;EpC8lHR;EoC3lHM;IACE,aAAA;EpC6lHR;EoC1lHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EpC0lHR;EoCvlHQ;IACE,aAAA;EpCylHV;EoCtlHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCwlHV;AACF;AarxHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EpCipHN;EoC/oHM;IACE,mBAAA;EpCipHR;EoC/oHQ;IACE,kBAAA;EpCipHV;EoC9oHQ;IACE,kDAAA;IACA,iDAAA;EpCgpHV;EoC5oHM;IACE,iBAAA;EpC8oHR;EoC3oHM;IACE,wBAAA;IACA,gBAAA;EpC6oHR;EoC1oHM;IACE,aAAA;EpC4oHR;EoCzoHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EpCyoHR;EoCtoHQ;IACE,aAAA;EpCwoHV;EoCroHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCuoHV;AACF;AoC9rHI;EAEI,iBAAA;EACA,2BAAA;ApC+rHR;AoC7rHQ;EACE,mBAAA;ApC+rHV;AoC7rHU;EACE,kBAAA;ApC+rHZ;AoC5rHU;EACE,kDAAA;EACA,iDAAA;ApC8rHZ;AoC1rHQ;EACE,iBAAA;ApC4rHV;AoCzrHQ;EACE,wBAAA;EACA,gBAAA;ApC2rHV;AoCxrHQ;EACE,aAAA;ApC0rHV;AoCvrHQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ApCurHV;AoCprHU;EACE,aAAA;ApCsrHZ;AoCnrHU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ApCqrHZ;AoCpqHA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ApCqqHF;AoC/pHI;EACE,qEAAA;ApCiqHN;AqC17HA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AN28HJ;AqCt7HE;EACE,eAAA;EACA,cAAA;ArCw7HJ;AqCr7HE;EACE,mBAAA;EACA,sBAAA;ArCu7HJ;AqCr7HI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AN88HJ;AqCr7HI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ANq8HJ;AqCl7HE;;EAEE,aAAA;ArCo7HJ;AqCh7HA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;ArCg7HF;AqC76HA;EACE,4CAAA;EACA,iCAAA;ArC+6HF;AqC56HA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;ArC86HF;AqC36HA;EACE,gBAAA;ArC66HF;AqCr6HE;EACE,oCAAA;ArCu6HJ;AqC/5HA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;ArCi6HF;AqC/5HE;E/B7FE,wFAAA;AN+/HJ;AqC75HA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;ArC+5HF;AqC75HE;E/BxGE,wFAAA;ANwgIJ;AqCt5HA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;ArCw5HF;AqCt5HE;EACE,mCAAA;EACA,sCAAA;ArCw5HJ;AqCp5HA;EACE,uDAAA;EACA,sDAAA;ArCs5HF;AqCl5HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AN+hIJ;AqCj5HA;;;EAGE,WAAA;ArCm5HF;AqCh5HA;;E/B3II,0DAAA;EACA,2DAAA;AN+hIJ;AqCh5HA;;E/BlII,8DAAA;EACA,6DAAA;ANshIJ;AqCx4HE;EACE,0CAAA;ArC04HJ;AargII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;ErC04HF;EqCv4HE;IACE,WAAA;IACA,gBAAA;ErCy4HJ;EqCv4HI;IACE,cAAA;IACA,cAAA;ErCy4HN;EqCp4HM;I/B1KJ,0BAAA;IACA,6BAAA;ENijIF;EqCr4HQ;;IAGE,0BAAA;ErCs4HV;EqCp4HQ;;IAGE,6BAAA;ErCq4HV;EqCj4HM;I/B3KJ,yBAAA;IACA,4BAAA;EN+iIF;EqCl4HQ;;IAGE,yBAAA;ErCm4HV;EqCj4HQ;;IAGE,4BAAA;ErCk4HV;AACF;AsCtmIA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AtCumIF;AsCnmIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AtCqmIF;AqB5nIM;EiBUN;IjBTQ,gBAAA;ErB+nIN;AACF;AsCxmIE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AtC0mIJ;AsCxmII;EACE,qDAAA;EACA,iDAAA;AtC0mIN;AsCrmIE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AtCumIJ;AqBrpIM;EiBqCJ;IjBpCM,gBAAA;ErBwpIN;AACF;AsCzmIE;EACE,UAAA;AtC2mIJ;AsCxmIE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AtC0mIJ;AsCtmIA;EACE,gBAAA;AtCwmIF;AsCrmIA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AtCumIF;AsCrmIE;EhC7DE,yDAAA;EACA,0DAAA;ANqqIJ;AsCtmII;EhChEA,+DAAA;EACA,gEAAA;ANyqIJ;AsCrmIE;EACE,aAAA;AtCumIJ;AsCnmIE;EhC5DE,6DAAA;EACA,4DAAA;ANkqIJ;AsCnmIM;EhChEF,mEAAA;EACA,kEAAA;ANsqIJ;AsClmII;EhCrEA,6DAAA;EACA,4DAAA;AN0qIJ;AsChmIA;EACE,8EAAA;AtCkmIF;AsCzlIE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AN0sIJ;AsCzlII;EAAgB,aAAA;AtC4lIpB;AsC3lII;EAAe,gBAAA;AtC8lInB;AsC3lII;;;EhCrHA,gBAAA;ANqtIJ;AsCrlII;EACE,iEAAA;EACA,wEAAA;AtCulIN;AuC5uIA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AN2uIJ;AuCruIE;EACE,iDAAA;AvCuuIJ;AuCruII;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AvCuuIN;AuCnuIE;EACE,6CAAA;AvCquIJ;AwC1wIA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AR8xIF;AwCvwIA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AxCywIF;AqB1xIM;EmBQN;InBPQ,gBAAA;ErB6xIN;AACF;AwC5wIE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AxC6wIJ;AwC1wIE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AxC4wIJ;AwCzwIE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AxC0wIJ;AwCvwIE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AxCwwIJ;AwCnwIE;EACE,8CnC8sCgC;ALujGpC;AwChwIM;ElC9BF,0DAAA;EACA,6DAAA;ANiyIJ;AwC9vIM;ElClDF,2DAAA;EACA,8DAAA;ANmzIJ;AwCjvIA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;AzCs1IF;AwCnvIA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;AzC41IF;A0C91IA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ANk2IJ;A0Cz1IE;EACE,aAAA;A1C21IJ;A0Ct1IA;EACE,kBAAA;EACA,SAAA;A1Cw1IF;A2Cx3IA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AN23IJ;A2Cn3IA;EAEE,cAAA;A3Co3IF;A2Ch3IA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A3Ck3IF;A2C12IA;EACE,mBtCs+C8B;ALs4FhC;A2Cz2IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A3C22IJ;A2Cn2IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A3Cq2IJ;A2Cz2IE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A3C22IJ;A2C/2IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A3Ci3IJ;A2Cr3IE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A3Cu3IJ;A2C33IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A3C63IJ;A2Cj4IE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A3Cm4IJ;A2Cv4IE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A3Cy4IJ;A2C74IE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A3C+4IJ;A4C38IE;EACE;IAAK,gDAAA;E5C88IP;AACF;A4C18IA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;ANk9IJ;A4Cr8IA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A5Cu8IF;AqB59IM;EuBYN;IvBXQ,gBAAA;ErB+9IN;AACF;A4Cz8IA;EtBAE,qMAAA;EsBEA,oEAAA;A5C28IF;A4Cx8IA;EACE,iBAAA;A5C08IF;A4Cv8IA;EACE,WAAA;A5Cy8IF;A4Cr8IE;EACE,kDAAA;A5Cu8IJ;A4Cp8IM;EAJJ;IAKM,eAAA;E5Cu8IN;AACF;A6CngJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AN4gJJ;A6C7/IA;EACE,qBAAA;EACA,sBAAA;A7C+/IF;A6C7/IE;EAEE,oCAAA;EACA,0BAAA;A7C8/IJ;A6Ct/IA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A7Cw/IF;A6Ct/IE;EvC9BE,+BAAA;EACA,gCAAA;ANuhJJ;A6Ct/IE;EvCpBE,mCAAA;EACA,kCAAA;AN6gJJ;A6Ct/IE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A7Cu/IJ;A6Cn/IE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A7Cq/IJ;A6Cj/IE;EACE,mBAAA;A7Cm/IJ;A6Cj/II;EACE,wDAAA;EACA,mDAAA;A7Cm/IN;A6Cz+IA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A7C2+IF;A6Cv+II;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A7Cw+IN;A6Cr+II;EACE,+CAAA;EACA,uDAAA;A7Cu+IN;A6C19II;EACE,mBAAA;A7C49IN;A6Cz9IQ;EvCzDJ,6DAAA;EAZA,0BAAA;ANkiJJ;A6Cx9IQ;EvC1EJ,2DAAA;EAYA,4BAAA;AN0hJJ;A6Cv9IQ;EACE,aAAA;A7Cy9IV;A6Ct9IQ;EACE,mDAAA;EACA,oBAAA;A7Cw9IV;A6Ct9IU;EACE,yDAAA;EACA,oDAAA;A7Cw9IZ;AahjJI;EgCgEA;IACE,mBAAA;E7Cm/IJ;E6Ch/IM;IvCzDJ,6DAAA;IAZA,0BAAA;ENyjJF;E6C/+IM;IvC1EJ,2DAAA;IAYA,4BAAA;ENijJF;E6C9+IM;IACE,aAAA;E7Cg/IR;E6C7+IM;IACE,mDAAA;IACA,oBAAA;E7C++IR;E6C7+IQ;IACE,yDAAA;IACA,oDAAA;E7C++IV;AACF;AaxkJI;EgCgEA;IACE,mBAAA;E7C2gJJ;E6CxgJM;IvCzDJ,6DAAA;IAZA,0BAAA;ENilJF;E6CvgJM;IvC1EJ,2DAAA;IAYA,4BAAA;ENykJF;E6CtgJM;IACE,aAAA;E7CwgJR;E6CrgJM;IACE,mDAAA;IACA,oBAAA;E7CugJR;E6CrgJQ;IACE,yDAAA;IACA,oDAAA;E7CugJV;AACF;AahmJI;EgCgEA;IACE,mBAAA;E7CmiJJ;E6ChiJM;IvCzDJ,6DAAA;IAZA,0BAAA;ENymJF;E6C/hJM;IvC1EJ,2DAAA;IAYA,4BAAA;ENimJF;E6C9hJM;IACE,aAAA;E7CgiJR;E6C7hJM;IACE,mDAAA;IACA,oBAAA;E7C+hJR;E6C7hJQ;IACE,yDAAA;IACA,oDAAA;E7C+hJV;AACF;AaxnJI;EgCgEA;IACE,mBAAA;E7C2jJJ;E6CxjJM;IvCzDJ,6DAAA;IAZA,0BAAA;ENioJF;E6CvjJM;IvC1EJ,2DAAA;IAYA,4BAAA;ENynJF;E6CtjJM;IACE,aAAA;E7CwjJR;E6CrjJM;IACE,mDAAA;IACA,oBAAA;E7CujJR;E6CrjJQ;IACE,yDAAA;IACA,oDAAA;E7CujJV;AACF;AahpJI;EgCgEA;IACE,mBAAA;E7CmlJJ;E6ChlJM;IvCzDJ,6DAAA;IAZA,0BAAA;ENypJF;E6C/kJM;IvC1EJ,2DAAA;IAYA,4BAAA;ENipJF;E6C9kJM;IACE,aAAA;E7CglJR;E6C7kJM;IACE,mDAAA;IACA,oBAAA;E7C+kJR;E6C7kJQ;IACE,yDAAA;IACA,oDAAA;E7C+kJV;AACF;A6ClkJA;EvClJI,gBAAA;ANutJJ;A6ClkJE;EACE,mDAAA;A7CokJJ;A6ClkJI;EACE,sBAAA;A7CokJN;A6CvjJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A7CyjJJ;A6CnkJE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A7CqkJJ;A6C/kJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A7CilJJ;A6C3lJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A7C6lJJ;A6CvmJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A7CymJJ;A6CnnJE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A7CqnJJ;A6C/nJE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A7CioJJ;A6C3oJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A7C6oJJ;A8C30JA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A9C00JF;A8Cv0JE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A9Cy0JJ;A8Ct0JE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A9Cw0JJ;A8Cr0JE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;A9Cs0JJ;A8C9zJA;EAHE,iEAAA;A9Co0JF;A8C7zJA;;EAEE,uBAAA;A9C+zJF;AG12JI;E2CkCF,iEAAA;A9C20JF;A+C53JA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ANo4JJ;A+Cz3JE;EACE,UAAA;A/C23JJ;A+Cx3JE;EACE,aAAA;A/C03JJ;A+Ct3JA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;A/Cu3JF;A+Cr3JE;EACE,sCAAA;A/Cu3JJ;A+Cn3JA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ANs5JJ;A+Cp3JE;EACE,oDAAA;EACA,sCAAA;A/Cs3JJ;A+Cl3JA;EACE,kCAAA;EACA,qBAAA;A/Co3JF;AgDl7JA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AhD+6JF;AgDx6JA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AhDy6JF;AgDt6JE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AhDw6JJ;AqBl9JM;E2BwCJ;I3BvCM,gBAAA;ErBq9JN;AACF;AgD36JE;EACE,e3Cg8CgC;AL6+GpC;AgDz6JE;EACE,sB3C67CgC;AL8+GpC;AgDv6JA;EACE,+CAAA;AhDy6JF;AgDv6JE;EACE,gBAAA;EACA,gBAAA;AhDy6JJ;AgDt6JE;EACE,gBAAA;AhDw6JJ;AgDp6JA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AhDs6JF;AgDl6JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AhDi6JF;AgD75JA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AhDk6J9D;AiD9gKE;EAAS,UAAA;AjDihKX;AiDhhKE;EAAS,mCD2GiF;AhDw6J5F;AgDn6JA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AN2gKJ;AgDp6JE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AhDq6JJ;AgDh6JA;EACE,gBAAA;EACA,8CAAA;AhDk6JF;AgD75JA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AhD65JF;AgDz5JA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;ANyhKJ;AgDv5JE;EACE,8CAAA;AhDy5JJ;AaxgKI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EhDs5JF;EgDl5JA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EhDo5JF;EgDj5JA;IACE,uBAAA;EhDm5JF;AACF;AathKI;EmCuIF;;IAEE,uBAAA;EhDk5JF;AACF;Aa5hKI;EmC8IF;IACE,wBAAA;EhDi5JF;AACF;AgDx4JI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AhD04JN;AgDx4JM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;ANwlKJ;AgDv4JM;;E1CjNF,gBAAA;AN4lKJ;AgDt4JM;EACE,gBAAA;AhDw4JR;AatiKI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EhD65JJ;EgD35JI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EN2mKF;EgD15JI;;I1CjNF,gBAAA;EN+mKF;EgDz5JI;IACE,gBAAA;EhD25JN;AACF;Aa1jKI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EhDi7JJ;EgD/6JI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EN+nKF;EgD96JI;;I1CjNF,gBAAA;ENmoKF;EgD76JI;IACE,gBAAA;EhD+6JN;AACF;Aa9kKI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EhDq8JJ;EgDn8JI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ENmpKF;EgDl8JI;;I1CjNF,gBAAA;ENupKF;EgDj8JI;IACE,gBAAA;EhDm8JN;AACF;AalmKI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EhDy9JJ;EgDv9JI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ENuqKF;EgDt9JI;;I1CjNF,gBAAA;EN2qKF;EgDr9JI;IACE,gBAAA;EhDu9JN;AACF;AatnKI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EhD6+JJ;EgD3+JI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EN2rKF;EgD1+JI;;I1CjNF,gBAAA;EN+rKF;EgDz+JI;IACE,gBAAA;EhD2+JN;AACF;AkDrtKA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AlD6tKF;AkD3tKE;EAAS,kCAAA;AlD8tKX;AkD5tKE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AlD8tKJ;AkD5tKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlD8tKN;AkDztKA;EACE,iDAAA;AlD2tKF;AkDztKE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AlD2tKJ;AArwKA;EkD8CA,qBAAA;AlD0tKA;AkDztKA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AlD2tKF;AkDztKE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AlD2tKJ;AAlxKA;EkD2DA,mBAAA;AlD0tKA;AkDxtKA;EACE,8CAAA;AlD0tKF;AkDxtKE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AlD0tKJ;AA7xKA;EkDuEA,qBAAA;AlDytKA;AkDxtKA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AlD0tKF;AkDxtKE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AlD0tKJ;AA1yKA;EkDoFA,mBAAA;AlDytKA;AkDvsKA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AN2yKJ;AoD9zKA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;ANw1KJ;AoDp0KE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDs0KJ;AoDp0KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ApDq0KN;AoD/zKE;EACE,oFAAA;ApDi0KJ;AoD/zKI;EAEE,wFAAA;ApDg0KN;AoD7zKI;EACE,SAAA;EACA,gDAAA;ApD+zKN;AoD5zKI;EACE,sCAAA;EACA,sCAAA;ApD8zKN;AA73KA;EoDoEA,qBAAA;ApD4zKA;AoD1zKE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ApD4zKJ;AoD1zKI;EAEE,kIAAA;ApD2zKN;AoDxzKI;EACE,OAAA;EACA,kDAAA;ApD0zKN;AoDvzKI;EACE,oCAAA;EACA,wCAAA;ApDyzKN;AAh5KA;EoD4FA,mBAAA;ApDuzKA;AoDpzKE;EACE,iFAAA;ApDszKJ;AoDpzKI;EAEE,wFAAA;ApDqzKN;AoDlzKI;EACE,MAAA;EACA,mDAAA;ApDozKN;AoDjzKI;EACE,mCAAA;EACA,yCAAA;ApDmzKN;AoD9yKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ApDgzKJ;AA36KA;EoD+HA,qBAAA;ApD+yKA;AoD7yKE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ApD+yKJ;AoD7yKI;EAEE,kIAAA;ApD8yKN;AoD3yKI;EACE,QAAA;EACA,iDAAA;ApD6yKN;AoD1yKI;EACE,qCAAA;EACA,uCAAA;ApD4yKN;AA97KA;EoDuJA,mBAAA;ApD0yKA;AoDxxKA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;ANu7KJ;AoDzxKE;EACE,aAAA;ApD2xKJ;AoDvxKA;EACE,0EAAA;EACA,mCAAA;ApDyxKF;AqD98KA;EACE,kBAAA;ArDg9KF;AqD78KA;EACE,mBAAA;ArD+8KF;AqD58KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArD88KF;AsDp+KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDs+KJ;AqD/8KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;ArDi9KF;AqBh+KM;EgCQN;IhCPQ,gBAAA;ErBm+KN;AACF;AqDn9KA;;;EAGE,cAAA;ArDq9KF;AqDl9KA;;EAEE,2BAAA;ArDo9KF;AqDj9KA;;EAEE,4BAAA;ArDm9KF;AqD18KE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArD48KJ;AqDz8KE;;;EAGE,UAAA;EACA,UAAA;ArD28KJ;AqDx8KE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;ArD08KJ;AqBngLM;EgCqDJ;;IhCpDM,gBAAA;ErBugLN;AACF;AqDv8KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;ArDw8KF;AqB5hLM;EgCkEN;;IhCjEQ,gBAAA;ErBgiLN;AACF;AqD38KE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;AL08HrC;AqD38KA;EACE,OAAA;ArD68KF;AqD18KA;EACE,QAAA;ArD48KF;AqDv8KA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;ArDy8KF;AqDt8KA;EACE,0TAAA;ArDw8KF;AqDt8KA;EACE,yTAAA;ArDw8KF;AqDh8KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;AL8+HrC;AqD/7KE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;ArDg8KJ;AqB9lLM;EgC6IJ;IhC5IM,gBAAA;ErBimLN;AACF;AqDl8KE;EACE,UhDw8CiC;AL4/HrC;AqD37KA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;ArD67KF;AqDl7KA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;ArD07KF;AqDn7KA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;ArDq7KF;AGhoLI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;ArDq8KF;AuDhpLA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AvDipLF;AuD7oLA;EACE;IAAK,0CAAA;EvDgpLL;AACF;AuD7oLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AvD4oLF;AuDzoLA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AvD0oLF;AuDjoLA;EACE;IACE,mBAAA;EvDmoLF;EuDjoLA;IACE,UAAA;IACA,eAAA;EvDmoLF;AACF;AuD/nLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AvD8nLF;AuD3nLA;EACE,wBAAA;EACA,yBAAA;AvD6nLF;AuDznLE;EACE;;IAEE,kCAAA;EvD2nLJ;AACF;AwD5sLA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AxD6sLF;AahpLI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;ExD6rLJ;AACF;AqBxtLM;EmCYJ;InCXM,gBAAA;ErB2tLN;AACF;AarqLI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDosLN;EwDjsLI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDmsLN;EwDhsLI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExDksLN;EwD/rLI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExDisLN;EwD9rLI;IAEE,eAAA;ExD+rLN;EwD5rLI;IAGE,mBAAA;ExD4rLN;AACF;AaztLI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExD2rLN;EwDzrLM;IACE,aAAA;ExD2rLR;EwDxrLM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDyrLR;AACF;Aa7tLI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;ExD0wLJ;AACF;AqBryLM;EmCYJ;InCXM,gBAAA;ErBwyLN;AACF;AalvLI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDixLN;EwD9wLI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDgxLN;EwD7wLI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExD+wLN;EwD5wLI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExD8wLN;EwD3wLI;IAEE,eAAA;ExD4wLN;EwDzwLI;IAGE,mBAAA;ExDywLN;AACF;AatyLI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDwwLN;EwDtwLM;IACE,aAAA;ExDwwLR;EwDrwLM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDswLR;AACF;Aa1yLI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;ExDu1LJ;AACF;AqBl3LM;EmCYJ;InCXM,gBAAA;ErBq3LN;AACF;Aa/zLI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExD81LN;EwD31LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExD61LN;EwD11LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExD41LN;EwDz1LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExD21LN;EwDx1LI;IAEE,eAAA;ExDy1LN;EwDt1LI;IAGE,mBAAA;ExDs1LN;AACF;Aan3LI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDq1LN;EwDn1LM;IACE,aAAA;ExDq1LR;EwDl1LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDm1LR;AACF;Aav3LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;ExDo6LJ;AACF;AqB/7LM;EmCYJ;InCXM,gBAAA;ErBk8LN;AACF;Aa54LI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExD26LN;EwDx6LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExD06LN;EwDv6LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExDy6LN;EwDt6LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExDw6LN;EwDr6LI;IAEE,eAAA;ExDs6LN;EwDn6LI;IAGE,mBAAA;ExDm6LN;AACF;Aah8LI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDk6LN;EwDh6LM;IACE,aAAA;ExDk6LR;EwD/5LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDg6LR;AACF;Aap8LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;ExDi/LJ;AACF;AqB5gMM;EmCYJ;InCXM,gBAAA;ErB+gMN;AACF;Aaz9LI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDw/LN;EwDr/LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDu/LN;EwDp/LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExDs/LN;EwDn/LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExDq/LN;EwDl/LI;IAEE,eAAA;ExDm/LN;EwDh/LI;IAGE,mBAAA;ExDg/LN;AACF;Aa7gMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExD++LN;EwD7+LM;IACE,aAAA;ExD++LR;EwD5+LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExD6+LR;AACF;AwD7jME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AxD6jMN;AqBvlMM;EmCYJ;InCXM,gBAAA;ErB0lMN;AACF;AwDhkMM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AxDkkMR;AwD/jMM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AxDikMR;AwD9jMM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AxDgkMR;AwD7jMM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AxD+jMR;AwD5jMM;EAEE,eAAA;AxD6jMR;AwD1jMM;EAGE,mBAAA;AxD0jMR;AwD/hMA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;AL4oMX;AiDnpME;EAAS,UAAA;AjDspMX;AiDrpME;EAAS,Y5Cm+CyB;ALqrJpC;AwD1iMA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AxD4iMF;AwD1iME;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AxD2iMJ;AwDviMA;EACE,gBAAA;EACA,kDAAA;AxDyiMF;AwDtiMA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AxDwiMF;AyDzrMA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;AL24JpC;AyDzrME;EACE,qBAAA;EACA,WAAA;AzD2rMJ;AyDtrMA;EACE,iBAAA;AzDwrMF;AyDrrMA;EACE,iBAAA;AzDurMF;AyDprMA;EACE,iBAAA;AzDsrMF;AyDjrME;EACE,mDAAA;AzDmrMJ;AyD/qMA;EACE;IACE,YpDmxCgC;EL85JlC;AACF;AyD9qMA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AzDgrMF;AyD7qMA;EACE;IACE,uBAAA;EzD+qMF;AACF;AsD9tME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDguMJ;A0DnuME;EACE,sBAAA;EACA,iFAAA;A1DquMJ;A0DvuME;EACE,sBAAA;EACA,mFAAA;A1DyuMJ;A0D3uME;EACE,sBAAA;EACA,iFAAA;A1D6uMJ;A0D/uME;EACE,sBAAA;EACA,8EAAA;A1DivMJ;A0DnvME;EACE,sBAAA;EACA,iFAAA;A1DqvMJ;A0DvvME;EACE,sBAAA;EACA,gFAAA;A1DyvMJ;A0D3vME;EACE,sBAAA;EACA,+EAAA;A1D6vMJ;A0D/vME;EACE,sBAAA;EACA,8EAAA;A1DiwMJ;A2DnwME;EACE,wEAAA;EACA,kGAAA;A3DqwMJ;A2DlwMM;EAGE,8DAAA;EACA,wFAAA;A3DkwMR;A2D3wME;EACE,0EAAA;EACA,oGAAA;A3D6wMJ;A2D1wMM;EAGE,8DAAA;EACA,wFAAA;A3D0wMR;A2DnxME;EACE,wEAAA;EACA,kGAAA;A3DqxMJ;A2DlxMM;EAGE,8DAAA;EACA,wFAAA;A3DkxMR;A2D3xME;EACE,qEAAA;EACA,+FAAA;A3D6xMJ;A2D1xMM;EAGE,+DAAA;EACA,yFAAA;A3D0xMR;A2DnyME;EACE,wEAAA;EACA,kGAAA;A3DqyMJ;A2DlyMM;EAGE,+DAAA;EACA,yFAAA;A3DkyMR;A2D3yME;EACE,uEAAA;EACA,iGAAA;A3D6yMJ;A2D1yMM;EAGE,8DAAA;EACA,wFAAA;A3D0yMR;A2DnzME;EACE,sEAAA;EACA,gGAAA;A3DqzMJ;A2DlzMM;EAGE,gEAAA;EACA,0FAAA;A3DkzMR;A2D3zME;EACE,qEAAA;EACA,+FAAA;A3D6zMJ;A2D1zMM;EAGE,6DAAA;EACA,uFAAA;A3D0zMR;A2DnzMA;EACE,+EAAA;EACA,yGAAA;A3DqzMF;A2DlzMI;EAEE,kFAAA;EACA,4GAAA;A3DmzMN;A4D70MA;EACE,UAAA;EAEA,kJAAA;A5D80MF;A6Dj1MA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A7Dm1MF;A6Dj1ME;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A7Dm1MJ;AqB50MM;EwCZJ;IxCaM,gBAAA;ErB+0MN;AACF;A6Dj1MI;EACE,mEAAA;A7Dm1MN;A8Dt2MA;EACE,kBAAA;EACA,WAAA;A9Dw2MF;A8Dt2ME;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A9Dw2MJ;A8Dr2ME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A9Du2MJ;A8Dl2ME;EACE,uBAAA;A9Do2MJ;A8Dr2ME;EACE,sBAAA;A9Du2MJ;A8Dx2ME;EACE,yBAAA;A9D02MJ;A8D32ME;EACE,iCAAA;A9D62MJ;A+Dl4MA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;AL6xKpC;A+Dj4MA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;ALoyKpC;A+D33MI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;AL0yKpC;A+D13MI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AL+yKpC;Aa71MI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ELqzKlC;E+Dr4ME;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EL0zKlC;AACF;Aaz2MI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ELi0KlC;E+Dj5ME;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ELs0KlC;AACF;Aar3MI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EL60KlC;E+D75ME;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ELk1KlC;AACF;Aaj4MI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ELy1KlC;E+Dz6ME;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EL81KlC;AACF;Aa74MI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ELq2KlC;E+Dr7ME;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EL02KlC;AACF;AgEv9MA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AhEy9MF;AgEt9MA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AhEw9MF;AiEh+MA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AlEg+MF;AkE79ME;;EACE,6BAAA;AlEg+MJ;AkE59ME;;EACE,2BAAA;AlE+9MJ;AmEl/ME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;AnEo/MJ;AoE5/MA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ArE+/MF;AsErgNA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AL40L9B;AuE38MQ;EAOI,mCAAA;AvEu8MZ;AuE98MQ;EAOI,8BAAA;AvE08MZ;AuEj9MQ;EAOI,iCAAA;AvE68MZ;AuEp9MQ;EAOI,iCAAA;AvEg9MZ;AuEv9MQ;EAOI,sCAAA;AvEm9MZ;AuE19MQ;EAOI,mCAAA;AvEs9MZ;AuE79MQ;EAOI,sBAAA;AvEy9MZ;AuEh+MQ;EAOI,uBAAA;AvE49MZ;AuEn+MQ;EAOI,sBAAA;AvE+9MZ;AuEt+MQ;EAOI,8BAAA;AvEk+MZ;AuEz+MQ;EAOI,4BAAA;AvEq+MZ;AuE5+MQ;EAOI,2BAAA;AvEw+MZ;AuE/+MQ;EAOI,iCAAA;AvE2+MZ;AuEl/MQ;EAOI,2BAAA;AvE8+MZ;AuEr/MQ;EAOI,qBAAA;AvEi/MZ;AuEx/MQ;EAOI,wBAAA;AvEo/MZ;AuE3/MQ;EAOI,uBAAA;AvEu/MZ;AuE9/MQ;EAOI,wBAAA;AvE0/MZ;AuEjgNQ;EAOI,qBAAA;AvE6/MZ;AuEpgNQ;EAOI,yBAAA;AvEggNZ;AuEvgNQ;EAOI,2BAAA;AvEmgNZ;AuE1gNQ;EAOI,4BAAA;AvEsgNZ;AuE7gNQ;EAOI,2BAAA;AvEygNZ;AuEhhNQ;EAOI,2BAAA;AvE4gNZ;AuEnhNQ;EAOI,6BAAA;AvE+gNZ;AuEthNQ;EAOI,8BAAA;AvEkhNZ;AuEzhNQ;EAOI,6BAAA;AvEqhNZ;AuE5hNQ;EAOI,2BAAA;AvEwhNZ;AuE/hNQ;EAOI,6BAAA;AvE2hNZ;AuEliNQ;EAOI,8BAAA;AvE8hNZ;AuEriNQ;EAOI,6BAAA;AvEiiNZ;AuExiNQ;EAOI,0BAAA;AvEoiNZ;AuE3iNQ;EAOI,gCAAA;AvEuiNZ;AuE9iNQ;EAOI,yBAAA;AvE0iNZ;AuEjjNQ;EAOI,wBAAA;AvE6iNZ;AuEpjNQ;EAOI,+BAAA;AvEgjNZ;AuEvjNQ;EAOI,yBAAA;AvEmjNZ;AuE1jNQ;EAOI,6BAAA;AvEsjNZ;AuE7jNQ;EAOI,8BAAA;AvEyjNZ;AuEhkNQ;EAOI,wBAAA;AvE4jNZ;AuEnkNQ;EAOI,+BAAA;AvE+jNZ;AuEtkNQ;EAOI,wBAAA;AvEkkNZ;AuEzkNQ;EAOI,2CAAA;AvEqkNZ;AuE5kNQ;EAOI,8CAAA;AvEwkNZ;AuE/kNQ;EAOI,8CAAA;AvE2kNZ;AuEllNQ;EAOI,2BAAA;AvE8kNZ;AuE/lNQ;EACE,gFAAA;AvEimNV;AuElmNQ;EACE,kFAAA;AvEomNV;AuErmNQ;EACE,gFAAA;AvEumNV;AuExmNQ;EACE,6EAAA;AvE0mNV;AuE3mNQ;EACE,gFAAA;AvE6mNV;AuE9mNQ;EACE,+EAAA;AvEgnNV;AuEjnNQ;EACE,8EAAA;AvEmnNV;AuEpnNQ;EACE,6EAAA;AvEsnNV;AuE7mNQ;EAOI,2BAAA;AvEymNZ;AuEhnNQ;EAOI,6BAAA;AvE4mNZ;AuEnnNQ;EAOI,6BAAA;AvE+mNZ;AuEtnNQ;EAOI,0BAAA;AvEknNZ;AuEznNQ;EAOI,2BAAA;AvEqnNZ;AuE5nNQ;EAOI,iBAAA;AvEwnNZ;AuE/nNQ;EAOI,mBAAA;AvE2nNZ;AuEloNQ;EAOI,oBAAA;AvE8nNZ;AuEroNQ;EAOI,oBAAA;AvEioNZ;AuExoNQ;EAOI,sBAAA;AvEooNZ;AuE3oNQ;EAOI,uBAAA;AvEuoNZ;AuE9oNQ;EAOI,kBAAA;AvE0oNZ;AuEjpNQ;EAOI,oBAAA;AvE6oNZ;AuEppNQ;EAOI,qBAAA;AvEgpNZ;AuEvpNQ;EAOI,mBAAA;AvEmpNZ;AuE1pNQ;EAOI,qBAAA;AvEspNZ;AuE7pNQ;EAOI,sBAAA;AvEypNZ;AuEhqNQ;EAOI,2CAAA;AvE4pNZ;AuEnqNQ;EAOI,sCAAA;AvE+pNZ;AuEtqNQ;EAOI,sCAAA;AvEkqNZ;AuEzqNQ;EAOI,uFAAA;AvEqqNZ;AuE5qNQ;EAOI,oBAAA;AvEwqNZ;AuE/qNQ;EAOI,2FAAA;AvE2qNZ;AuElrNQ;EAOI,wBAAA;AvE8qNZ;AuErrNQ;EAOI,6FAAA;AvEirNZ;AuExrNQ;EAOI,0BAAA;AvEorNZ;AuE3rNQ;EAOI,8FAAA;AvEurNZ;AuE9rNQ;EAOI,2BAAA;AvE0rNZ;AuEjsNQ;EAOI,4FAAA;AvE6rNZ;AuEpsNQ;EAOI,yBAAA;AvEgsNZ;AuEvsNQ;EAIQ,sBAAA;EAGJ,8EAAA;AvEosNZ;AuE3sNQ;EAIQ,sBAAA;EAGJ,gFAAA;AvEwsNZ;AuE/sNQ;EAIQ,sBAAA;EAGJ,8EAAA;AvE4sNZ;AuEntNQ;EAIQ,sBAAA;EAGJ,2EAAA;AvEgtNZ;AuEvtNQ;EAIQ,sBAAA;EAGJ,8EAAA;AvEotNZ;AuE3tNQ;EAIQ,sBAAA;EAGJ,6EAAA;AvEwtNZ;AuE/tNQ;EAIQ,sBAAA;EAGJ,4EAAA;AvE4tNZ;AuEnuNQ;EAIQ,sBAAA;EAGJ,2EAAA;AvEguNZ;AuEvuNQ;EAIQ,sBAAA;EAGJ,4EAAA;AvEouNZ;AuE3uNQ;EAIQ,sBAAA;EAGJ,4EAAA;AvEwuNZ;AuE/uNQ;EAOI,wDAAA;AvE2uNZ;AuElvNQ;EAOI,0DAAA;AvE8uNZ;AuErvNQ;EAOI,wDAAA;AvEivNZ;AuExvNQ;EAOI,qDAAA;AvEovNZ;AuE3vNQ;EAOI,wDAAA;AvEuvNZ;AuE9vNQ;EAOI,uDAAA;AvE0vNZ;AuEjwNQ;EAOI,sDAAA;AvE6vNZ;AuEpwNQ;EAOI,qDAAA;AvEgwNZ;AuEvwNQ;EAOI,4BAAA;AvEmwNZ;AuE1wNQ;EAOI,4BAAA;AvEswNZ;AuE7wNQ;EAOI,4BAAA;AvEywNZ;AuEhxNQ;EAOI,4BAAA;AvE4wNZ;AuEnxNQ;EAOI,4BAAA;AvE+wNZ;AuEhyNQ;EACE,wBAAA;AvEkyNV;AuEnyNQ;EACE,yBAAA;AvEqyNV;AuEtyNQ;EACE,wBAAA;AvEwyNV;AuEzyNQ;EACE,yBAAA;AvE2yNV;AuE5yNQ;EACE,sBAAA;AvE8yNV;AuEryNQ;EAOI,qBAAA;AvEiyNZ;AuExyNQ;EAOI,qBAAA;AvEoyNZ;AuE3yNQ;EAOI,qBAAA;AvEuyNZ;AuE9yNQ;EAOI,sBAAA;AvE0yNZ;AuEjzNQ;EAOI,sBAAA;AvE6yNZ;AuEpzNQ;EAOI,0BAAA;AvEgzNZ;AuEvzNQ;EAOI,uBAAA;AvEmzNZ;AuE1zNQ;EAOI,2BAAA;AvEszNZ;AuE7zNQ;EAOI,sBAAA;AvEyzNZ;AuEh0NQ;EAOI,sBAAA;AvE4zNZ;AuEn0NQ;EAOI,sBAAA;AvE+zNZ;AuEt0NQ;EAOI,uBAAA;AvEk0NZ;AuEz0NQ;EAOI,uBAAA;AvEq0NZ;AuE50NQ;EAOI,2BAAA;AvEw0NZ;AuE/0NQ;EAOI,wBAAA;AvE20NZ;AuEl1NQ;EAOI,4BAAA;AvE80NZ;AuEr1NQ;EAOI,yBAAA;AvEi1NZ;AuEx1NQ;EAOI,8BAAA;AvEo1NZ;AuE31NQ;EAOI,iCAAA;AvEu1NZ;AuE91NQ;EAOI,sCAAA;AvE01NZ;AuEj2NQ;EAOI,yCAAA;AvE61NZ;AuEp2NQ;EAOI,uBAAA;AvEg2NZ;AuEv2NQ;EAOI,uBAAA;AvEm2NZ;AuE12NQ;EAOI,yBAAA;AvEs2NZ;AuE72NQ;EAOI,yBAAA;AvEy2NZ;AuEh3NQ;EAOI,0BAAA;AvE42NZ;AuEn3NQ;EAOI,4BAAA;AvE+2NZ;AuEt3NQ;EAOI,kCAAA;AvEk3NZ;AuEz3NQ;EAOI,sCAAA;AvEq3NZ;AuE53NQ;EAOI,oCAAA;AvEw3NZ;AuE/3NQ;EAOI,kCAAA;AvE23NZ;AuEl4NQ;EAOI,yCAAA;AvE83NZ;AuEr4NQ;EAOI,wCAAA;AvEi4NZ;AuEx4NQ;EAOI,wCAAA;AvEo4NZ;AuE34NQ;EAOI,kCAAA;AvEu4NZ;AuE94NQ;EAOI,gCAAA;AvE04NZ;AuEj5NQ;EAOI,8BAAA;AvE64NZ;AuEp5NQ;EAOI,gCAAA;AvEg5NZ;AuEv5NQ;EAOI,+BAAA;AvEm5NZ;AuE15NQ;EAOI,oCAAA;AvEs5NZ;AuE75NQ;EAOI,kCAAA;AvEy5NZ;AuEh6NQ;EAOI,gCAAA;AvE45NZ;AuEn6NQ;EAOI,uCAAA;AvE+5NZ;AuEt6NQ;EAOI,sCAAA;AvEk6NZ;AuEz6NQ;EAOI,iCAAA;AvEq6NZ;AuE56NQ;EAOI,2BAAA;AvEw6NZ;AuE/6NQ;EAOI,iCAAA;AvE26NZ;AuEl7NQ;EAOI,+BAAA;AvE86NZ;AuEr7NQ;EAOI,6BAAA;AvEi7NZ;AuEx7NQ;EAOI,+BAAA;AvEo7NZ;AuE37NQ;EAOI,8BAAA;AvEu7NZ;AuE97NQ;EAOI,oBAAA;AvE07NZ;AuEj8NQ;EAOI,mBAAA;AvE67NZ;AuEp8NQ;EAOI,mBAAA;AvEg8NZ;AuEv8NQ;EAOI,mBAAA;AvEm8NZ;AuE18NQ;EAOI,mBAAA;AvEs8NZ;AuE78NQ;EAOI,mBAAA;AvEy8NZ;AuEh9NQ;EAOI,mBAAA;AvE48NZ;AuEn9NQ;EAOI,mBAAA;AvE+8NZ;AuEt9NQ;EAOI,oBAAA;AvEk9NZ;AuEz9NQ;EAOI,0BAAA;AvEq9NZ;AuE59NQ;EAOI,yBAAA;AvEw9NZ;AuE/9NQ;EAOI,uBAAA;AvE29NZ;AuEl+NQ;EAOI,yBAAA;AvE89NZ;AuEr+NQ;EAOI,uBAAA;AvEi+NZ;AuEx+NQ;EAOI,uBAAA;AvEo+NZ;AuE3+NQ;EAOI,0BAAA;EAAA,yBAAA;AvEw+NZ;AuE/+NQ;EAOI,gCAAA;EAAA,+BAAA;AvE4+NZ;AuEn/NQ;EAOI,+BAAA;EAAA,8BAAA;AvEg/NZ;AuEv/NQ;EAOI,6BAAA;EAAA,4BAAA;AvEo/NZ;AuE3/NQ;EAOI,+BAAA;EAAA,8BAAA;AvEw/NZ;AuE//NQ;EAOI,6BAAA;EAAA,4BAAA;AvE4/NZ;AuEngOQ;EAOI,6BAAA;EAAA,4BAAA;AvEggOZ;AuEvgOQ;EAOI,wBAAA;EAAA,2BAAA;AvEogOZ;AuE3gOQ;EAOI,8BAAA;EAAA,iCAAA;AvEwgOZ;AuE/gOQ;EAOI,6BAAA;EAAA,gCAAA;AvE4gOZ;AuEnhOQ;EAOI,2BAAA;EAAA,8BAAA;AvEghOZ;AuEvhOQ;EAOI,6BAAA;EAAA,gCAAA;AvEohOZ;AuE3hOQ;EAOI,2BAAA;EAAA,8BAAA;AvEwhOZ;AuE/hOQ;EAOI,2BAAA;EAAA,8BAAA;AvE4hOZ;AuEniOQ;EAOI,wBAAA;AvE+hOZ;AuEtiOQ;EAOI,8BAAA;AvEkiOZ;AuEziOQ;EAOI,6BAAA;AvEqiOZ;AuE5iOQ;EAOI,2BAAA;AvEwiOZ;AuE/iOQ;EAOI,6BAAA;AvE2iOZ;AuEljOQ;EAOI,2BAAA;AvE8iOZ;AuErjOQ;EAOI,2BAAA;AvEijOZ;AuExjOQ;EAOI,0BAAA;AvEojOZ;AuE3jOQ;EAOI,gCAAA;AvEujOZ;AuE9jOQ;EAOI,+BAAA;AvE0jOZ;AuEjkOQ;EAOI,6BAAA;AvE6jOZ;AuEpkOQ;EAOI,+BAAA;AvEgkOZ;AuEvkOQ;EAOI,6BAAA;AvEmkOZ;AuE1kOQ;EAOI,6BAAA;AvEskOZ;AuE7kOQ;EAOI,2BAAA;AvEykOZ;AuEhlOQ;EAOI,iCAAA;AvE4kOZ;AuEnlOQ;EAOI,gCAAA;AvE+kOZ;AuEtlOQ;EAOI,8BAAA;AvEklOZ;AuEzlOQ;EAOI,gCAAA;AvEqlOZ;AuE5lOQ;EAOI,8BAAA;AvEwlOZ;AuE/lOQ;EAOI,8BAAA;AvE2lOZ;AuElmOQ;EAOI,yBAAA;AvE8lOZ;AuErmOQ;EAOI,+BAAA;AvEimOZ;AuExmOQ;EAOI,8BAAA;AvEomOZ;AuE3mOQ;EAOI,4BAAA;AvEumOZ;AuE9mOQ;EAOI,8BAAA;AvE0mOZ;AuEjnOQ;EAOI,4BAAA;AvE6mOZ;AuEpnOQ;EAOI,4BAAA;AvEgnOZ;AuEvnOQ;EAOI,qBAAA;AvEmnOZ;AuE1nOQ;EAOI,2BAAA;AvEsnOZ;AuE7nOQ;EAOI,0BAAA;AvEynOZ;AuEhoOQ;EAOI,wBAAA;AvE4nOZ;AuEnoOQ;EAOI,0BAAA;AvE+nOZ;AuEtoOQ;EAOI,wBAAA;AvEkoOZ;AuEzoOQ;EAOI,2BAAA;EAAA,0BAAA;AvEsoOZ;AuE7oOQ;EAOI,iCAAA;EAAA,gCAAA;AvE0oOZ;AuEjpOQ;EAOI,gCAAA;EAAA,+BAAA;AvE8oOZ;AuErpOQ;EAOI,8BAAA;EAAA,6BAAA;AvEkpOZ;AuEzpOQ;EAOI,gCAAA;EAAA,+BAAA;AvEspOZ;AuE7pOQ;EAOI,8BAAA;EAAA,6BAAA;AvE0pOZ;AuEjqOQ;EAOI,yBAAA;EAAA,4BAAA;AvE8pOZ;AuErqOQ;EAOI,+BAAA;EAAA,kCAAA;AvEkqOZ;AuEzqOQ;EAOI,8BAAA;EAAA,iCAAA;AvEsqOZ;AuE7qOQ;EAOI,4BAAA;EAAA,+BAAA;AvE0qOZ;AuEjrOQ;EAOI,8BAAA;EAAA,iCAAA;AvE8qOZ;AuErrOQ;EAOI,4BAAA;EAAA,+BAAA;AvEkrOZ;AuEzrOQ;EAOI,yBAAA;AvEqrOZ;AuE5rOQ;EAOI,+BAAA;AvEwrOZ;AuE/rOQ;EAOI,8BAAA;AvE2rOZ;AuElsOQ;EAOI,4BAAA;AvE8rOZ;AuErsOQ;EAOI,8BAAA;AvEisOZ;AuExsOQ;EAOI,4BAAA;AvEosOZ;AuE3sOQ;EAOI,2BAAA;AvEusOZ;AuE9sOQ;EAOI,iCAAA;AvE0sOZ;AuEjtOQ;EAOI,gCAAA;AvE6sOZ;AuEptOQ;EAOI,8BAAA;AvEgtOZ;AuEvtOQ;EAOI,gCAAA;AvEmtOZ;AuE1tOQ;EAOI,8BAAA;AvEstOZ;AuE7tOQ;EAOI,4BAAA;AvEytOZ;AuEhuOQ;EAOI,kCAAA;AvE4tOZ;AuEnuOQ;EAOI,iCAAA;AvE+tOZ;AuEtuOQ;EAOI,+BAAA;AvEkuOZ;AuEzuOQ;EAOI,iCAAA;AvEquOZ;AuE5uOQ;EAOI,+BAAA;AvEwuOZ;AuE/uOQ;EAOI,0BAAA;AvE2uOZ;AuElvOQ;EAOI,gCAAA;AvE8uOZ;AuErvOQ;EAOI,+BAAA;AvEivOZ;AuExvOQ;EAOI,6BAAA;AvEovOZ;AuE3vOQ;EAOI,+BAAA;AvEuvOZ;AuE9vOQ;EAOI,6BAAA;AvE0vOZ;AuEjwOQ;EAOI,iBAAA;AvE6vOZ;AuEpwOQ;EAOI,uBAAA;AvEgwOZ;AuEvwOQ;EAOI,sBAAA;AvEmwOZ;AuE1wOQ;EAOI,oBAAA;AvEswOZ;AuE7wOQ;EAOI,sBAAA;AvEywOZ;AuEhxOQ;EAOI,oBAAA;AvE4wOZ;AuEnxOQ;EAOI,qBAAA;AvE+wOZ;AuEtxOQ;EAOI,2BAAA;AvEkxOZ;AuEzxOQ;EAOI,0BAAA;AvEqxOZ;AuE5xOQ;EAOI,wBAAA;AvEwxOZ;AuE/xOQ;EAOI,0BAAA;AvE2xOZ;AuElyOQ;EAOI,wBAAA;AvE8xOZ;AuEryOQ;EAOI,wBAAA;AvEiyOZ;AuExyOQ;EAOI,8BAAA;AvEoyOZ;AuE3yOQ;EAOI,6BAAA;AvEuyOZ;AuE9yOQ;EAOI,2BAAA;AvE0yOZ;AuEjzOQ;EAOI,6BAAA;AvE6yOZ;AuEpzOQ;EAOI,2BAAA;AvEgzOZ;AuEvzOQ;EAOI,gDAAA;AvEmzOZ;AuE1zOQ;EAOI,4CAAA;AvEszOZ;AuE7zOQ;EAOI,4CAAA;AvEyzOZ;AuEh0OQ;EAOI,0CAAA;AvE4zOZ;AuEn0OQ;EAOI,4CAAA;AvE+zOZ;AuEt0OQ;EAOI,6BAAA;AvEk0OZ;AuEz0OQ;EAOI,0BAAA;AvEq0OZ;AuE50OQ;EAOI,6BAAA;AvEw0OZ;AuE/0OQ;EAOI,6BAAA;AvE20OZ;AuEl1OQ;EAOI,+BAAA;AvE80OZ;AuEr1OQ;EAOI,2BAAA;AvEi1OZ;AuEx1OQ;EAOI,2BAAA;AvEo1OZ;AuE31OQ;EAOI,2BAAA;AvEu1OZ;AuE91OQ;EAOI,2BAAA;AvE01OZ;AuEj2OQ;EAOI,2BAAA;AvE61OZ;AuEp2OQ;EAOI,8BAAA;AvEg2OZ;AuEv2OQ;EAOI,yBAAA;AvEm2OZ;AuE12OQ;EAOI,4BAAA;AvEs2OZ;AuE72OQ;EAOI,2BAAA;AvEy2OZ;AuEh3OQ;EAOI,yBAAA;AvE42OZ;AuEn3OQ;EAOI,2BAAA;AvE+2OZ;AuEt3OQ;EAOI,4BAAA;AvEk3OZ;AuEz3OQ;EAOI,6BAAA;AvEq3OZ;AuE53OQ;EAOI,gCAAA;AvEw3OZ;AuE/3OQ;EAOI,qCAAA;AvE23OZ;AuEl4OQ;EAOI,wCAAA;AvE83OZ;AuEr4OQ;EAOI,oCAAA;AvEi4OZ;AuEx4OQ;EAOI,oCAAA;AvEo4OZ;AuE34OQ;EAOI,qCAAA;AvEu4OZ;AuE94OQ;EAOI,8BAAA;AvE04OZ;AuEj5OQ;EAOI,8BAAA;AvE64OZ;AA78OA;EuE2CQ,qBAAA;AvEq6OR;AuEv5OQ;EAOI,gCAAA;EAAA,iCAAA;AvEo5OZ;AAp9OA;EuEmFQ,mBAAA;AvEo4OR;AuE95OQ;EAIQ,oBAAA;EAGJ,qEAAA;AvE25OZ;AuEl6OQ;EAIQ,oBAAA;EAGJ,uEAAA;AvE+5OZ;AuEt6OQ;EAIQ,oBAAA;EAGJ,qEAAA;AvEm6OZ;AuE16OQ;EAIQ,oBAAA;EAGJ,kEAAA;AvEu6OZ;AuE96OQ;EAIQ,oBAAA;EAGJ,qEAAA;AvE26OZ;AuEl7OQ;EAIQ,oBAAA;EAGJ,oEAAA;AvE+6OZ;AuEt7OQ;EAIQ,oBAAA;EAGJ,mEAAA;AvEm7OZ;AuE17OQ;EAIQ,oBAAA;EAGJ,kEAAA;AvEu7OZ;AuE97OQ;EAIQ,oBAAA;EAGJ,mEAAA;AvE27OZ;AuEl8OQ;EAIQ,oBAAA;EAGJ,mEAAA;AvE+7OZ;AuEt8OQ;EAIQ,oBAAA;EAGJ,wEAAA;AvEm8OZ;AuE18OQ;EAIQ,oBAAA;EAGJ,2CAAA;AvEu8OZ;AuE98OQ;EAIQ,oBAAA;EAGJ,oCAAA;AvE28OZ;AuEl9OQ;EAIQ,oBAAA;EAGJ,0CAAA;AvE+8OZ;AuEt9OQ;EAIQ,oBAAA;EAGJ,2CAAA;AvEm9OZ;AuE19OQ;EAIQ,oBAAA;EAGJ,0CAAA;AvEu9OZ;AuE99OQ;EAIQ,oBAAA;EAGJ,0CAAA;AvE29OZ;AuEl+OQ;EAIQ,oBAAA;EAGJ,yBAAA;AvE+9OZ;AuEh/OQ;EACE,uBAAA;AvEk/OV;AuEn/OQ;EACE,sBAAA;AvEq/OV;AuEt/OQ;EACE,uBAAA;AvEw/OV;AuEz/OQ;EACE,oBAAA;AvE2/OV;AuEl/OQ;EAOI,iDAAA;AvE8+OZ;AuEr/OQ;EAOI,mDAAA;AvEi/OZ;AuEx/OQ;EAOI,iDAAA;AvEo/OZ;AuE3/OQ;EAOI,8CAAA;AvEu/OZ;AuE9/OQ;EAOI,iDAAA;AvE0/OZ;AuEjgPQ;EAOI,gDAAA;AvE6/OZ;AuEpgPQ;EAOI,+CAAA;AvEggPZ;AuEvgPQ;EAOI,8CAAA;AvEmgPZ;AuEphPQ;EACE,sBAAA;AvEshPV;AuElhPU;EACE,sBAAA;AvEohPZ;AuE1hPQ;EACE,uBAAA;AvE4hPV;AuExhPU;EACE,uBAAA;AvE0hPZ;AuEhiPQ;EACE,sBAAA;AvEkiPV;AuE9hPU;EACE,sBAAA;AvEgiPZ;AuEtiPQ;EACE,uBAAA;AvEwiPV;AuEpiPU;EACE,uBAAA;AvEsiPZ;AuE5iPQ;EACE,oBAAA;AvE8iPV;AuE1iPU;EACE,oBAAA;AvE4iPZ;AuExiPQ;EAOI,yCAAA;AvEoiPZ;AuE/hPU;EAOI,yCAAA;AvE2hPd;AuE9iPQ;EAOI,wCAAA;AvE0iPZ;AuEriPU;EAOI,wCAAA;AvEiiPd;AuEpjPQ;EAOI,yCAAA;AvEgjPZ;AuE3iPU;EAOI,yCAAA;AvEuiPd;AuE1jPQ;EAIQ,8BAAA;EAGJ,+FAAA;AvEujPZ;AuE9jPQ;EAIQ,8BAAA;EAGJ,iGAAA;AvE2jPZ;AuElkPQ;EAIQ,8BAAA;EAGJ,+FAAA;AvE+jPZ;AuEtkPQ;EAIQ,8BAAA;EAGJ,4FAAA;AvEmkPZ;AuE1kPQ;EAIQ,8BAAA;EAGJ,+FAAA;AvEukPZ;AuE9kPQ;EAIQ,8BAAA;EAGJ,8FAAA;AvE2kPZ;AuEllPQ;EAIQ,8BAAA;EAGJ,6FAAA;AvE+kPZ;AuEtlPQ;EAIQ,8BAAA;EAGJ,4FAAA;AvEmlPZ;AuE1lPQ;EAIQ,8BAAA;EAGJ,qGAAA;AvEulPZ;AuExmPQ;EACE,8BAAA;AvE0mPV;AuEtmPU;EACE,8BAAA;AvEwmPZ;AuE9mPQ;EACE,gCAAA;AvEgnPV;AuE5mPU;EACE,gCAAA;AvE8mPZ;AuEpnPQ;EACE,iCAAA;AvEsnPV;AuElnPU;EACE,iCAAA;AvEonPZ;AuE1nPQ;EACE,gCAAA;AvE4nPV;AuExnPU;EACE,gCAAA;AvE0nPZ;AuEhoPQ;EACE,iCAAA;AvEkoPV;AuE9nPU;EACE,iCAAA;AvEgoPZ;AuEtoPQ;EACE,8BAAA;AvEwoPV;AuEpoPU;EACE,8BAAA;AvEsoPZ;AuEloPQ;EAIQ,kBAAA;EAGJ,8EAAA;AvE+nPZ;AuEtoPQ;EAIQ,kBAAA;EAGJ,gFAAA;AvEmoPZ;AuE1oPQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEuoPZ;AuE9oPQ;EAIQ,kBAAA;EAGJ,2EAAA;AvE2oPZ;AuElpPQ;EAIQ,kBAAA;EAGJ,8EAAA;AvE+oPZ;AuEtpPQ;EAIQ,kBAAA;EAGJ,6EAAA;AvEmpPZ;AuE1pPQ;EAIQ,kBAAA;EAGJ,4EAAA;AvEupPZ;AuE9pPQ;EAIQ,kBAAA;EAGJ,2EAAA;AvE2pPZ;AuElqPQ;EAIQ,kBAAA;EAGJ,4EAAA;AvE+pPZ;AuEtqPQ;EAIQ,kBAAA;EAGJ,4EAAA;AvEmqPZ;AuE1qPQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEuqPZ;AuE9qPQ;EAIQ,kBAAA;EAGJ,wCAAA;AvE2qPZ;AuElrPQ;EAIQ,kBAAA;EAGJ,mFAAA;AvE+qPZ;AuEtrPQ;EAIQ,kBAAA;EAGJ,kFAAA;AvEmrPZ;AuEpsPQ;EACE,oBAAA;AvEssPV;AuEvsPQ;EACE,qBAAA;AvEysPV;AuE1sPQ;EACE,oBAAA;AvE4sPV;AuE7sPQ;EACE,qBAAA;AvE+sPV;AuEhtPQ;EACE,kBAAA;AvEktPV;AuEzsPQ;EAOI,wDAAA;AvEqsPZ;AuE5sPQ;EAOI,0DAAA;AvEwsPZ;AuE/sPQ;EAOI,wDAAA;AvE2sPZ;AuEltPQ;EAOI,qDAAA;AvE8sPZ;AuErtPQ;EAOI,wDAAA;AvEitPZ;AuExtPQ;EAOI,uDAAA;AvEotPZ;AuE3tPQ;EAOI,sDAAA;AvEutPZ;AuE9tPQ;EAOI,qDAAA;AvE0tPZ;AuEjuPQ;EAOI,+CAAA;AvE6tPZ;AuEpuPQ;EAOI,2BAAA;AvEguPZ;AuEvuPQ;EAOI,4BAAA;AvEmuPZ;AuE1uPQ;EAOI,4BAAA;AvEsuPZ;AuE7uPQ;EAOI,+BAAA;AvEyuPZ;AuEhvPQ;EAOI,+BAAA;AvE4uPZ;AuEnvPQ;EAOI,iDAAA;AvE+uPZ;AuEtvPQ;EAOI,2BAAA;AvEkvPZ;AuEzvPQ;EAOI,oDAAA;AvEqvPZ;AuE5vPQ;EAOI,iDAAA;AvEwvPZ;AuE/vPQ;EAOI,oDAAA;AvE2vPZ;AuElwPQ;EAOI,oDAAA;AvE8vPZ;AuErwPQ;EAOI,qDAAA;AvEiwPZ;AuExwPQ;EAOI,6BAAA;AvEowPZ;AuE3wPQ;EAOI,sDAAA;AvEuwPZ;AuE9wPQ;EAOI,0DAAA;EAAA,2DAAA;AvE2wPZ;AuElxPQ;EAOI,oCAAA;EAAA,qCAAA;AvE+wPZ;AuEtxPQ;EAOI,6DAAA;EAAA,8DAAA;AvEmxPZ;AuE1xPQ;EAOI,0DAAA;EAAA,2DAAA;AvEuxPZ;AuE9xPQ;EAOI,6DAAA;EAAA,8DAAA;AvE2xPZ;AuElyPQ;EAOI,6DAAA;EAAA,8DAAA;AvE+xPZ;AuEtyPQ;EAOI,8DAAA;EAAA,+DAAA;AvEmyPZ;AuE1yPQ;EAOI,sCAAA;EAAA,uCAAA;AvEuyPZ;AuE9yPQ;EAOI,+DAAA;EAAA,gEAAA;AvE2yPZ;AuElzPQ;EAOI,2DAAA;EAAA,8DAAA;AvE+yPZ;AuEtzPQ;EAOI,qCAAA;EAAA,wCAAA;AvEmzPZ;AuE1zPQ;EAOI,8DAAA;EAAA,iEAAA;AvEuzPZ;AuE9zPQ;EAOI,2DAAA;EAAA,8DAAA;AvE2zPZ;AuEl0PQ;EAOI,8DAAA;EAAA,iEAAA;AvE+zPZ;AuEt0PQ;EAOI,8DAAA;EAAA,iEAAA;AvEm0PZ;AuE10PQ;EAOI,+DAAA;EAAA,kEAAA;AvEu0PZ;AuE90PQ;EAOI,uCAAA;EAAA,0CAAA;AvE20PZ;AuEl1PQ;EAOI,gEAAA;EAAA,mEAAA;AvE+0PZ;AuEt1PQ;EAOI,8DAAA;EAAA,6DAAA;AvEm1PZ;AuE11PQ;EAOI,wCAAA;EAAA,uCAAA;AvEu1PZ;AuE91PQ;EAOI,iEAAA;EAAA,gEAAA;AvE21PZ;AuEl2PQ;EAOI,8DAAA;EAAA,6DAAA;AvE+1PZ;AuEt2PQ;EAOI,iEAAA;EAAA,gEAAA;AvEm2PZ;AuE12PQ;EAOI,iEAAA;EAAA,gEAAA;AvEu2PZ;AuE92PQ;EAOI,kEAAA;EAAA,iEAAA;AvE22PZ;AuEl3PQ;EAOI,0CAAA;EAAA,yCAAA;AvE+2PZ;AuEt3PQ;EAOI,mEAAA;EAAA,kEAAA;AvEm3PZ;AuE13PQ;EAOI,6DAAA;EAAA,0DAAA;AvEu3PZ;AuE93PQ;EAOI,uCAAA;EAAA,oCAAA;AvE23PZ;AuEl4PQ;EAOI,gEAAA;EAAA,6DAAA;AvE+3PZ;AuEt4PQ;EAOI,6DAAA;EAAA,0DAAA;AvEm4PZ;AuE14PQ;EAOI,gEAAA;EAAA,6DAAA;AvEu4PZ;AuE94PQ;EAOI,gEAAA;EAAA,6DAAA;AvE24PZ;AuEl5PQ;EAOI,iEAAA;EAAA,8DAAA;AvE+4PZ;AuEt5PQ;EAOI,yCAAA;EAAA,sCAAA;AvEm5PZ;AuE15PQ;EAOI,kEAAA;EAAA,+DAAA;AvEu5PZ;AuE95PQ;EAOI,8BAAA;AvE05PZ;AuEj6PQ;EAOI,6BAAA;AvE65PZ;AuEp6PQ;EAOI,sBAAA;AvEg6PZ;AuEv6PQ;EAOI,qBAAA;AvEm6PZ;AuE16PQ;EAOI,qBAAA;AvEs6PZ;AuE76PQ;EAOI,qBAAA;AvEy6PZ;AuEh7PQ;EAOI,qBAAA;AvE46PZ;Aat7PI;E0DGI;IAOI,sBAAA;EvEg7PV;EuEv7PM;IAOI,uBAAA;EvEm7PV;EuE17PM;IAOI,sBAAA;EvEs7PV;EuE77PM;IAOI,8BAAA;EvEy7PV;EuEh8PM;IAOI,4BAAA;EvE47PV;EuEn8PM;IAOI,2BAAA;EvE+7PV;EuEt8PM;IAOI,iCAAA;EvEk8PV;EuEz8PM;IAOI,2BAAA;EvEq8PV;EuE58PM;IAOI,0BAAA;EvEw8PV;EuE/8PM;IAOI,gCAAA;EvE28PV;EuEl9PM;IAOI,yBAAA;EvE88PV;EuEr9PM;IAOI,wBAAA;EvEi9PV;EuEx9PM;IAOI,+BAAA;EvEo9PV;EuE39PM;IAOI,yBAAA;EvEu9PV;EuE99PM;IAOI,6BAAA;EvE09PV;EuEj+PM;IAOI,8BAAA;EvE69PV;EuEp+PM;IAOI,wBAAA;EvEg+PV;EuEv+PM;IAOI,+BAAA;EvEm+PV;EuE1+PM;IAOI,wBAAA;EvEs+PV;EuE7+PM;IAOI,yBAAA;EvEy+PV;EuEh/PM;IAOI,8BAAA;EvE4+PV;EuEn/PM;IAOI,iCAAA;EvE++PV;EuEt/PM;IAOI,sCAAA;EvEk/PV;EuEz/PM;IAOI,yCAAA;EvEq/PV;EuE5/PM;IAOI,uBAAA;EvEw/PV;EuE//PM;IAOI,uBAAA;EvE2/PV;EuElgQM;IAOI,yBAAA;EvE8/PV;EuErgQM;IAOI,yBAAA;EvEigQV;EuExgQM;IAOI,0BAAA;EvEogQV;EuE3gQM;IAOI,4BAAA;EvEugQV;EuE9gQM;IAOI,kCAAA;EvE0gQV;EuEjhQM;IAOI,sCAAA;EvE6gQV;EuEphQM;IAOI,oCAAA;EvEghQV;EuEvhQM;IAOI,kCAAA;EvEmhQV;EuE1hQM;IAOI,yCAAA;EvEshQV;EuE7hQM;IAOI,wCAAA;EvEyhQV;EuEhiQM;IAOI,wCAAA;EvE4hQV;EuEniQM;IAOI,kCAAA;EvE+hQV;EuEtiQM;IAOI,gCAAA;EvEkiQV;EuEziQM;IAOI,8BAAA;EvEqiQV;EuE5iQM;IAOI,gCAAA;EvEwiQV;EuE/iQM;IAOI,+BAAA;EvE2iQV;EuEljQM;IAOI,oCAAA;EvE8iQV;EuErjQM;IAOI,kCAAA;EvEijQV;EuExjQM;IAOI,gCAAA;EvEojQV;EuE3jQM;IAOI,uCAAA;EvEujQV;EuE9jQM;IAOI,sCAAA;EvE0jQV;EuEjkQM;IAOI,iCAAA;EvE6jQV;EuEpkQM;IAOI,2BAAA;EvEgkQV;EuEvkQM;IAOI,iCAAA;EvEmkQV;EuE1kQM;IAOI,+BAAA;EvEskQV;EuE7kQM;IAOI,6BAAA;EvEykQV;EuEhlQM;IAOI,+BAAA;EvE4kQV;EuEnlQM;IAOI,8BAAA;EvE+kQV;EuEtlQM;IAOI,oBAAA;EvEklQV;EuEzlQM;IAOI,mBAAA;EvEqlQV;EuE5lQM;IAOI,mBAAA;EvEwlQV;EuE/lQM;IAOI,mBAAA;EvE2lQV;EuElmQM;IAOI,mBAAA;EvE8lQV;EuErmQM;IAOI,mBAAA;EvEimQV;EuExmQM;IAOI,mBAAA;EvEomQV;EuE3mQM;IAOI,mBAAA;EvEumQV;EuE9mQM;IAOI,oBAAA;EvE0mQV;EuEjnQM;IAOI,0BAAA;EvE6mQV;EuEpnQM;IAOI,yBAAA;EvEgnQV;EuEvnQM;IAOI,uBAAA;EvEmnQV;EuE1nQM;IAOI,yBAAA;EvEsnQV;EuE7nQM;IAOI,uBAAA;EvEynQV;EuEhoQM;IAOI,uBAAA;EvE4nQV;EuEnoQM;IAOI,0BAAA;IAAA,yBAAA;EvEgoQV;EuEvoQM;IAOI,gCAAA;IAAA,+BAAA;EvEooQV;EuE3oQM;IAOI,+BAAA;IAAA,8BAAA;EvEwoQV;EuE/oQM;IAOI,6BAAA;IAAA,4BAAA;EvE4oQV;EuEnpQM;IAOI,+BAAA;IAAA,8BAAA;EvEgpQV;EuEvpQM;IAOI,6BAAA;IAAA,4BAAA;EvEopQV;EuE3pQM;IAOI,6BAAA;IAAA,4BAAA;EvEwpQV;EuE/pQM;IAOI,wBAAA;IAAA,2BAAA;EvE4pQV;EuEnqQM;IAOI,8BAAA;IAAA,iCAAA;EvEgqQV;EuEvqQM;IAOI,6BAAA;IAAA,gCAAA;EvEoqQV;EuE3qQM;IAOI,2BAAA;IAAA,8BAAA;EvEwqQV;EuE/qQM;IAOI,6BAAA;IAAA,gCAAA;EvE4qQV;EuEnrQM;IAOI,2BAAA;IAAA,8BAAA;EvEgrQV;EuEvrQM;IAOI,2BAAA;IAAA,8BAAA;EvEorQV;EuE3rQM;IAOI,wBAAA;EvEurQV;EuE9rQM;IAOI,8BAAA;EvE0rQV;EuEjsQM;IAOI,6BAAA;EvE6rQV;EuEpsQM;IAOI,2BAAA;EvEgsQV;EuEvsQM;IAOI,6BAAA;EvEmsQV;EuE1sQM;IAOI,2BAAA;EvEssQV;EuE7sQM;IAOI,2BAAA;EvEysQV;EuEhtQM;IAOI,0BAAA;EvE4sQV;EuEntQM;IAOI,gCAAA;EvE+sQV;EuEttQM;IAOI,+BAAA;EvEktQV;EuEztQM;IAOI,6BAAA;EvEqtQV;EuE5tQM;IAOI,+BAAA;EvEwtQV;EuE/tQM;IAOI,6BAAA;EvE2tQV;EuEluQM;IAOI,6BAAA;EvE8tQV;EuEruQM;IAOI,2BAAA;EvEiuQV;EuExuQM;IAOI,iCAAA;EvEouQV;EuE3uQM;IAOI,gCAAA;EvEuuQV;EuE9uQM;IAOI,8BAAA;EvE0uQV;EuEjvQM;IAOI,gCAAA;EvE6uQV;EuEpvQM;IAOI,8BAAA;EvEgvQV;EuEvvQM;IAOI,8BAAA;EvEmvQV;EuE1vQM;IAOI,yBAAA;EvEsvQV;EuE7vQM;IAOI,+BAAA;EvEyvQV;EuEhwQM;IAOI,8BAAA;EvE4vQV;EuEnwQM;IAOI,4BAAA;EvE+vQV;EuEtwQM;IAOI,8BAAA;EvEkwQV;EuEzwQM;IAOI,4BAAA;EvEqwQV;EuE5wQM;IAOI,4BAAA;EvEwwQV;EuE/wQM;IAOI,qBAAA;EvE2wQV;EuElxQM;IAOI,2BAAA;EvE8wQV;EuErxQM;IAOI,0BAAA;EvEixQV;EuExxQM;IAOI,wBAAA;EvEoxQV;EuE3xQM;IAOI,0BAAA;EvEuxQV;EuE9xQM;IAOI,wBAAA;EvE0xQV;EuEjyQM;IAOI,2BAAA;IAAA,0BAAA;EvE8xQV;EuEryQM;IAOI,iCAAA;IAAA,gCAAA;EvEkyQV;EuEzyQM;IAOI,gCAAA;IAAA,+BAAA;EvEsyQV;EuE7yQM;IAOI,8BAAA;IAAA,6BAAA;EvE0yQV;EuEjzQM;IAOI,gCAAA;IAAA,+BAAA;EvE8yQV;EuErzQM;IAOI,8BAAA;IAAA,6BAAA;EvEkzQV;EuEzzQM;IAOI,yBAAA;IAAA,4BAAA;EvEszQV;EuE7zQM;IAOI,+BAAA;IAAA,kCAAA;EvE0zQV;EuEj0QM;IAOI,8BAAA;IAAA,iCAAA;EvE8zQV;EuEr0QM;IAOI,4BAAA;IAAA,+BAAA;EvEk0QV;EuEz0QM;IAOI,8BAAA;IAAA,iCAAA;EvEs0QV;EuE70QM;IAOI,4BAAA;IAAA,+BAAA;EvE00QV;EuEj1QM;IAOI,yBAAA;EvE60QV;EuEp1QM;IAOI,+BAAA;EvEg1QV;EuEv1QM;IAOI,8BAAA;EvEm1QV;EuE11QM;IAOI,4BAAA;EvEs1QV;EuE71QM;IAOI,8BAAA;EvEy1QV;EuEh2QM;IAOI,4BAAA;EvE41QV;EuEn2QM;IAOI,2BAAA;EvE+1QV;EuEt2QM;IAOI,iCAAA;EvEk2QV;EuEz2QM;IAOI,gCAAA;EvEq2QV;EuE52QM;IAOI,8BAAA;EvEw2QV;EuE/2QM;IAOI,gCAAA;EvE22QV;EuEl3QM;IAOI,8BAAA;EvE82QV;EuEr3QM;IAOI,4BAAA;EvEi3QV;EuEx3QM;IAOI,kCAAA;EvEo3QV;EuE33QM;IAOI,iCAAA;EvEu3QV;EuE93QM;IAOI,+BAAA;EvE03QV;EuEj4QM;IAOI,iCAAA;EvE63QV;EuEp4QM;IAOI,+BAAA;EvEg4QV;EuEv4QM;IAOI,0BAAA;EvEm4QV;EuE14QM;IAOI,gCAAA;EvEs4QV;EuE74QM;IAOI,+BAAA;EvEy4QV;EuEh5QM;IAOI,6BAAA;EvE44QV;EuEn5QM;IAOI,+BAAA;EvE+4QV;EuEt5QM;IAOI,6BAAA;EvEk5QV;EuEz5QM;IAOI,iBAAA;EvEq5QV;EuE55QM;IAOI,uBAAA;EvEw5QV;EuE/5QM;IAOI,sBAAA;EvE25QV;EuEl6QM;IAOI,oBAAA;EvE85QV;EuEr6QM;IAOI,sBAAA;EvEi6QV;EuEx6QM;IAOI,oBAAA;EvEo6QV;EuE36QM;IAOI,qBAAA;EvEu6QV;EuE96QM;IAOI,2BAAA;EvE06QV;EuEj7QM;IAOI,0BAAA;EvE66QV;EuEp7QM;IAOI,wBAAA;EvEg7QV;EuEv7QM;IAOI,0BAAA;EvEm7QV;EuE17QM;IAOI,wBAAA;EvEs7QV;EuE77QM;IAOI,wBAAA;EvEy7QV;EuEh8QM;IAOI,8BAAA;EvE47QV;EuEn8QM;IAOI,6BAAA;EvE+7QV;EuEt8QM;IAOI,2BAAA;EvEk8QV;EuEz8QM;IAOI,6BAAA;EvEq8QV;EuE58QM;IAOI,2BAAA;EvEw8QV;EuE/8QM;IAOI,2BAAA;EvE28QV;EuEl9QM;IAOI,4BAAA;EvE88QV;EuEr9QM;IAOI,6BAAA;EvEi9QV;AACF;Aa59QI;E0DGI;IAOI,sBAAA;EvEs9QV;EuE79QM;IAOI,uBAAA;EvEy9QV;EuEh+QM;IAOI,sBAAA;EvE49QV;EuEn+QM;IAOI,8BAAA;EvE+9QV;EuEt+QM;IAOI,4BAAA;EvEk+QV;EuEz+QM;IAOI,2BAAA;EvEq+QV;EuE5+QM;IAOI,iCAAA;EvEw+QV;EuE/+QM;IAOI,2BAAA;EvE2+QV;EuEl/QM;IAOI,0BAAA;EvE8+QV;EuEr/QM;IAOI,gCAAA;EvEi/QV;EuEx/QM;IAOI,yBAAA;EvEo/QV;EuE3/QM;IAOI,wBAAA;EvEu/QV;EuE9/QM;IAOI,+BAAA;EvE0/QV;EuEjgRM;IAOI,yBAAA;EvE6/QV;EuEpgRM;IAOI,6BAAA;EvEggRV;EuEvgRM;IAOI,8BAAA;EvEmgRV;EuE1gRM;IAOI,wBAAA;EvEsgRV;EuE7gRM;IAOI,+BAAA;EvEygRV;EuEhhRM;IAOI,wBAAA;EvE4gRV;EuEnhRM;IAOI,yBAAA;EvE+gRV;EuEthRM;IAOI,8BAAA;EvEkhRV;EuEzhRM;IAOI,iCAAA;EvEqhRV;EuE5hRM;IAOI,sCAAA;EvEwhRV;EuE/hRM;IAOI,yCAAA;EvE2hRV;EuEliRM;IAOI,uBAAA;EvE8hRV;EuEriRM;IAOI,uBAAA;EvEiiRV;EuExiRM;IAOI,yBAAA;EvEoiRV;EuE3iRM;IAOI,yBAAA;EvEuiRV;EuE9iRM;IAOI,0BAAA;EvE0iRV;EuEjjRM;IAOI,4BAAA;EvE6iRV;EuEpjRM;IAOI,kCAAA;EvEgjRV;EuEvjRM;IAOI,sCAAA;EvEmjRV;EuE1jRM;IAOI,oCAAA;EvEsjRV;EuE7jRM;IAOI,kCAAA;EvEyjRV;EuEhkRM;IAOI,yCAAA;EvE4jRV;EuEnkRM;IAOI,wCAAA;EvE+jRV;EuEtkRM;IAOI,wCAAA;EvEkkRV;EuEzkRM;IAOI,kCAAA;EvEqkRV;EuE5kRM;IAOI,gCAAA;EvEwkRV;EuE/kRM;IAOI,8BAAA;EvE2kRV;EuEllRM;IAOI,gCAAA;EvE8kRV;EuErlRM;IAOI,+BAAA;EvEilRV;EuExlRM;IAOI,oCAAA;EvEolRV;EuE3lRM;IAOI,kCAAA;EvEulRV;EuE9lRM;IAOI,gCAAA;EvE0lRV;EuEjmRM;IAOI,uCAAA;EvE6lRV;EuEpmRM;IAOI,sCAAA;EvEgmRV;EuEvmRM;IAOI,iCAAA;EvEmmRV;EuE1mRM;IAOI,2BAAA;EvEsmRV;EuE7mRM;IAOI,iCAAA;EvEymRV;EuEhnRM;IAOI,+BAAA;EvE4mRV;EuEnnRM;IAOI,6BAAA;EvE+mRV;EuEtnRM;IAOI,+BAAA;EvEknRV;EuEznRM;IAOI,8BAAA;EvEqnRV;EuE5nRM;IAOI,oBAAA;EvEwnRV;EuE/nRM;IAOI,mBAAA;EvE2nRV;EuEloRM;IAOI,mBAAA;EvE8nRV;EuEroRM;IAOI,mBAAA;EvEioRV;EuExoRM;IAOI,mBAAA;EvEooRV;EuE3oRM;IAOI,mBAAA;EvEuoRV;EuE9oRM;IAOI,mBAAA;EvE0oRV;EuEjpRM;IAOI,mBAAA;EvE6oRV;EuEppRM;IAOI,oBAAA;EvEgpRV;EuEvpRM;IAOI,0BAAA;EvEmpRV;EuE1pRM;IAOI,yBAAA;EvEspRV;EuE7pRM;IAOI,uBAAA;EvEypRV;EuEhqRM;IAOI,yBAAA;EvE4pRV;EuEnqRM;IAOI,uBAAA;EvE+pRV;EuEtqRM;IAOI,uBAAA;EvEkqRV;EuEzqRM;IAOI,0BAAA;IAAA,yBAAA;EvEsqRV;EuE7qRM;IAOI,gCAAA;IAAA,+BAAA;EvE0qRV;EuEjrRM;IAOI,+BAAA;IAAA,8BAAA;EvE8qRV;EuErrRM;IAOI,6BAAA;IAAA,4BAAA;EvEkrRV;EuEzrRM;IAOI,+BAAA;IAAA,8BAAA;EvEsrRV;EuE7rRM;IAOI,6BAAA;IAAA,4BAAA;EvE0rRV;EuEjsRM;IAOI,6BAAA;IAAA,4BAAA;EvE8rRV;EuErsRM;IAOI,wBAAA;IAAA,2BAAA;EvEksRV;EuEzsRM;IAOI,8BAAA;IAAA,iCAAA;EvEssRV;EuE7sRM;IAOI,6BAAA;IAAA,gCAAA;EvE0sRV;EuEjtRM;IAOI,2BAAA;IAAA,8BAAA;EvE8sRV;EuErtRM;IAOI,6BAAA;IAAA,gCAAA;EvEktRV;EuEztRM;IAOI,2BAAA;IAAA,8BAAA;EvEstRV;EuE7tRM;IAOI,2BAAA;IAAA,8BAAA;EvE0tRV;EuEjuRM;IAOI,wBAAA;EvE6tRV;EuEpuRM;IAOI,8BAAA;EvEguRV;EuEvuRM;IAOI,6BAAA;EvEmuRV;EuE1uRM;IAOI,2BAAA;EvEsuRV;EuE7uRM;IAOI,6BAAA;EvEyuRV;EuEhvRM;IAOI,2BAAA;EvE4uRV;EuEnvRM;IAOI,2BAAA;EvE+uRV;EuEtvRM;IAOI,0BAAA;EvEkvRV;EuEzvRM;IAOI,gCAAA;EvEqvRV;EuE5vRM;IAOI,+BAAA;EvEwvRV;EuE/vRM;IAOI,6BAAA;EvE2vRV;EuElwRM;IAOI,+BAAA;EvE8vRV;EuErwRM;IAOI,6BAAA;EvEiwRV;EuExwRM;IAOI,6BAAA;EvEowRV;EuE3wRM;IAOI,2BAAA;EvEuwRV;EuE9wRM;IAOI,iCAAA;EvE0wRV;EuEjxRM;IAOI,gCAAA;EvE6wRV;EuEpxRM;IAOI,8BAAA;EvEgxRV;EuEvxRM;IAOI,gCAAA;EvEmxRV;EuE1xRM;IAOI,8BAAA;EvEsxRV;EuE7xRM;IAOI,8BAAA;EvEyxRV;EuEhyRM;IAOI,yBAAA;EvE4xRV;EuEnyRM;IAOI,+BAAA;EvE+xRV;EuEtyRM;IAOI,8BAAA;EvEkyRV;EuEzyRM;IAOI,4BAAA;EvEqyRV;EuE5yRM;IAOI,8BAAA;EvEwyRV;EuE/yRM;IAOI,4BAAA;EvE2yRV;EuElzRM;IAOI,4BAAA;EvE8yRV;EuErzRM;IAOI,qBAAA;EvEizRV;EuExzRM;IAOI,2BAAA;EvEozRV;EuE3zRM;IAOI,0BAAA;EvEuzRV;EuE9zRM;IAOI,wBAAA;EvE0zRV;EuEj0RM;IAOI,0BAAA;EvE6zRV;EuEp0RM;IAOI,wBAAA;EvEg0RV;EuEv0RM;IAOI,2BAAA;IAAA,0BAAA;EvEo0RV;EuE30RM;IAOI,iCAAA;IAAA,gCAAA;EvEw0RV;EuE/0RM;IAOI,gCAAA;IAAA,+BAAA;EvE40RV;EuEn1RM;IAOI,8BAAA;IAAA,6BAAA;EvEg1RV;EuEv1RM;IAOI,gCAAA;IAAA,+BAAA;EvEo1RV;EuE31RM;IAOI,8BAAA;IAAA,6BAAA;EvEw1RV;EuE/1RM;IAOI,yBAAA;IAAA,4BAAA;EvE41RV;EuEn2RM;IAOI,+BAAA;IAAA,kCAAA;EvEg2RV;EuEv2RM;IAOI,8BAAA;IAAA,iCAAA;EvEo2RV;EuE32RM;IAOI,4BAAA;IAAA,+BAAA;EvEw2RV;EuE/2RM;IAOI,8BAAA;IAAA,iCAAA;EvE42RV;EuEn3RM;IAOI,4BAAA;IAAA,+BAAA;EvEg3RV;EuEv3RM;IAOI,yBAAA;EvEm3RV;EuE13RM;IAOI,+BAAA;EvEs3RV;EuE73RM;IAOI,8BAAA;EvEy3RV;EuEh4RM;IAOI,4BAAA;EvE43RV;EuEn4RM;IAOI,8BAAA;EvE+3RV;EuEt4RM;IAOI,4BAAA;EvEk4RV;EuEz4RM;IAOI,2BAAA;EvEq4RV;EuE54RM;IAOI,iCAAA;EvEw4RV;EuE/4RM;IAOI,gCAAA;EvE24RV;EuEl5RM;IAOI,8BAAA;EvE84RV;EuEr5RM;IAOI,gCAAA;EvEi5RV;EuEx5RM;IAOI,8BAAA;EvEo5RV;EuE35RM;IAOI,4BAAA;EvEu5RV;EuE95RM;IAOI,kCAAA;EvE05RV;EuEj6RM;IAOI,iCAAA;EvE65RV;EuEp6RM;IAOI,+BAAA;EvEg6RV;EuEv6RM;IAOI,iCAAA;EvEm6RV;EuE16RM;IAOI,+BAAA;EvEs6RV;EuE76RM;IAOI,0BAAA;EvEy6RV;EuEh7RM;IAOI,gCAAA;EvE46RV;EuEn7RM;IAOI,+BAAA;EvE+6RV;EuEt7RM;IAOI,6BAAA;EvEk7RV;EuEz7RM;IAOI,+BAAA;EvEq7RV;EuE57RM;IAOI,6BAAA;EvEw7RV;EuE/7RM;IAOI,iBAAA;EvE27RV;EuEl8RM;IAOI,uBAAA;EvE87RV;EuEr8RM;IAOI,sBAAA;EvEi8RV;EuEx8RM;IAOI,oBAAA;EvEo8RV;EuE38RM;IAOI,sBAAA;EvEu8RV;EuE98RM;IAOI,oBAAA;EvE08RV;EuEj9RM;IAOI,qBAAA;EvE68RV;EuEp9RM;IAOI,2BAAA;EvEg9RV;EuEv9RM;IAOI,0BAAA;EvEm9RV;EuE19RM;IAOI,wBAAA;EvEs9RV;EuE79RM;IAOI,0BAAA;EvEy9RV;EuEh+RM;IAOI,wBAAA;EvE49RV;EuEn+RM;IAOI,wBAAA;EvE+9RV;EuEt+RM;IAOI,8BAAA;EvEk+RV;EuEz+RM;IAOI,6BAAA;EvEq+RV;EuE5+RM;IAOI,2BAAA;EvEw+RV;EuE/+RM;IAOI,6BAAA;EvE2+RV;EuEl/RM;IAOI,2BAAA;EvE8+RV;EuEr/RM;IAOI,2BAAA;EvEi/RV;EuEx/RM;IAOI,4BAAA;EvEo/RV;EuE3/RM;IAOI,6BAAA;EvEu/RV;AACF;AalgSI;E0DGI;IAOI,sBAAA;EvE4/RV;EuEngSM;IAOI,uBAAA;EvE+/RV;EuEtgSM;IAOI,sBAAA;EvEkgSV;EuEzgSM;IAOI,8BAAA;EvEqgSV;EuE5gSM;IAOI,4BAAA;EvEwgSV;EuE/gSM;IAOI,2BAAA;EvE2gSV;EuElhSM;IAOI,iCAAA;EvE8gSV;EuErhSM;IAOI,2BAAA;EvEihSV;EuExhSM;IAOI,0BAAA;EvEohSV;EuE3hSM;IAOI,gCAAA;EvEuhSV;EuE9hSM;IAOI,yBAAA;EvE0hSV;EuEjiSM;IAOI,wBAAA;EvE6hSV;EuEpiSM;IAOI,+BAAA;EvEgiSV;EuEviSM;IAOI,yBAAA;EvEmiSV;EuE1iSM;IAOI,6BAAA;EvEsiSV;EuE7iSM;IAOI,8BAAA;EvEyiSV;EuEhjSM;IAOI,wBAAA;EvE4iSV;EuEnjSM;IAOI,+BAAA;EvE+iSV;EuEtjSM;IAOI,wBAAA;EvEkjSV;EuEzjSM;IAOI,yBAAA;EvEqjSV;EuE5jSM;IAOI,8BAAA;EvEwjSV;EuE/jSM;IAOI,iCAAA;EvE2jSV;EuElkSM;IAOI,sCAAA;EvE8jSV;EuErkSM;IAOI,yCAAA;EvEikSV;EuExkSM;IAOI,uBAAA;EvEokSV;EuE3kSM;IAOI,uBAAA;EvEukSV;EuE9kSM;IAOI,yBAAA;EvE0kSV;EuEjlSM;IAOI,yBAAA;EvE6kSV;EuEplSM;IAOI,0BAAA;EvEglSV;EuEvlSM;IAOI,4BAAA;EvEmlSV;EuE1lSM;IAOI,kCAAA;EvEslSV;EuE7lSM;IAOI,sCAAA;EvEylSV;EuEhmSM;IAOI,oCAAA;EvE4lSV;EuEnmSM;IAOI,kCAAA;EvE+lSV;EuEtmSM;IAOI,yCAAA;EvEkmSV;EuEzmSM;IAOI,wCAAA;EvEqmSV;EuE5mSM;IAOI,wCAAA;EvEwmSV;EuE/mSM;IAOI,kCAAA;EvE2mSV;EuElnSM;IAOI,gCAAA;EvE8mSV;EuErnSM;IAOI,8BAAA;EvEinSV;EuExnSM;IAOI,gCAAA;EvEonSV;EuE3nSM;IAOI,+BAAA;EvEunSV;EuE9nSM;IAOI,oCAAA;EvE0nSV;EuEjoSM;IAOI,kCAAA;EvE6nSV;EuEpoSM;IAOI,gCAAA;EvEgoSV;EuEvoSM;IAOI,uCAAA;EvEmoSV;EuE1oSM;IAOI,sCAAA;EvEsoSV;EuE7oSM;IAOI,iCAAA;EvEyoSV;EuEhpSM;IAOI,2BAAA;EvE4oSV;EuEnpSM;IAOI,iCAAA;EvE+oSV;EuEtpSM;IAOI,+BAAA;EvEkpSV;EuEzpSM;IAOI,6BAAA;EvEqpSV;EuE5pSM;IAOI,+BAAA;EvEwpSV;EuE/pSM;IAOI,8BAAA;EvE2pSV;EuElqSM;IAOI,oBAAA;EvE8pSV;EuErqSM;IAOI,mBAAA;EvEiqSV;EuExqSM;IAOI,mBAAA;EvEoqSV;EuE3qSM;IAOI,mBAAA;EvEuqSV;EuE9qSM;IAOI,mBAAA;EvE0qSV;EuEjrSM;IAOI,mBAAA;EvE6qSV;EuEprSM;IAOI,mBAAA;EvEgrSV;EuEvrSM;IAOI,mBAAA;EvEmrSV;EuE1rSM;IAOI,oBAAA;EvEsrSV;EuE7rSM;IAOI,0BAAA;EvEyrSV;EuEhsSM;IAOI,yBAAA;EvE4rSV;EuEnsSM;IAOI,uBAAA;EvE+rSV;EuEtsSM;IAOI,yBAAA;EvEksSV;EuEzsSM;IAOI,uBAAA;EvEqsSV;EuE5sSM;IAOI,uBAAA;EvEwsSV;EuE/sSM;IAOI,0BAAA;IAAA,yBAAA;EvE4sSV;EuEntSM;IAOI,gCAAA;IAAA,+BAAA;EvEgtSV;EuEvtSM;IAOI,+BAAA;IAAA,8BAAA;EvEotSV;EuE3tSM;IAOI,6BAAA;IAAA,4BAAA;EvEwtSV;EuE/tSM;IAOI,+BAAA;IAAA,8BAAA;EvE4tSV;EuEnuSM;IAOI,6BAAA;IAAA,4BAAA;EvEguSV;EuEvuSM;IAOI,6BAAA;IAAA,4BAAA;EvEouSV;EuE3uSM;IAOI,wBAAA;IAAA,2BAAA;EvEwuSV;EuE/uSM;IAOI,8BAAA;IAAA,iCAAA;EvE4uSV;EuEnvSM;IAOI,6BAAA;IAAA,gCAAA;EvEgvSV;EuEvvSM;IAOI,2BAAA;IAAA,8BAAA;EvEovSV;EuE3vSM;IAOI,6BAAA;IAAA,gCAAA;EvEwvSV;EuE/vSM;IAOI,2BAAA;IAAA,8BAAA;EvE4vSV;EuEnwSM;IAOI,2BAAA;IAAA,8BAAA;EvEgwSV;EuEvwSM;IAOI,wBAAA;EvEmwSV;EuE1wSM;IAOI,8BAAA;EvEswSV;EuE7wSM;IAOI,6BAAA;EvEywSV;EuEhxSM;IAOI,2BAAA;EvE4wSV;EuEnxSM;IAOI,6BAAA;EvE+wSV;EuEtxSM;IAOI,2BAAA;EvEkxSV;EuEzxSM;IAOI,2BAAA;EvEqxSV;EuE5xSM;IAOI,0BAAA;EvEwxSV;EuE/xSM;IAOI,gCAAA;EvE2xSV;EuElySM;IAOI,+BAAA;EvE8xSV;EuErySM;IAOI,6BAAA;EvEiySV;EuExySM;IAOI,+BAAA;EvEoySV;EuE3ySM;IAOI,6BAAA;EvEuySV;EuE9ySM;IAOI,6BAAA;EvE0ySV;EuEjzSM;IAOI,2BAAA;EvE6ySV;EuEpzSM;IAOI,iCAAA;EvEgzSV;EuEvzSM;IAOI,gCAAA;EvEmzSV;EuE1zSM;IAOI,8BAAA;EvEszSV;EuE7zSM;IAOI,gCAAA;EvEyzSV;EuEh0SM;IAOI,8BAAA;EvE4zSV;EuEn0SM;IAOI,8BAAA;EvE+zSV;EuEt0SM;IAOI,yBAAA;EvEk0SV;EuEz0SM;IAOI,+BAAA;EvEq0SV;EuE50SM;IAOI,8BAAA;EvEw0SV;EuE/0SM;IAOI,4BAAA;EvE20SV;EuEl1SM;IAOI,8BAAA;EvE80SV;EuEr1SM;IAOI,4BAAA;EvEi1SV;EuEx1SM;IAOI,4BAAA;EvEo1SV;EuE31SM;IAOI,qBAAA;EvEu1SV;EuE91SM;IAOI,2BAAA;EvE01SV;EuEj2SM;IAOI,0BAAA;EvE61SV;EuEp2SM;IAOI,wBAAA;EvEg2SV;EuEv2SM;IAOI,0BAAA;EvEm2SV;EuE12SM;IAOI,wBAAA;EvEs2SV;EuE72SM;IAOI,2BAAA;IAAA,0BAAA;EvE02SV;EuEj3SM;IAOI,iCAAA;IAAA,gCAAA;EvE82SV;EuEr3SM;IAOI,gCAAA;IAAA,+BAAA;EvEk3SV;EuEz3SM;IAOI,8BAAA;IAAA,6BAAA;EvEs3SV;EuE73SM;IAOI,gCAAA;IAAA,+BAAA;EvE03SV;EuEj4SM;IAOI,8BAAA;IAAA,6BAAA;EvE83SV;EuEr4SM;IAOI,yBAAA;IAAA,4BAAA;EvEk4SV;EuEz4SM;IAOI,+BAAA;IAAA,kCAAA;EvEs4SV;EuE74SM;IAOI,8BAAA;IAAA,iCAAA;EvE04SV;EuEj5SM;IAOI,4BAAA;IAAA,+BAAA;EvE84SV;EuEr5SM;IAOI,8BAAA;IAAA,iCAAA;EvEk5SV;EuEz5SM;IAOI,4BAAA;IAAA,+BAAA;EvEs5SV;EuE75SM;IAOI,yBAAA;EvEy5SV;EuEh6SM;IAOI,+BAAA;EvE45SV;EuEn6SM;IAOI,8BAAA;EvE+5SV;EuEt6SM;IAOI,4BAAA;EvEk6SV;EuEz6SM;IAOI,8BAAA;EvEq6SV;EuE56SM;IAOI,4BAAA;EvEw6SV;EuE/6SM;IAOI,2BAAA;EvE26SV;EuEl7SM;IAOI,iCAAA;EvE86SV;EuEr7SM;IAOI,gCAAA;EvEi7SV;EuEx7SM;IAOI,8BAAA;EvEo7SV;EuE37SM;IAOI,gCAAA;EvEu7SV;EuE97SM;IAOI,8BAAA;EvE07SV;EuEj8SM;IAOI,4BAAA;EvE67SV;EuEp8SM;IAOI,kCAAA;EvEg8SV;EuEv8SM;IAOI,iCAAA;EvEm8SV;EuE18SM;IAOI,+BAAA;EvEs8SV;EuE78SM;IAOI,iCAAA;EvEy8SV;EuEh9SM;IAOI,+BAAA;EvE48SV;EuEn9SM;IAOI,0BAAA;EvE+8SV;EuEt9SM;IAOI,gCAAA;EvEk9SV;EuEz9SM;IAOI,+BAAA;EvEq9SV;EuE59SM;IAOI,6BAAA;EvEw9SV;EuE/9SM;IAOI,+BAAA;EvE29SV;EuEl+SM;IAOI,6BAAA;EvE89SV;EuEr+SM;IAOI,iBAAA;EvEi+SV;EuEx+SM;IAOI,uBAAA;EvEo+SV;EuE3+SM;IAOI,sBAAA;EvEu+SV;EuE9+SM;IAOI,oBAAA;EvE0+SV;EuEj/SM;IAOI,sBAAA;EvE6+SV;EuEp/SM;IAOI,oBAAA;EvEg/SV;EuEv/SM;IAOI,qBAAA;EvEm/SV;EuE1/SM;IAOI,2BAAA;EvEs/SV;EuE7/SM;IAOI,0BAAA;EvEy/SV;EuEhgTM;IAOI,wBAAA;EvE4/SV;EuEngTM;IAOI,0BAAA;EvE+/SV;EuEtgTM;IAOI,wBAAA;EvEkgTV;EuEzgTM;IAOI,wBAAA;EvEqgTV;EuE5gTM;IAOI,8BAAA;EvEwgTV;EuE/gTM;IAOI,6BAAA;EvE2gTV;EuElhTM;IAOI,2BAAA;EvE8gTV;EuErhTM;IAOI,6BAAA;EvEihTV;EuExhTM;IAOI,2BAAA;EvEohTV;EuE3hTM;IAOI,2BAAA;EvEuhTV;EuE9hTM;IAOI,4BAAA;EvE0hTV;EuEjiTM;IAOI,6BAAA;EvE6hTV;AACF;AaxiTI;E0DGI;IAOI,sBAAA;EvEkiTV;EuEziTM;IAOI,uBAAA;EvEqiTV;EuE5iTM;IAOI,sBAAA;EvEwiTV;EuE/iTM;IAOI,8BAAA;EvE2iTV;EuEljTM;IAOI,4BAAA;EvE8iTV;EuErjTM;IAOI,2BAAA;EvEijTV;EuExjTM;IAOI,iCAAA;EvEojTV;EuE3jTM;IAOI,2BAAA;EvEujTV;EuE9jTM;IAOI,0BAAA;EvE0jTV;EuEjkTM;IAOI,gCAAA;EvE6jTV;EuEpkTM;IAOI,yBAAA;EvEgkTV;EuEvkTM;IAOI,wBAAA;EvEmkTV;EuE1kTM;IAOI,+BAAA;EvEskTV;EuE7kTM;IAOI,yBAAA;EvEykTV;EuEhlTM;IAOI,6BAAA;EvE4kTV;EuEnlTM;IAOI,8BAAA;EvE+kTV;EuEtlTM;IAOI,wBAAA;EvEklTV;EuEzlTM;IAOI,+BAAA;EvEqlTV;EuE5lTM;IAOI,wBAAA;EvEwlTV;EuE/lTM;IAOI,yBAAA;EvE2lTV;EuElmTM;IAOI,8BAAA;EvE8lTV;EuErmTM;IAOI,iCAAA;EvEimTV;EuExmTM;IAOI,sCAAA;EvEomTV;EuE3mTM;IAOI,yCAAA;EvEumTV;EuE9mTM;IAOI,uBAAA;EvE0mTV;EuEjnTM;IAOI,uBAAA;EvE6mTV;EuEpnTM;IAOI,yBAAA;EvEgnTV;EuEvnTM;IAOI,yBAAA;EvEmnTV;EuE1nTM;IAOI,0BAAA;EvEsnTV;EuE7nTM;IAOI,4BAAA;EvEynTV;EuEhoTM;IAOI,kCAAA;EvE4nTV;EuEnoTM;IAOI,sCAAA;EvE+nTV;EuEtoTM;IAOI,oCAAA;EvEkoTV;EuEzoTM;IAOI,kCAAA;EvEqoTV;EuE5oTM;IAOI,yCAAA;EvEwoTV;EuE/oTM;IAOI,wCAAA;EvE2oTV;EuElpTM;IAOI,wCAAA;EvE8oTV;EuErpTM;IAOI,kCAAA;EvEipTV;EuExpTM;IAOI,gCAAA;EvEopTV;EuE3pTM;IAOI,8BAAA;EvEupTV;EuE9pTM;IAOI,gCAAA;EvE0pTV;EuEjqTM;IAOI,+BAAA;EvE6pTV;EuEpqTM;IAOI,oCAAA;EvEgqTV;EuEvqTM;IAOI,kCAAA;EvEmqTV;EuE1qTM;IAOI,gCAAA;EvEsqTV;EuE7qTM;IAOI,uCAAA;EvEyqTV;EuEhrTM;IAOI,sCAAA;EvE4qTV;EuEnrTM;IAOI,iCAAA;EvE+qTV;EuEtrTM;IAOI,2BAAA;EvEkrTV;EuEzrTM;IAOI,iCAAA;EvEqrTV;EuE5rTM;IAOI,+BAAA;EvEwrTV;EuE/rTM;IAOI,6BAAA;EvE2rTV;EuElsTM;IAOI,+BAAA;EvE8rTV;EuErsTM;IAOI,8BAAA;EvEisTV;EuExsTM;IAOI,oBAAA;EvEosTV;EuE3sTM;IAOI,mBAAA;EvEusTV;EuE9sTM;IAOI,mBAAA;EvE0sTV;EuEjtTM;IAOI,mBAAA;EvE6sTV;EuEptTM;IAOI,mBAAA;EvEgtTV;EuEvtTM;IAOI,mBAAA;EvEmtTV;EuE1tTM;IAOI,mBAAA;EvEstTV;EuE7tTM;IAOI,mBAAA;EvEytTV;EuEhuTM;IAOI,oBAAA;EvE4tTV;EuEnuTM;IAOI,0BAAA;EvE+tTV;EuEtuTM;IAOI,yBAAA;EvEkuTV;EuEzuTM;IAOI,uBAAA;EvEquTV;EuE5uTM;IAOI,yBAAA;EvEwuTV;EuE/uTM;IAOI,uBAAA;EvE2uTV;EuElvTM;IAOI,uBAAA;EvE8uTV;EuErvTM;IAOI,0BAAA;IAAA,yBAAA;EvEkvTV;EuEzvTM;IAOI,gCAAA;IAAA,+BAAA;EvEsvTV;EuE7vTM;IAOI,+BAAA;IAAA,8BAAA;EvE0vTV;EuEjwTM;IAOI,6BAAA;IAAA,4BAAA;EvE8vTV;EuErwTM;IAOI,+BAAA;IAAA,8BAAA;EvEkwTV;EuEzwTM;IAOI,6BAAA;IAAA,4BAAA;EvEswTV;EuE7wTM;IAOI,6BAAA;IAAA,4BAAA;EvE0wTV;EuEjxTM;IAOI,wBAAA;IAAA,2BAAA;EvE8wTV;EuErxTM;IAOI,8BAAA;IAAA,iCAAA;EvEkxTV;EuEzxTM;IAOI,6BAAA;IAAA,gCAAA;EvEsxTV;EuE7xTM;IAOI,2BAAA;IAAA,8BAAA;EvE0xTV;EuEjyTM;IAOI,6BAAA;IAAA,gCAAA;EvE8xTV;EuEryTM;IAOI,2BAAA;IAAA,8BAAA;EvEkyTV;EuEzyTM;IAOI,2BAAA;IAAA,8BAAA;EvEsyTV;EuE7yTM;IAOI,wBAAA;EvEyyTV;EuEhzTM;IAOI,8BAAA;EvE4yTV;EuEnzTM;IAOI,6BAAA;EvE+yTV;EuEtzTM;IAOI,2BAAA;EvEkzTV;EuEzzTM;IAOI,6BAAA;EvEqzTV;EuE5zTM;IAOI,2BAAA;EvEwzTV;EuE/zTM;IAOI,2BAAA;EvE2zTV;EuEl0TM;IAOI,0BAAA;EvE8zTV;EuEr0TM;IAOI,gCAAA;EvEi0TV;EuEx0TM;IAOI,+BAAA;EvEo0TV;EuE30TM;IAOI,6BAAA;EvEu0TV;EuE90TM;IAOI,+BAAA;EvE00TV;EuEj1TM;IAOI,6BAAA;EvE60TV;EuEp1TM;IAOI,6BAAA;EvEg1TV;EuEv1TM;IAOI,2BAAA;EvEm1TV;EuE11TM;IAOI,iCAAA;EvEs1TV;EuE71TM;IAOI,gCAAA;EvEy1TV;EuEh2TM;IAOI,8BAAA;EvE41TV;EuEn2TM;IAOI,gCAAA;EvE+1TV;EuEt2TM;IAOI,8BAAA;EvEk2TV;EuEz2TM;IAOI,8BAAA;EvEq2TV;EuE52TM;IAOI,yBAAA;EvEw2TV;EuE/2TM;IAOI,+BAAA;EvE22TV;EuEl3TM;IAOI,8BAAA;EvE82TV;EuEr3TM;IAOI,4BAAA;EvEi3TV;EuEx3TM;IAOI,8BAAA;EvEo3TV;EuE33TM;IAOI,4BAAA;EvEu3TV;EuE93TM;IAOI,4BAAA;EvE03TV;EuEj4TM;IAOI,qBAAA;EvE63TV;EuEp4TM;IAOI,2BAAA;EvEg4TV;EuEv4TM;IAOI,0BAAA;EvEm4TV;EuE14TM;IAOI,wBAAA;EvEs4TV;EuE74TM;IAOI,0BAAA;EvEy4TV;EuEh5TM;IAOI,wBAAA;EvE44TV;EuEn5TM;IAOI,2BAAA;IAAA,0BAAA;EvEg5TV;EuEv5TM;IAOI,iCAAA;IAAA,gCAAA;EvEo5TV;EuE35TM;IAOI,gCAAA;IAAA,+BAAA;EvEw5TV;EuE/5TM;IAOI,8BAAA;IAAA,6BAAA;EvE45TV;EuEn6TM;IAOI,gCAAA;IAAA,+BAAA;EvEg6TV;EuEv6TM;IAOI,8BAAA;IAAA,6BAAA;EvEo6TV;EuE36TM;IAOI,yBAAA;IAAA,4BAAA;EvEw6TV;EuE/6TM;IAOI,+BAAA;IAAA,kCAAA;EvE46TV;EuEn7TM;IAOI,8BAAA;IAAA,iCAAA;EvEg7TV;EuEv7TM;IAOI,4BAAA;IAAA,+BAAA;EvEo7TV;EuE37TM;IAOI,8BAAA;IAAA,iCAAA;EvEw7TV;EuE/7TM;IAOI,4BAAA;IAAA,+BAAA;EvE47TV;EuEn8TM;IAOI,yBAAA;EvE+7TV;EuEt8TM;IAOI,+BAAA;EvEk8TV;EuEz8TM;IAOI,8BAAA;EvEq8TV;EuE58TM;IAOI,4BAAA;EvEw8TV;EuE/8TM;IAOI,8BAAA;EvE28TV;EuEl9TM;IAOI,4BAAA;EvE88TV;EuEr9TM;IAOI,2BAAA;EvEi9TV;EuEx9TM;IAOI,iCAAA;EvEo9TV;EuE39TM;IAOI,gCAAA;EvEu9TV;EuE99TM;IAOI,8BAAA;EvE09TV;EuEj+TM;IAOI,gCAAA;EvE69TV;EuEp+TM;IAOI,8BAAA;EvEg+TV;EuEv+TM;IAOI,4BAAA;EvEm+TV;EuE1+TM;IAOI,kCAAA;EvEs+TV;EuE7+TM;IAOI,iCAAA;EvEy+TV;EuEh/TM;IAOI,+BAAA;EvE4+TV;EuEn/TM;IAOI,iCAAA;EvE++TV;EuEt/TM;IAOI,+BAAA;EvEk/TV;EuEz/TM;IAOI,0BAAA;EvEq/TV;EuE5/TM;IAOI,gCAAA;EvEw/TV;EuE//TM;IAOI,+BAAA;EvE2/TV;EuElgUM;IAOI,6BAAA;EvE8/TV;EuErgUM;IAOI,+BAAA;EvEigUV;EuExgUM;IAOI,6BAAA;EvEogUV;EuE3gUM;IAOI,iBAAA;EvEugUV;EuE9gUM;IAOI,uBAAA;EvE0gUV;EuEjhUM;IAOI,sBAAA;EvE6gUV;EuEphUM;IAOI,oBAAA;EvEghUV;EuEvhUM;IAOI,sBAAA;EvEmhUV;EuE1hUM;IAOI,oBAAA;EvEshUV;EuE7hUM;IAOI,qBAAA;EvEyhUV;EuEhiUM;IAOI,2BAAA;EvE4hUV;EuEniUM;IAOI,0BAAA;EvE+hUV;EuEtiUM;IAOI,wBAAA;EvEkiUV;EuEziUM;IAOI,0BAAA;EvEqiUV;EuE5iUM;IAOI,wBAAA;EvEwiUV;EuE/iUM;IAOI,wBAAA;EvE2iUV;EuEljUM;IAOI,8BAAA;EvE8iUV;EuErjUM;IAOI,6BAAA;EvEijUV;EuExjUM;IAOI,2BAAA;EvEojUV;EuE3jUM;IAOI,6BAAA;EvEujUV;EuE9jUM;IAOI,2BAAA;EvE0jUV;EuEjkUM;IAOI,2BAAA;EvE6jUV;EuEpkUM;IAOI,4BAAA;EvEgkUV;EuEvkUM;IAOI,6BAAA;EvEmkUV;AACF;Aa9kUI;E0DGI;IAOI,sBAAA;EvEwkUV;EuE/kUM;IAOI,uBAAA;EvE2kUV;EuEllUM;IAOI,sBAAA;EvE8kUV;EuErlUM;IAOI,8BAAA;EvEilUV;EuExlUM;IAOI,4BAAA;EvEolUV;EuE3lUM;IAOI,2BAAA;EvEulUV;EuE9lUM;IAOI,iCAAA;EvE0lUV;EuEjmUM;IAOI,2BAAA;EvE6lUV;EuEpmUM;IAOI,0BAAA;EvEgmUV;EuEvmUM;IAOI,gCAAA;EvEmmUV;EuE1mUM;IAOI,yBAAA;EvEsmUV;EuE7mUM;IAOI,wBAAA;EvEymUV;EuEhnUM;IAOI,+BAAA;EvE4mUV;EuEnnUM;IAOI,yBAAA;EvE+mUV;EuEtnUM;IAOI,6BAAA;EvEknUV;EuEznUM;IAOI,8BAAA;EvEqnUV;EuE5nUM;IAOI,wBAAA;EvEwnUV;EuE/nUM;IAOI,+BAAA;EvE2nUV;EuEloUM;IAOI,wBAAA;EvE8nUV;EuEroUM;IAOI,yBAAA;EvEioUV;EuExoUM;IAOI,8BAAA;EvEooUV;EuE3oUM;IAOI,iCAAA;EvEuoUV;EuE9oUM;IAOI,sCAAA;EvE0oUV;EuEjpUM;IAOI,yCAAA;EvE6oUV;EuEppUM;IAOI,uBAAA;EvEgpUV;EuEvpUM;IAOI,uBAAA;EvEmpUV;EuE1pUM;IAOI,yBAAA;EvEspUV;EuE7pUM;IAOI,yBAAA;EvEypUV;EuEhqUM;IAOI,0BAAA;EvE4pUV;EuEnqUM;IAOI,4BAAA;EvE+pUV;EuEtqUM;IAOI,kCAAA;EvEkqUV;EuEzqUM;IAOI,sCAAA;EvEqqUV;EuE5qUM;IAOI,oCAAA;EvEwqUV;EuE/qUM;IAOI,kCAAA;EvE2qUV;EuElrUM;IAOI,yCAAA;EvE8qUV;EuErrUM;IAOI,wCAAA;EvEirUV;EuExrUM;IAOI,wCAAA;EvEorUV;EuE3rUM;IAOI,kCAAA;EvEurUV;EuE9rUM;IAOI,gCAAA;EvE0rUV;EuEjsUM;IAOI,8BAAA;EvE6rUV;EuEpsUM;IAOI,gCAAA;EvEgsUV;EuEvsUM;IAOI,+BAAA;EvEmsUV;EuE1sUM;IAOI,oCAAA;EvEssUV;EuE7sUM;IAOI,kCAAA;EvEysUV;EuEhtUM;IAOI,gCAAA;EvE4sUV;EuEntUM;IAOI,uCAAA;EvE+sUV;EuEttUM;IAOI,sCAAA;EvEktUV;EuEztUM;IAOI,iCAAA;EvEqtUV;EuE5tUM;IAOI,2BAAA;EvEwtUV;EuE/tUM;IAOI,iCAAA;EvE2tUV;EuEluUM;IAOI,+BAAA;EvE8tUV;EuEruUM;IAOI,6BAAA;EvEiuUV;EuExuUM;IAOI,+BAAA;EvEouUV;EuE3uUM;IAOI,8BAAA;EvEuuUV;EuE9uUM;IAOI,oBAAA;EvE0uUV;EuEjvUM;IAOI,mBAAA;EvE6uUV;EuEpvUM;IAOI,mBAAA;EvEgvUV;EuEvvUM;IAOI,mBAAA;EvEmvUV;EuE1vUM;IAOI,mBAAA;EvEsvUV;EuE7vUM;IAOI,mBAAA;EvEyvUV;EuEhwUM;IAOI,mBAAA;EvE4vUV;EuEnwUM;IAOI,mBAAA;EvE+vUV;EuEtwUM;IAOI,oBAAA;EvEkwUV;EuEzwUM;IAOI,0BAAA;EvEqwUV;EuE5wUM;IAOI,yBAAA;EvEwwUV;EuE/wUM;IAOI,uBAAA;EvE2wUV;EuElxUM;IAOI,yBAAA;EvE8wUV;EuErxUM;IAOI,uBAAA;EvEixUV;EuExxUM;IAOI,uBAAA;EvEoxUV;EuE3xUM;IAOI,0BAAA;IAAA,yBAAA;EvEwxUV;EuE/xUM;IAOI,gCAAA;IAAA,+BAAA;EvE4xUV;EuEnyUM;IAOI,+BAAA;IAAA,8BAAA;EvEgyUV;EuEvyUM;IAOI,6BAAA;IAAA,4BAAA;EvEoyUV;EuE3yUM;IAOI,+BAAA;IAAA,8BAAA;EvEwyUV;EuE/yUM;IAOI,6BAAA;IAAA,4BAAA;EvE4yUV;EuEnzUM;IAOI,6BAAA;IAAA,4BAAA;EvEgzUV;EuEvzUM;IAOI,wBAAA;IAAA,2BAAA;EvEozUV;EuE3zUM;IAOI,8BAAA;IAAA,iCAAA;EvEwzUV;EuE/zUM;IAOI,6BAAA;IAAA,gCAAA;EvE4zUV;EuEn0UM;IAOI,2BAAA;IAAA,8BAAA;EvEg0UV;EuEv0UM;IAOI,6BAAA;IAAA,gCAAA;EvEo0UV;EuE30UM;IAOI,2BAAA;IAAA,8BAAA;EvEw0UV;EuE/0UM;IAOI,2BAAA;IAAA,8BAAA;EvE40UV;EuEn1UM;IAOI,wBAAA;EvE+0UV;EuEt1UM;IAOI,8BAAA;EvEk1UV;EuEz1UM;IAOI,6BAAA;EvEq1UV;EuE51UM;IAOI,2BAAA;EvEw1UV;EuE/1UM;IAOI,6BAAA;EvE21UV;EuEl2UM;IAOI,2BAAA;EvE81UV;EuEr2UM;IAOI,2BAAA;EvEi2UV;EuEx2UM;IAOI,0BAAA;EvEo2UV;EuE32UM;IAOI,gCAAA;EvEu2UV;EuE92UM;IAOI,+BAAA;EvE02UV;EuEj3UM;IAOI,6BAAA;EvE62UV;EuEp3UM;IAOI,+BAAA;EvEg3UV;EuEv3UM;IAOI,6BAAA;EvEm3UV;EuE13UM;IAOI,6BAAA;EvEs3UV;EuE73UM;IAOI,2BAAA;EvEy3UV;EuEh4UM;IAOI,iCAAA;EvE43UV;EuEn4UM;IAOI,gCAAA;EvE+3UV;EuEt4UM;IAOI,8BAAA;EvEk4UV;EuEz4UM;IAOI,gCAAA;EvEq4UV;EuE54UM;IAOI,8BAAA;EvEw4UV;EuE/4UM;IAOI,8BAAA;EvE24UV;EuEl5UM;IAOI,yBAAA;EvE84UV;EuEr5UM;IAOI,+BAAA;EvEi5UV;EuEx5UM;IAOI,8BAAA;EvEo5UV;EuE35UM;IAOI,4BAAA;EvEu5UV;EuE95UM;IAOI,8BAAA;EvE05UV;EuEj6UM;IAOI,4BAAA;EvE65UV;EuEp6UM;IAOI,4BAAA;EvEg6UV;EuEv6UM;IAOI,qBAAA;EvEm6UV;EuE16UM;IAOI,2BAAA;EvEs6UV;EuE76UM;IAOI,0BAAA;EvEy6UV;EuEh7UM;IAOI,wBAAA;EvE46UV;EuEn7UM;IAOI,0BAAA;EvE+6UV;EuEt7UM;IAOI,wBAAA;EvEk7UV;EuEz7UM;IAOI,2BAAA;IAAA,0BAAA;EvEs7UV;EuE77UM;IAOI,iCAAA;IAAA,gCAAA;EvE07UV;EuEj8UM;IAOI,gCAAA;IAAA,+BAAA;EvE87UV;EuEr8UM;IAOI,8BAAA;IAAA,6BAAA;EvEk8UV;EuEz8UM;IAOI,gCAAA;IAAA,+BAAA;EvEs8UV;EuE78UM;IAOI,8BAAA;IAAA,6BAAA;EvE08UV;EuEj9UM;IAOI,yBAAA;IAAA,4BAAA;EvE88UV;EuEr9UM;IAOI,+BAAA;IAAA,kCAAA;EvEk9UV;EuEz9UM;IAOI,8BAAA;IAAA,iCAAA;EvEs9UV;EuE79UM;IAOI,4BAAA;IAAA,+BAAA;EvE09UV;EuEj+UM;IAOI,8BAAA;IAAA,iCAAA;EvE89UV;EuEr+UM;IAOI,4BAAA;IAAA,+BAAA;EvEk+UV;EuEz+UM;IAOI,yBAAA;EvEq+UV;EuE5+UM;IAOI,+BAAA;EvEw+UV;EuE/+UM;IAOI,8BAAA;EvE2+UV;EuEl/UM;IAOI,4BAAA;EvE8+UV;EuEr/UM;IAOI,8BAAA;EvEi/UV;EuEx/UM;IAOI,4BAAA;EvEo/UV;EuE3/UM;IAOI,2BAAA;EvEu/UV;EuE9/UM;IAOI,iCAAA;EvE0/UV;EuEjgVM;IAOI,gCAAA;EvE6/UV;EuEpgVM;IAOI,8BAAA;EvEggVV;EuEvgVM;IAOI,gCAAA;EvEmgVV;EuE1gVM;IAOI,8BAAA;EvEsgVV;EuE7gVM;IAOI,4BAAA;EvEygVV;EuEhhVM;IAOI,kCAAA;EvE4gVV;EuEnhVM;IAOI,iCAAA;EvE+gVV;EuEthVM;IAOI,+BAAA;EvEkhVV;EuEzhVM;IAOI,iCAAA;EvEqhVV;EuE5hVM;IAOI,+BAAA;EvEwhVV;EuE/hVM;IAOI,0BAAA;EvE2hVV;EuEliVM;IAOI,gCAAA;EvE8hVV;EuEriVM;IAOI,+BAAA;EvEiiVV;EuExiVM;IAOI,6BAAA;EvEoiVV;EuE3iVM;IAOI,+BAAA;EvEuiVV;EuE9iVM;IAOI,6BAAA;EvE0iVV;EuEjjVM;IAOI,iBAAA;EvE6iVV;EuEpjVM;IAOI,uBAAA;EvEgjVV;EuEvjVM;IAOI,sBAAA;EvEmjVV;EuE1jVM;IAOI,oBAAA;EvEsjVV;EuE7jVM;IAOI,sBAAA;EvEyjVV;EuEhkVM;IAOI,oBAAA;EvE4jVV;EuEnkVM;IAOI,qBAAA;EvE+jVV;EuEtkVM;IAOI,2BAAA;EvEkkVV;EuEzkVM;IAOI,0BAAA;EvEqkVV;EuE5kVM;IAOI,wBAAA;EvEwkVV;EuE/kVM;IAOI,0BAAA;EvE2kVV;EuEllVM;IAOI,wBAAA;EvE8kVV;EuErlVM;IAOI,wBAAA;EvEilVV;EuExlVM;IAOI,8BAAA;EvEolVV;EuE3lVM;IAOI,6BAAA;EvEulVV;EuE9lVM;IAOI,2BAAA;EvE0lVV;EuEjmVM;IAOI,6BAAA;EvE6lVV;EuEpmVM;IAOI,2BAAA;EvEgmVV;EuEvmVM;IAOI,2BAAA;EvEmmVV;EuE1mVM;IAOI,4BAAA;EvEsmVV;EuE7mVM;IAOI,6BAAA;EvEymVV;AACF;AwEhqVA;ED+CQ;IAOI,4BAAA;EvE8mVV;EuErnVM;IAOI,0BAAA;EvEinVV;EuExnVM;IAOI,6BAAA;EvEonVV;EuE3nVM;IAOI,4BAAA;EvEunVV;AACF;AwE3pVA;ED4BQ;IAOI,0BAAA;EvE4nVV;EuEnoVM;IAOI,gCAAA;EvE+nVV;EuEtoVM;IAOI,yBAAA;EvEkoVV;EuEzoVM;IAOI,wBAAA;EvEqoVV;EuE5oVM;IAOI,+BAAA;EvEwoVV;EuE/oVM;IAOI,yBAAA;EvE2oVV;EuElpVM;IAOI,6BAAA;EvE8oVV;EuErpVM;IAOI,8BAAA;EvEipVV;EuExpVM;IAOI,wBAAA;EvEopVV;EuE3pVM;IAOI,+BAAA;EvEupVV;EuE9pVM;IAOI,wBAAA;EvE0pVV;AACF","sourcesContent":["// 1. Import Bootstrap configuration globally (creates variables on the true :root)\n@import '../node_modules/bootstrap/scss/functions';\n@import '../node_modules/bootstrap/scss/variables';\n@import '../node_modules/bootstrap/scss/variables-dark';\n@import '../node_modules/bootstrap/scss/maps';\n@import '../node_modules/bootstrap/scss/mixins';\n@import '../node_modules/bootstrap/scss/root'; // This initializes --bs-border-width, etc.\n\n// 2. Scope the actual layout and component classes strictly inside your React app containers\n.build-with-bootstrap {\n\n    @import \"../node_modules/bootstrap/scss/mixins/banner\";\n    @import \"../node_modules/bootstrap/scss/reboot\";\n    @import \"../node_modules/bootstrap/scss/utilities\";\n    @import \"../node_modules/bootstrap/scss/type\";\n    @import \"../node_modules/bootstrap/scss/images\";\n    @import \"../node_modules/bootstrap/scss/containers\";\n    @import \"../node_modules/bootstrap/scss/grid\";\n    @import \"../node_modules/bootstrap/scss/tables\";\n    @import \"../node_modules/bootstrap/scss/forms\";\n    @import \"../node_modules/bootstrap/scss/buttons\";\n    @import \"../node_modules/bootstrap/scss/transitions\";\n    @import \"../node_modules/bootstrap/scss/dropdown\";\n    @import \"../node_modules/bootstrap/scss/button-group\";\n    @import \"../node_modules/bootstrap/scss/nav\";\n    @import \"../node_modules/bootstrap/scss/navbar\";\n    @import \"../node_modules/bootstrap/scss/card\";\n    @import \"../node_modules/bootstrap/scss/accordion\";\n    @import \"../node_modules/bootstrap/scss/breadcrumb\";\n    @import \"../node_modules/bootstrap/scss/pagination\";\n    @import \"../node_modules/bootstrap/scss/badge\";\n    @import \"../node_modules/bootstrap/scss/alert\";\n    @import \"../node_modules/bootstrap/scss/progress\";\n    @import \"../node_modules/bootstrap/scss/list-group\";\n    @import \"../node_modules/bootstrap/scss/close\";\n    @import \"../node_modules/bootstrap/scss/toasts\";\n    @import \"../node_modules/bootstrap/scss/modal\";\n    @import \"../node_modules/bootstrap/scss/tooltip\";\n    @import \"../node_modules/bootstrap/scss/popover\";\n    @import \"../node_modules/bootstrap/scss/carousel\";\n    @import \"../node_modules/bootstrap/scss/spinners\";\n    @import \"../node_modules/bootstrap/scss/offcanvas\";\n    @import \"../node_modules/bootstrap/scss/placeholders\";\n\n    // Helpers\n    @import \"../node_modules/bootstrap/scss/helpers\";\n\n    // Utilities\n    @import \"../node_modules/bootstrap/scss/utilities/api\";\n    // scss-docs-end import-stack\n}",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
